var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8454 64.1508L55.3331 55.8049C55.2635 55.6402 55.1082 55.5127 54.939 55.4802L42.2437 53.0446C42.188 53.033 42.1324 53.0353 42.0791 53.0446L29.5368 55.7098C29.4789 55.7214 29.4163 55.7214 29.3583 55.7098L16.9644 52.924C16.9088 52.9124 16.8508 52.9101 16.7929 52.9217L4.10456 55.4036C3.93532 55.4361 3.77999 55.5637 3.71044 55.7307L0.151776 64.276C0.0103564 64.6193 0.223644 64.9255 0.557486 64.8536L14.7527 61.8521C14.8107 61.8405 14.871 61.8405 14.9266 61.8521L29.3861 64.9835C29.4464 64.9974 29.509 64.9951 29.5693 64.9835L43.8155 61.7129C43.8735 61.699 43.9338 61.699 43.994 61.7129L58.4397 64.7284C58.7758 64.7979 58.9891 64.4918 58.8454 64.1508Z",
    fill: "#F6F8FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8427 64.138L55.3304 55.7944C55.2608 55.6297 55.1055 55.5022 54.9363 55.4697L42.2433 53.0364C42.1877 53.0248 42.132 53.0272 42.0787 53.0364L29.5365 55.7016C29.4785 55.7132 29.4159 55.7132 29.358 55.7016L16.9664 52.9181C16.9107 52.9066 16.8528 52.9042 16.7948 52.9158L4.10651 55.3978C3.93727 55.4303 3.78194 55.5578 3.71239 55.7225L0.153729 64.2655C0.0123095 64.6065 0.225597 64.915 0.559439 64.8431L14.7524 61.8416C14.8103 61.83 14.8706 61.83 14.9262 61.8416L29.3858 64.973C29.446 64.9869 29.5086 64.9846 29.5689 64.973L43.8128 61.7024C43.8708 61.6885 43.9311 61.6885 43.9914 61.7024L58.437 64.7179C58.7731 64.7851 58.9864 64.4789 58.8427 64.138Z",
    fill: "#F7F9FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.84 64.1266L55.3277 55.7831C55.2581 55.6184 55.1028 55.4908 54.9336 55.4583L42.2406 53.0251C42.185 53.0135 42.1294 53.0158 42.076 53.0251L29.5361 55.688C29.4781 55.6996 29.4155 55.6996 29.3576 55.688L16.966 52.9045C16.9104 52.8929 16.8524 52.8906 16.7945 52.9022L4.10846 55.3841C3.93922 55.4166 3.78389 55.5442 3.71434 55.7089L0.155682 64.2519C0.0142626 64.5928 0.227551 64.9014 0.561392 64.8294L14.7543 61.8302C14.8123 61.8186 14.8725 61.8186 14.9282 61.8302L29.3854 64.9617C29.4457 64.9756 29.5083 64.9733 29.5685 64.9617L43.8125 61.6934C43.8704 61.6795 43.9307 61.6795 43.991 61.6934L58.4343 64.7088C58.7704 64.7738 58.9837 64.4676 58.84 64.1266Z",
    fill: "#F8FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4114 55.8434L56.1123 62.9297C56.198 63.1547 56.0497 63.3542 55.8294 63.3078L43.7091 60.7887L42.2578 53.5215L53.1425 55.6137C53.2607 55.6393 53.3673 55.7274 53.4114 55.8434Z",
    fill: "url(#paint0_linear_19952_150379)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4473 56.2818V63.8668L43.7097 60.7911L42.2584 53.5215L29.4473 56.2818Z",
    fill: "url(#paint1_linear_19952_150379)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48446 55.8434L2.77663 62.9297C2.69085 63.1547 2.83922 63.3542 3.05947 63.3078L15.1821 60.7887L16.6403 53.5215L5.75339 55.6137C5.63515 55.6393 5.52851 55.7274 5.48446 55.8434Z",
    fill: "url(#paint2_linear_19952_150379)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4464 56.2818V63.8668L15.1816 60.7911L16.6399 53.5215L29.4464 56.2818Z",
    fill: "url(#paint3_linear_19952_150379)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5136 18.8054C17.5136 13.0807 21.9787 8.4392 27.4848 8.4392C32.9932 8.4392 37.456 13.0807 37.456 18.8054C37.456 24.5301 32.9909 29.1716 27.4848 29.1716C21.9787 29.1716 17.5136 24.5301 17.5136 18.8054ZM9.87695 18.8054C9.87695 30.51 24.1278 46.2809 26.9887 49.3288C27.2599 49.6187 27.7097 49.6187 27.9832 49.3311C30.8487 46.2948 45.095 30.6028 45.095 18.8077C45.095 8.69899 37.2103 0.503906 27.4871 0.503906C17.764 0.503906 9.87695 8.69667 9.87695 18.8054Z",
    fill: "url(#paint4_radial_19952_150379)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5253 18.8058C17.5253 13.081 21.9904 8.43956 27.4965 8.43956C33.0026 8.43956 37.4677 13.081 37.4677 18.8058C37.4677 24.5305 33.0026 29.172 27.4965 29.172C21.9904 29.172 17.5253 24.5305 17.5253 18.8058ZM9.88867 18.8058C9.88867 30.5104 24.1396 46.2812 27.0004 49.3292C27.2716 49.6191 27.7214 49.6191 27.995 49.3315C30.8604 46.2952 45.1044 30.6009 45.1044 18.8058C45.1044 8.69704 37.2197 0.501953 27.4965 0.501953C17.7734 0.501953 9.88867 8.69704 9.88867 18.8058Z",
    fill: "url(#paint5_radial_19952_150379)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5351 18.8058C17.5351 13.081 22.0002 8.43956 27.5063 8.43956C33.0124 8.43956 37.4775 13.081 37.4775 18.8058C37.4775 24.5305 33.0124 29.172 27.5063 29.172C22.0002 29.172 17.5351 24.5305 17.5351 18.8058ZM9.89844 18.8058C9.89844 30.5104 24.1493 46.2836 27.0102 49.3315C27.2814 49.6214 27.7312 49.6214 28.0047 49.3338C30.8702 46.2975 45.1141 30.6009 45.1141 18.8058C45.1141 8.69704 37.2318 0.501953 27.5063 0.501953C17.7808 0.501953 9.89844 8.69704 9.89844 18.8058Z",
    fill: "url(#paint6_radial_19952_150379)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5468 18.8054C17.5468 13.0807 22.0119 8.4392 27.518 8.4392C33.0241 8.4392 37.4892 13.0807 37.4892 18.8054C37.4892 24.5301 33.0241 29.1716 27.518 29.1716C22.0119 29.1716 17.5468 24.5301 17.5468 18.8054ZM9.91016 18.8054C9.91016 30.51 24.1587 46.2832 27.0219 49.3334C27.2931 49.6234 27.7429 49.6234 28.0164 49.3358C30.8819 46.2994 45.1259 30.6005 45.1259 18.8077C45.1259 8.69899 37.2435 0.503906 27.518 0.503906C17.7925 0.503906 9.91016 8.69667 9.91016 18.8054Z",
    fill: "url(#paint7_radial_19952_150379)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5546 18.8054C17.5546 13.0807 22.0197 8.4392 27.5258 8.4392C33.0319 8.4392 37.497 13.0807 37.497 18.8054C37.497 24.5301 33.0319 29.1716 27.5258 29.1716C22.0197 29.1716 17.5546 24.5301 17.5546 18.8054ZM9.91797 18.8054C9.91797 30.51 24.1665 46.2855 27.0274 49.3358C27.2986 49.6257 27.7484 49.6257 28.0219 49.3381C30.8874 46.2994 45.1313 30.6005 45.1313 18.8077C45.1313 8.69899 37.249 0.503906 27.5235 0.503906C17.798 0.503906 9.91797 8.69667 9.91797 18.8054Z",
    fill: "url(#paint8_radial_19952_150379)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5663 18.8058C17.5663 13.081 22.0315 8.43956 27.5375 8.43956C33.0436 8.43956 37.5087 13.081 37.5087 18.8058C37.5087 24.5305 33.0436 29.172 27.5375 29.172C22.0315 29.172 17.5663 24.5305 17.5663 18.8058ZM9.92969 18.8058C9.92969 30.5104 24.1782 46.2859 27.0391 49.3361C27.3103 49.6261 27.7601 49.6261 28.0337 49.3384C30.8991 46.2998 45.1407 30.5985 45.1407 18.8058C45.1407 8.69704 37.2584 0.501953 27.5352 0.501953C17.8121 0.501953 9.92969 8.69704 9.92969 18.8058Z",
    fill: "url(#paint9_radial_19952_150379)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5757 18.8058C17.5757 13.081 22.0385 8.43956 27.5469 8.43956C33.053 8.43956 37.5181 13.081 37.5181 18.8058C37.5181 24.5305 33.0553 29.172 27.5469 29.172C22.0385 29.172 17.5757 24.5305 17.5757 18.8058ZM9.94141 18.8058C9.94141 30.5104 24.19 46.2882 27.0508 49.3384C27.3221 49.6284 27.7741 49.6284 28.0454 49.3408C30.9109 46.3021 45.1525 30.6009 45.1525 18.8058C45.1525 8.69704 37.2701 0.501953 27.5469 0.501953C17.8238 0.504273 9.94141 8.69704 9.94141 18.8058Z",
    fill: "url(#paint10_radial_19952_150379)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5855 18.8054C17.5855 13.0807 22.0483 8.4392 27.5567 8.4392C33.0628 8.4392 37.5279 13.0807 37.5279 18.8054C37.5279 24.5301 33.0651 29.1716 27.5567 29.1716C22.0506 29.1716 17.5855 24.5301 17.5855 18.8054ZM9.95117 18.8054C9.95117 30.5123 24.1974 46.2901 27.0606 49.3404C27.3318 49.6303 27.7839 49.6303 28.0551 49.3427C30.9206 46.3041 45.1622 30.6005 45.1622 18.8077C45.1622 8.69899 37.2799 0.503906 27.5567 0.503906C17.8336 0.503906 9.95117 8.69667 9.95117 18.8054Z",
    fill: "url(#paint11_radial_19952_150379)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5972 18.8058C17.5972 13.081 22.06 8.43956 27.5661 8.43956C33.0722 8.43956 37.535 13.081 37.535 18.8058C37.535 24.5305 33.0722 29.172 27.5661 29.172C22.06 29.172 17.5972 24.5305 17.5972 18.8058ZM9.96289 18.8058C9.96289 30.5127 24.2091 46.2905 27.07 49.3408C27.3412 49.6307 27.7933 49.6307 28.0645 49.3431C30.93 46.3044 45.1716 30.5985 45.1716 18.8058C45.1716 8.69704 37.2892 0.501953 27.5661 0.501953C17.843 0.504273 9.96289 8.69704 9.96289 18.8058Z",
    fill: "url(#paint12_radial_19952_150379)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.607 18.8058C17.607 13.081 22.0698 8.43956 27.5759 8.43956C33.0819 8.43956 37.5448 13.081 37.5448 18.8058C37.5448 24.5305 33.0819 29.172 27.5759 29.172C22.0721 29.172 17.607 24.5305 17.607 18.8058ZM9.97266 18.8058C9.97266 30.5127 24.2189 46.2928 27.0797 49.3431C27.351 49.633 27.8031 49.633 28.0743 49.3454C30.9398 46.3044 45.1814 30.5985 45.1814 18.8058C45.1814 8.69704 37.299 0.501953 27.5782 0.501953C17.8574 0.501953 9.97266 8.69704 9.97266 18.8058Z",
    fill: "url(#paint13_radial_19952_150379)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6187 18.8058C17.6187 13.081 22.0815 8.43956 27.5876 8.43956C33.0937 8.43956 37.5565 13.081 37.5565 18.8058C37.5565 24.5305 33.0937 29.172 27.5876 29.172C22.0815 29.172 17.6187 24.5305 17.6187 18.8058ZM9.98438 18.8058C9.98438 30.5127 24.2306 46.2928 27.0915 49.3454C27.3627 49.6353 27.8148 49.6353 28.086 49.3477C30.9515 46.3067 45.1908 30.5985 45.1908 18.8058C45.1908 8.69704 37.3084 0.501953 27.5876 0.501953C17.8668 0.501953 9.98438 8.69704 9.98438 18.8058Z",
    fill: "url(#paint14_radial_19952_150379)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6265 18.8054C17.6265 13.0807 22.0893 8.4392 27.5954 8.4392C33.1015 8.4392 37.5643 13.0807 37.5643 18.8054C37.5643 24.5301 33.1015 29.1716 27.5954 29.1716C22.0893 29.1716 17.6265 24.5301 17.6265 18.8054ZM9.99219 18.8054C9.99219 30.5123 24.2361 46.2948 27.0993 49.3473C27.3705 49.6373 27.8226 49.6373 28.0938 49.3497C30.9593 46.3087 45.1986 30.5982 45.1986 18.8077C45.1986 8.69899 37.3162 0.503906 27.5954 0.503906C17.8746 0.503906 9.99219 8.69667 9.99219 18.8054Z",
    fill: "url(#paint15_radial_19952_150379)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6382 18.8058C17.6382 13.081 22.101 8.43956 27.6071 8.43956C33.1132 8.43956 37.576 13.081 37.576 18.8058C37.576 24.5305 33.1132 29.172 27.6071 29.172C22.101 29.172 17.6382 24.5305 17.6382 18.8058ZM10.0039 18.8058C10.0039 30.5127 24.2478 46.2951 27.1087 49.3477C27.3799 49.6377 27.832 49.6377 28.1032 49.35C30.9687 46.3091 45.208 30.5962 45.208 18.8058C45.208 8.69704 37.3279 0.501953 27.6048 0.501953C17.8816 0.501953 10.0039 8.69704 10.0039 18.8058Z",
    fill: "url(#paint16_radial_19952_150379)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.648 18.8058C17.648 13.081 22.1108 8.43956 27.6169 8.43956C33.123 8.43956 37.5858 13.081 37.5858 18.8058C37.5858 24.5305 33.123 29.172 27.6169 29.172C22.1108 29.172 17.648 24.5305 17.648 18.8058ZM10.0137 18.8058C10.0137 30.5127 24.2576 46.2975 27.1184 49.35C27.3897 49.64 27.8418 49.64 28.113 49.3524C30.9785 46.3114 45.2178 30.5962 45.2178 18.8058C45.2178 8.69704 37.3377 0.501953 27.6146 0.501953C17.8914 0.501953 10.0137 8.69704 10.0137 18.8058Z",
    fill: "url(#paint17_radial_19952_150379)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6597 18.8054C17.6597 13.0807 22.1225 8.4392 27.6286 8.4392C33.1347 8.4392 37.5975 13.0807 37.5975 18.8054C37.5975 24.5301 33.1347 29.1716 27.6286 29.1716C22.1225 29.1716 17.6597 24.5301 17.6597 18.8054ZM10.0254 18.8054C10.0254 30.5123 24.2693 46.2994 27.1302 49.352C27.4014 49.6419 27.8535 49.6443 28.1247 49.3543C30.9902 46.311 45.2272 30.5958 45.2272 18.8077C45.2272 8.69899 37.3471 0.503906 27.6263 0.503906C17.9055 0.503906 10.0254 8.69667 10.0254 18.8054Z",
    fill: "url(#paint18_radial_19952_150379)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6695 18.8054C17.6695 13.0807 22.1323 8.4392 27.6384 8.4392C33.1444 8.4392 37.6073 13.0807 37.6073 18.8054C37.6073 24.5301 33.1444 29.1716 27.6384 29.1716C22.1323 29.1716 17.6695 24.5301 17.6695 18.8054ZM10.0352 18.8054C10.0352 30.5123 24.2768 46.2994 27.1399 49.3543C27.4112 49.6443 27.8632 49.6466 28.1345 49.3566C31 46.3133 45.2369 30.5982 45.2369 18.8077C45.2369 8.69899 37.3569 0.503906 27.636 0.503906C17.9152 0.503906 10.0352 8.69667 10.0352 18.8054Z",
    fill: "url(#paint19_radial_19952_150379)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6812 18.8058C17.6812 13.081 22.144 8.43956 27.6478 8.43956C33.1538 8.43956 37.6143 13.081 37.6143 18.8058C37.6143 24.5305 33.1515 29.172 27.6478 29.172C22.1417 29.172 17.6812 24.5305 17.6812 18.8058ZM10.0469 18.8058C10.0469 30.515 24.2885 46.3021 27.1493 49.3547C27.4206 49.6446 27.8726 49.6469 28.1462 49.357C31.0117 46.3137 45.2486 30.5962 45.2486 18.8058C45.2486 8.69704 37.3686 0.501953 27.6478 0.501953C17.9269 0.501953 10.0469 8.69704 10.0469 18.8058Z",
    fill: "url(#paint20_radial_19952_150379)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6906 18.8058C17.6906 13.081 22.1534 8.43956 27.6572 8.43956C33.1609 8.43956 37.6237 13.081 37.6237 18.8058C37.6237 24.5305 33.1609 29.172 27.6572 29.172C22.1534 29.172 17.6906 24.5305 17.6906 18.8058ZM10.0586 18.8058C10.0586 30.515 24.3002 46.3021 27.161 49.357C27.4323 49.6469 27.8844 49.6493 28.1579 49.3593C31.0234 46.316 45.2604 30.5962 45.2604 18.8058C45.2604 8.69704 37.3803 0.501953 27.6595 0.501953C17.9387 0.501953 10.0586 8.69704 10.0586 18.8058Z",
    fill: "url(#paint21_radial_19952_150379)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6984 18.8054C17.6984 13.0807 22.1612 8.4392 27.665 8.4392C33.1687 8.4392 37.6315 13.0807 37.6315 18.8054C37.6315 24.5301 33.1687 29.1716 27.665 29.1716C22.1612 29.1716 17.6984 24.5301 17.6984 18.8054ZM10.0664 18.8054C10.0664 30.5147 24.308 46.3041 27.1688 49.3589C27.4401 49.6489 27.8922 49.6512 28.1657 49.3613C31.0312 46.318 45.2659 30.5958 45.2659 18.8077C45.2659 8.69899 37.3858 0.503906 27.6673 0.503906C17.9488 0.503906 10.0664 8.69667 10.0664 18.8054Z",
    fill: "url(#paint22_radial_19952_150379)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7101 18.8058C17.7101 13.081 22.1729 8.43956 27.6767 8.43956C33.1805 8.43956 37.6433 13.081 37.6433 18.8058C37.6433 24.5305 33.1805 29.172 27.6767 29.172C22.1729 29.172 17.7101 24.5305 17.7101 18.8058ZM10.0781 18.8058C10.0781 30.515 24.3174 46.3044 27.1806 49.3616C27.4518 49.6516 27.9039 49.6539 28.1775 49.3616C31.0429 46.316 45.2776 30.5939 45.2776 18.8058C45.2776 8.69704 37.3975 0.501953 27.679 0.501953C17.9605 0.501953 10.0781 8.69704 10.0781 18.8058Z",
    fill: "url(#paint23_radial_19952_150379)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7199 18.8061C17.7199 13.0814 22.1827 8.43993 27.6865 8.43993C33.1902 8.43993 37.653 13.0814 37.653 18.8061C37.653 24.5309 33.1902 29.1724 27.6865 29.1724C22.1827 29.1724 17.7199 24.5309 17.7199 18.8061ZM10.0879 18.8061C10.0879 30.5154 24.3272 46.3071 27.188 49.362C27.4593 49.6519 27.9113 49.6543 28.1849 49.362C31.0504 46.3164 45.285 30.5919 45.285 18.8038C45.285 8.69508 37.405 0.5 27.6865 0.5C17.9679 0.5 10.0879 8.6974 10.0879 18.8061Z",
    fill: "url(#paint24_radial_19952_150379)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7316 18.8061C17.7316 13.0814 22.1944 8.43993 27.6982 8.43993C33.2019 8.43993 37.6648 13.0814 37.6648 18.8061C37.6648 24.5309 33.2019 29.1724 27.6982 29.1724C22.1921 29.1724 17.7316 24.5309 17.7316 18.8061ZM10.0996 18.8061C10.0996 30.5154 24.3389 46.3094 27.1997 49.3643C27.471 49.6543 27.9231 49.6566 28.1966 49.3643C31.0621 46.3187 45.2968 30.5919 45.2968 18.8038C45.2968 8.69508 37.4167 0.5 27.6982 0.5C17.9797 0.5 10.0996 8.6974 10.0996 18.8061Z",
    fill: "url(#paint25_radial_19952_150379)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7414 18.8058C17.7414 13.081 22.2042 8.43956 27.708 8.43956C33.2117 8.43956 37.6745 13.081 37.6745 18.8058C37.6745 24.5305 33.2117 29.172 27.708 29.172C22.2042 29.172 17.7414 24.5305 17.7414 18.8058ZM10.1094 18.8058C10.1094 30.515 24.3487 46.3091 27.2095 49.3663C27.4808 49.6562 27.9328 49.6585 28.2064 49.3663C31.0719 46.3207 45.3042 30.5916 45.3042 18.8058C45.3042 8.69704 37.4265 0.501953 27.7056 0.501953C17.9848 0.501953 10.1094 8.69704 10.1094 18.8058Z",
    fill: "url(#paint26_radial_19952_150379)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7531 18.8058C17.7531 13.081 22.2159 8.43956 27.7197 8.43956C33.2234 8.43956 37.6862 13.081 37.6862 18.8058C37.6862 24.5305 33.2234 29.172 27.7197 29.172C22.2159 29.172 17.7531 24.5305 17.7531 18.8058ZM10.1211 18.8058C10.1211 30.515 24.3581 46.3114 27.2212 49.3686C27.4925 49.6585 27.9445 49.6609 28.2181 49.3686C31.0836 46.323 45.3159 30.5916 45.3159 18.8058C45.3159 8.69704 37.4382 0.501953 27.7197 0.501953C18.0012 0.501953 10.1211 8.69704 10.1211 18.8058Z",
    fill: "url(#paint27_radial_19952_150379)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7609 18.8058C17.7609 13.081 22.2214 8.43956 27.7252 8.43956C33.2289 8.43956 37.6894 13.081 37.6894 18.8058C37.6894 24.5305 33.2289 29.172 27.7252 29.172C22.2214 29.172 17.7609 24.5305 17.7609 18.8058ZM10.1289 18.8058C10.1289 30.515 24.3659 46.3114 27.229 49.3686C27.5003 49.6585 27.9524 49.6609 28.2259 49.3686C31.0891 46.323 45.3237 30.5916 45.3237 18.8058C45.3237 8.69704 37.446 0.501953 27.7275 0.501953C18.009 0.501953 10.1289 8.69704 10.1289 18.8058Z",
    fill: "url(#paint28_radial_19952_150379)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7726 18.8061C17.7726 13.0814 22.2331 8.43993 27.7369 8.43993C33.2406 8.43993 37.7011 13.0814 37.7011 18.8061C37.7011 24.5309 33.2406 29.1724 27.7369 29.1724C22.2331 29.1724 17.7726 24.5309 17.7726 18.8061ZM10.1406 18.8061C10.1406 30.5154 24.3776 46.3141 27.2384 49.3713C27.512 49.6612 27.9618 49.6635 28.2353 49.3713C31.1008 46.3233 45.3331 30.5919 45.3331 18.8038C45.3331 8.69508 37.4554 0.5 27.7369 0.5C18.0184 0.5 10.1406 8.6974 10.1406 18.8061Z",
    fill: "url(#paint29_radial_19952_150379)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7824 18.8058C17.7824 13.081 22.2429 8.43956 27.7466 8.43956C33.2504 8.43956 37.7109 13.081 37.7109 18.8058C37.7109 24.5305 33.2504 29.172 27.7466 29.172C22.2429 29.172 17.7824 24.5305 17.7824 18.8058ZM10.1504 18.8058C10.1504 30.5173 24.3874 46.3137 27.2482 49.3732C27.5218 49.6632 27.9715 49.6655 28.2451 49.3732C31.1106 46.3253 45.3429 30.5916 45.3429 18.8058C45.3429 8.69704 37.4652 0.501953 27.7466 0.501953C18.0281 0.501953 10.1504 8.69704 10.1504 18.8058Z",
    fill: "url(#paint30_radial_19952_150379)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7918 18.8058C17.7918 13.081 22.2523 8.43956 27.756 8.43956C33.2598 8.43956 37.7203 13.081 37.7203 18.8058C37.7203 24.5305 33.2598 29.172 27.756 29.172C22.2546 29.172 17.7918 24.5305 17.7918 18.8058ZM10.1621 18.8058C10.1621 30.5173 24.3968 46.316 27.2599 49.3755C27.5335 49.6678 27.9832 49.6678 28.2568 49.3755C31.1223 46.3276 45.3523 30.5916 45.3523 18.8058C45.3523 8.69704 37.4746 0.501953 27.7584 0.501953C18.0422 0.501953 10.1621 8.69704 10.1621 18.8058Z",
    fill: "url(#paint31_radial_19952_150379)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8035 18.8061C17.8035 13.0814 22.264 8.43993 27.7678 8.43993C33.2715 8.43993 37.732 13.0814 37.732 18.8061C37.732 24.5309 33.2715 29.1724 27.7678 29.1724C22.264 29.1724 17.8035 24.5309 17.8035 18.8061ZM10.1738 18.8061C10.1738 30.5177 24.4085 46.3187 27.2716 49.3759C27.5452 49.6682 27.995 49.6682 28.2685 49.3759C31.134 46.328 45.364 30.5896 45.364 18.8038C45.364 8.69508 37.4863 0.5 27.7701 0.5C18.0539 0.5 10.1738 8.6974 10.1738 18.8061Z",
    fill: "url(#paint32_radial_19952_150379)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8133 18.8058C17.8133 13.081 22.2738 8.43956 27.7775 8.43956C33.2813 8.43956 37.7418 13.081 37.7418 18.8058C37.7418 24.5305 33.2813 29.172 27.7775 29.172C22.2761 29.172 17.8133 24.5305 17.8133 18.8058ZM10.1836 18.8058C10.1836 30.5173 24.4182 46.3183 27.2791 49.3779C27.5527 49.6701 28.0024 49.6701 28.276 49.3779C31.1415 46.3276 45.3715 30.5893 45.3715 18.8058C45.3715 8.69704 37.4937 0.501953 27.7775 0.501953C18.0613 0.504273 10.1836 8.69704 10.1836 18.8058Z",
    fill: "url(#paint33_radial_19952_150379)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.825 18.8058C17.825 13.081 22.2855 8.43956 27.7892 8.43956C33.293 8.43956 37.7535 13.081 37.7535 18.8058C37.7535 24.5305 33.293 29.172 27.7892 29.172C22.2855 29.172 17.825 24.5305 17.825 18.8058ZM10.1953 18.8058C10.1953 30.5173 24.43 46.3207 27.2908 49.3802C27.5644 49.6725 28.0141 49.6725 28.2877 49.3802C31.1532 46.3299 45.3832 30.5893 45.3832 18.8058C45.3832 8.69704 37.5054 0.501953 27.7892 0.501953C18.0731 0.501953 10.1953 8.69704 10.1953 18.8058Z",
    fill: "url(#paint34_radial_19952_150379)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8328 18.8061C17.8328 13.0814 22.2933 8.43993 27.7971 8.43993C33.2985 8.43993 37.7613 13.0814 37.7613 18.8061C37.7613 24.5309 33.3008 29.1724 27.7971 29.1724C22.2933 29.1724 17.8328 24.5309 17.8328 18.8061ZM10.2031 18.8061C10.2031 30.5177 24.4355 46.321 27.2986 49.3806C27.5722 49.6728 28.0219 49.6728 28.2955 49.3806C31.161 46.3303 45.3887 30.5873 45.3887 18.8038C45.3887 8.69508 37.5109 0.5 27.7947 0.5C18.0785 0.5 10.2031 8.6974 10.2031 18.8061Z",
    fill: "url(#paint35_radial_19952_150379)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8445 18.8061C17.8445 13.0814 22.305 8.43993 27.8065 8.43993C33.3079 8.43993 37.7684 13.0814 37.7684 18.8061C37.7684 24.5309 33.3079 29.1724 27.8065 29.1724C22.305 29.1724 17.8445 24.5309 17.8445 18.8061ZM10.2148 18.8061C10.2148 30.5177 24.4472 46.3233 27.3103 49.3829C27.5839 49.6751 28.0337 49.6751 28.3072 49.3829C31.1727 46.3326 45.4004 30.5873 45.4004 18.8038C45.4004 8.69508 37.525 0.5 27.8088 0.5C18.0926 0.5 10.2148 8.6974 10.2148 18.8061Z",
    fill: "url(#paint36_radial_19952_150379)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8543 18.8058C17.8543 13.081 22.3148 8.43956 27.8162 8.43956C33.3177 8.43956 37.7782 13.081 37.7782 18.8058C37.7782 24.5305 33.3177 29.172 27.8162 29.172C22.3148 29.172 17.8543 24.5305 17.8543 18.8058ZM10.2246 18.8058C10.2246 30.5173 24.4569 46.3253 27.3178 49.3848C27.5913 49.6771 28.0411 49.6771 28.3147 49.3848C31.1801 46.3346 45.4078 30.5893 45.4078 18.8058C45.4078 8.69704 37.5324 0.501953 27.8162 0.501953C18.1 0.501953 10.2246 8.69704 10.2246 18.8058Z",
    fill: "url(#paint37_radial_19952_150379)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.866 18.8058C17.866 13.081 22.3265 8.43956 27.8279 8.43956C33.3294 8.43956 37.7899 13.081 37.7899 18.8058C37.7899 24.5305 33.3294 29.172 27.8279 29.172C22.3265 29.172 17.866 24.5305 17.866 18.8058ZM10.2363 18.8058C10.2363 30.5173 24.4687 46.3253 27.3295 49.3871C27.6031 49.6794 28.0528 49.6794 28.3264 49.3871C31.1919 46.3346 45.4196 30.5893 45.4196 18.8058C45.4196 8.69704 37.5441 0.501953 27.8279 0.501953C18.1118 0.501953 10.2363 8.69704 10.2363 18.8058Z",
    fill: "url(#paint38_radial_19952_150379)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8758 18.8061C17.8758 13.0814 22.3363 8.43993 27.8377 8.43993C33.3391 8.43993 37.7996 13.0814 37.7996 18.8061C37.7996 24.5309 33.3391 29.1724 27.8377 29.1724C22.3363 29.1724 17.8758 24.5309 17.8758 18.8061ZM10.2461 18.8061C10.2461 30.5177 24.4761 46.328 27.3393 49.3875C27.6128 49.6798 28.0626 49.6798 28.3362 49.3875C31.2016 46.3349 45.427 30.5873 45.427 18.8038C45.427 8.69508 37.5516 0.5 27.8354 0.5C18.1192 0.5 10.2461 8.6974 10.2461 18.8061Z",
    fill: "url(#paint39_radial_19952_150379)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8875 18.8061C17.8875 13.0814 22.348 8.43993 27.8494 8.43993C33.3509 8.43993 37.8114 13.0814 37.8114 18.8061C37.8114 24.5309 33.3509 29.1724 27.8494 29.1724C22.348 29.1724 17.8875 24.5309 17.8875 18.8061ZM10.2578 18.8061C10.2578 30.52 24.4878 46.328 27.351 49.3898C27.6245 49.6821 28.0743 49.6821 28.3479 49.3898C31.2133 46.3373 45.4387 30.5873 45.4387 18.8038C45.4387 8.69508 37.5633 0.5 27.8494 0.5C18.1356 0.5 10.2578 8.6974 10.2578 18.8061Z",
    fill: "url(#paint40_radial_19952_150379)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8953 18.8058C17.8953 13.081 22.3558 8.43956 27.8572 8.43956C33.3587 8.43956 37.8192 13.081 37.8192 18.8058C37.8192 24.5305 33.3587 29.172 27.8572 29.172C22.3558 29.172 17.8953 24.5305 17.8953 18.8058ZM10.2656 18.8058C10.2656 30.5197 24.4956 46.3299 27.3565 49.3918C27.63 49.6841 28.0798 49.6841 28.3534 49.3918C31.2188 46.3392 45.4442 30.5869 45.4442 18.8058C45.4442 8.69704 37.5688 0.501953 27.8549 0.501953C18.141 0.501953 10.2656 8.69704 10.2656 18.8058Z",
    fill: "url(#paint41_radial_19952_150379)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9047 18.8058C17.9047 13.081 22.3652 8.43956 27.8666 8.43956C33.3681 8.43956 37.8286 13.081 37.8286 18.8058C37.8286 24.5305 33.3681 29.172 27.8666 29.172C22.3652 29.172 17.9047 24.5305 17.9047 18.8058ZM10.2773 18.8058C10.2773 30.5197 24.5074 46.3299 27.3682 49.3941C27.6418 49.6864 28.0915 49.6864 28.3651 49.3941C31.2306 46.3415 45.4559 30.5869 45.4559 18.8058C45.4559 8.69704 37.5805 0.501953 27.8666 0.501953C18.1528 0.501953 10.2773 8.69704 10.2773 18.8058Z",
    fill: "url(#paint42_radial_19952_150379)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9164 18.8061C17.9164 13.0814 22.3769 8.43993 27.8784 8.43993C33.3798 8.43993 37.8403 13.0814 37.8403 18.8061C37.8403 24.5309 33.3798 29.1724 27.8784 29.1724C22.3746 29.1724 17.9164 24.5309 17.9164 18.8061ZM10.2891 18.8061C10.2891 30.52 24.5168 46.3326 27.3799 49.3945C27.6535 49.6867 28.1032 49.6867 28.3768 49.3945C31.2423 46.3419 45.4677 30.585 45.4677 18.8038C45.4677 8.69508 37.5922 0.5 27.8784 0.5C18.1645 0.5 10.2891 8.6974 10.2891 18.8061Z",
    fill: "url(#paint43_radial_19952_150379)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9262 18.8061C17.9262 13.0814 22.3867 8.43993 27.8858 8.43993C33.3849 8.43993 37.8454 13.0814 37.8454 18.8061C37.8454 24.5309 33.3849 29.1724 27.8858 29.1724C22.3867 29.1724 17.9262 24.5309 17.9262 18.8061ZM10.2988 18.8061C10.2988 30.52 24.5265 46.3349 27.3897 49.3968C27.6632 49.6891 28.113 49.6891 28.3866 49.3968C31.252 46.3419 45.4751 30.585 45.4751 18.8038C45.4751 8.69508 37.5997 0.5 27.8858 0.5C18.1719 0.5 10.2988 8.6974 10.2988 18.8061Z",
    fill: "url(#paint44_radial_19952_150379)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9379 18.8058C17.9379 13.081 22.3984 8.43956 27.8975 8.43956C33.399 8.43956 37.8571 13.081 37.8571 18.8058C37.8571 24.5305 33.3966 29.172 27.8975 29.172C22.3961 29.172 17.9379 24.5305 17.9379 18.8058ZM10.3105 18.8058C10.3105 30.5197 24.5382 46.3346 27.3991 49.3987C27.6726 49.691 28.1224 49.691 28.396 49.3987C31.2614 46.3439 45.4845 30.5846 45.4845 18.8058C45.4845 8.69704 37.6091 0.501953 27.8975 0.501953C18.186 0.501953 10.3105 8.69704 10.3105 18.8058Z",
    fill: "url(#paint45_radial_19952_150379)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9477 18.8058C17.9477 13.081 22.4059 8.43956 27.9073 8.43956C33.4087 8.43956 37.8669 13.081 37.8669 18.8058C37.8669 24.5305 33.4087 29.172 27.9073 29.172C22.4059 29.172 17.9477 24.5305 17.9477 18.8058ZM10.3203 18.8058C10.3203 30.5197 24.548 46.3369 27.4088 49.4011C27.6824 49.6933 28.1322 49.6933 28.4057 49.4011C31.2712 46.3462 45.4943 30.5846 45.4943 18.8058C45.4943 8.69704 37.6212 0.501953 27.9073 0.501953C18.1934 0.501953 10.3203 8.69704 10.3203 18.8058Z",
    fill: "url(#paint46_radial_19952_150379)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9594 18.8061C17.9594 13.0814 22.4176 8.43993 27.919 8.43993C33.4204 8.43993 37.8786 13.0814 37.8786 18.8061C37.8786 24.5309 33.4204 29.1724 27.919 29.1724C22.4176 29.1724 17.9594 24.5309 17.9594 18.8061ZM10.332 18.8061C10.332 30.52 24.5574 46.3373 27.4206 49.4014C27.6941 49.6937 28.1439 49.6937 28.4175 49.4014C31.2829 46.3465 45.506 30.585 45.506 18.8038C45.506 8.69508 37.6329 0.5 27.919 0.5C18.2051 0.5 10.332 8.6974 10.332 18.8061Z",
    fill: "url(#paint47_radial_19952_150379)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9672 18.8058C17.9672 13.081 22.4254 8.43956 27.9268 8.43956C33.4283 8.43956 37.8864 13.081 37.8864 18.8058C37.8864 24.5305 33.4283 29.172 27.9268 29.172C22.4254 29.172 17.9672 24.5305 17.9672 18.8058ZM10.3398 18.8058C10.3398 30.5197 24.5652 46.3392 27.4284 49.4034C27.7019 49.6957 28.1517 49.6957 28.4253 49.4034C31.2907 46.3485 45.5115 30.5846 45.5115 18.8058C45.5115 8.69704 37.6384 0.501953 27.9245 0.501953C18.2106 0.501953 10.3398 8.69704 10.3398 18.8058Z",
    fill: "url(#paint48_radial_19952_150379)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9789 18.8058C17.9789 13.081 22.4371 8.43956 27.9385 8.43956C33.44 8.43956 37.8982 13.081 37.8982 18.8058C37.8982 24.5305 33.44 29.172 27.9385 29.172C22.4371 29.172 17.9789 24.5305 17.9789 18.8058ZM10.3516 18.8058C10.3516 30.522 24.5769 46.3392 27.4401 49.4057C27.7137 49.698 28.1634 49.698 28.437 49.4057C31.3025 46.3485 45.5232 30.5846 45.5232 18.8058C45.5232 8.69704 37.6501 0.501953 27.9385 0.501953C18.227 0.501953 10.3516 8.69704 10.3516 18.8058Z",
    fill: "url(#paint49_radial_19952_150379)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9887 18.8058C17.9887 13.081 22.4469 8.43956 27.9483 8.43956C33.4497 8.43956 37.9079 13.081 37.9079 18.8058C37.9079 24.5305 33.4497 29.172 27.9483 29.172C22.4469 29.172 17.9887 24.5305 17.9887 18.8058ZM10.3613 18.8058C10.3613 30.522 24.5867 46.3415 27.4475 49.408C27.7211 49.7003 28.1732 49.7003 28.4444 49.408C31.3099 46.3508 45.5307 30.5846 45.5307 18.8058C45.5307 8.69704 37.6575 0.501953 27.946 0.501953C18.2344 0.501953 10.3613 8.69704 10.3613 18.8058Z",
    fill: "url(#paint50_radial_19952_150379)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9981 18.8061C17.9981 13.0814 22.4563 8.43993 27.9577 8.43993C33.4591 8.43993 37.9173 13.0814 37.9173 18.8061C37.9173 24.5309 33.4591 29.1724 27.9577 29.1724C22.4563 29.1724 17.9981 24.5309 17.9981 18.8061ZM10.373 18.8061C10.373 30.5224 24.5961 46.3442 27.4593 49.4084C27.7328 49.7007 28.1849 49.7007 28.4562 49.4084C31.3216 46.3512 45.5424 30.5827 45.5424 18.8038C45.5424 8.69508 37.6693 0.5 27.9577 0.5C18.2462 0.5 10.373 8.6974 10.373 18.8061Z",
    fill: "url(#paint51_radial_19952_150379)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0102 18.8058C18.0102 13.081 22.4684 8.43956 27.9675 8.43956C33.4666 8.43956 37.9248 13.081 37.9248 18.8058C37.9248 24.5305 33.4666 29.172 27.9675 29.172C22.4684 29.172 18.0102 24.5305 18.0102 18.8058ZM10.3828 18.8058C10.3828 30.522 24.6059 46.3439 27.469 49.4103C27.7426 49.7026 28.1947 49.7026 28.4659 49.4103C31.3314 46.3531 45.5498 30.5823 45.5498 18.8058C45.5498 8.69704 37.6767 0.501953 27.9652 0.501953C18.2536 0.501953 10.3828 8.69704 10.3828 18.8058Z",
    fill: "url(#paint52_radial_19952_150379)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0196 18.8058C18.0196 13.081 22.4778 8.43956 27.9769 8.43956C33.476 8.43956 37.9342 13.081 37.9342 18.8058C37.9342 24.5305 33.476 29.172 27.9769 29.172C22.4778 29.172 18.0196 24.5305 18.0196 18.8058ZM10.3945 18.8058C10.3945 30.522 24.6176 46.3462 27.4807 49.4127C27.7543 49.7049 28.2064 49.7049 28.4776 49.4127C31.3431 46.3555 45.5615 30.5823 45.5615 18.8058C45.5615 8.69704 37.6884 0.501953 27.9769 0.501953C18.2653 0.501953 10.3945 8.69704 10.3945 18.8058Z",
    fill: "url(#paint53_radial_19952_150379)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0313 18.8061C18.0313 13.0814 22.4895 8.43993 27.9886 8.43993C33.4877 8.43993 37.9459 13.0814 37.9459 18.8061C37.9459 24.5309 33.4877 29.1724 27.9886 29.1724C22.4895 29.1724 18.0313 24.5309 18.0313 18.8061ZM10.4062 18.8061C10.4062 30.5224 24.6293 46.3465 27.4901 49.413C27.7637 49.7053 28.2158 49.7053 28.487 49.413C31.3525 46.3535 45.5709 30.5803 45.5709 18.8038C45.5709 8.69508 37.6978 0.5 27.9886 0.5C18.2794 0.5 10.4062 8.6974 10.4062 18.8061Z",
    fill: "url(#paint54_radial_19952_150379)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0391 18.8061C18.0391 13.0814 22.4973 8.43993 27.9964 8.43993C33.4955 8.43993 37.9537 13.0814 37.9537 18.8061C37.9537 24.5309 33.4955 29.1724 27.9964 29.1724C22.4973 29.1724 18.0391 24.5309 18.0391 18.8061ZM10.4141 18.8061C10.4141 30.5224 24.6348 46.3489 27.498 49.4154C27.7715 49.7076 28.2236 49.7076 28.4949 49.4154C31.3603 46.3558 45.5788 30.5803 45.5788 18.8038C45.5788 8.69508 37.7056 0.5 27.9964 0.5C18.2872 0.5 10.4141 8.6974 10.4141 18.8061Z",
    fill: "url(#paint55_radial_19952_150379)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0508 18.8058C18.0508 13.081 22.509 8.43956 28.0081 8.43956C33.5072 8.43956 37.9654 13.081 37.9654 18.8058C37.9654 24.5305 33.5072 29.172 28.0081 29.172C22.509 29.172 18.0508 24.5305 18.0508 18.8058ZM10.4258 18.8058C10.4258 30.522 24.6465 46.3485 27.5097 49.4173C27.7832 49.7096 28.2353 49.7096 28.5066 49.4173C31.372 46.3578 45.5881 30.5823 45.5881 18.8058C45.5881 8.69704 37.7174 0.501953 28.0058 0.501953C18.2943 0.501953 10.4258 8.69704 10.4258 18.8058Z",
    fill: "url(#paint56_radial_19952_150379)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0606 18.8058C18.0606 13.081 22.5188 8.43956 28.0179 8.43956C33.517 8.43956 37.9752 13.081 37.9752 18.8058C37.9752 24.5305 33.517 29.172 28.0179 29.172C22.5188 29.172 18.0606 24.5305 18.0606 18.8058ZM10.4355 18.8058C10.4355 30.522 24.6563 46.3508 27.5194 49.4196C27.793 49.7119 28.2451 49.7119 28.5187 49.4196C31.3841 46.3601 45.6002 30.5823 45.6002 18.8058C45.6002 8.69704 37.7294 0.501953 28.0179 0.501953C18.3087 0.504273 10.4355 8.69704 10.4355 18.8058Z",
    fill: "url(#paint57_radial_19952_150379)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0723 18.8061C18.0723 13.0814 22.5305 8.43993 28.0296 8.43993C33.5287 8.43993 37.9869 13.0814 37.9869 18.8061C37.9869 24.5309 33.5287 29.1724 28.0296 29.1724C22.5282 29.1724 18.0723 24.5309 18.0723 18.8061ZM10.4473 18.8061C10.4473 30.5224 24.668 46.3535 27.5288 49.42C27.8024 49.7123 28.2545 49.7123 28.5281 49.42C31.3935 46.3605 45.6096 30.5803 45.6096 18.8038C45.6096 8.69508 37.7388 0.5 28.0296 0.5C18.3204 0.5 10.4473 8.6974 10.4473 18.8061Z",
    fill: "url(#paint58_radial_19952_150379)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0821 18.8061C18.0821 13.0814 22.5403 8.43993 28.0394 8.43993C33.5385 8.43993 37.9967 13.0814 37.9967 18.8061C37.9967 24.5309 33.5385 29.1724 28.0394 29.1724C22.5403 29.1724 18.0821 24.5309 18.0821 18.8061ZM10.457 18.8061C10.457 30.5247 24.6755 46.3535 27.5386 49.4223C27.8122 49.7146 28.2643 49.7146 28.5378 49.4223C31.4033 46.3605 45.6194 30.5803 45.6194 18.8038C45.6194 8.69508 37.7486 0.5 28.0394 0.5C18.3301 0.5 10.457 8.6974 10.457 18.8061Z",
    fill: "url(#paint59_radial_19952_150379)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0915 18.8058C18.0915 13.081 22.5497 8.43956 28.0465 8.43956C33.5456 8.43956 38.0014 13.081 38.0014 18.8058C38.0014 24.5305 33.5433 29.172 28.0465 29.172C22.5497 29.172 18.0915 24.5305 18.0915 18.8058ZM10.4688 18.8058C10.4688 30.5243 24.6872 46.3555 27.5503 49.4243C27.8239 49.7165 28.276 49.7165 28.5495 49.4243C31.415 46.3624 45.6311 30.58 45.6311 18.8058C45.6311 8.69704 37.7603 0.501953 28.0511 0.501953C18.3395 0.504273 10.4688 8.69704 10.4688 18.8058Z",
    fill: "url(#paint60_radial_19952_150379)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 18.8058C18.1016 13.081 22.5598 8.43956 28.0566 8.43956C33.5557 8.43956 38.0116 13.081 38.0116 18.8058C38.0116 24.5305 33.5534 29.172 28.0566 29.172C22.5598 29.172 18.1016 24.5305 18.1016 18.8058ZM10.4766 18.8058C10.4766 30.5243 24.695 46.3555 27.5581 49.4266C27.8317 49.7189 28.2838 49.7189 28.5574 49.4266C31.4228 46.3647 45.6366 30.58 45.6366 18.8058C45.6366 8.69704 37.7658 0.501953 28.0566 0.501953C18.3474 0.501953 10.4766 8.69704 10.4766 18.8058Z",
    fill: "url(#paint61_radial_19952_150379)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M18.111 18.8061C18.111 13.0814 22.5692 8.43993 28.066 8.43993C33.5651 8.43993 38.021 13.0814 38.021 18.8061C38.021 24.5309 33.5628 29.1724 28.066 29.1724C22.5692 29.1724 18.111 24.5309 18.111 18.8061ZM10.4883 18.8061C10.4883 30.5247 24.7067 46.3581 27.5675 49.4269C27.8411 49.7192 28.2932 49.7192 28.5668 49.4269C31.4322 46.3651 45.646 30.578 45.646 18.8038C45.646 8.69508 37.7752 0.5 28.066 0.5C18.3568 0.5 10.4883 8.6974 10.4883 18.8061Z",
    fill: "url(#paint62_radial_19952_150379)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1227 18.8058C18.1227 13.081 22.5786 8.43956 28.0777 8.43956C33.5768 8.43956 38.0327 13.081 38.0327 18.8058C38.0327 24.5305 33.5768 29.172 28.0777 29.172C22.5786 29.172 18.1227 24.5305 18.1227 18.8058ZM10.5 18.8058C10.5 30.5243 24.7161 46.3578 27.5793 49.4289C27.8528 49.7212 28.3049 49.7212 28.5785 49.4289C31.4439 46.367 45.6577 30.5777 45.6577 18.8058C45.6577 8.69704 37.7869 0.501953 28.08 0.501953C18.3731 0.501953 10.5 8.69704 10.5 18.8058Z",
    fill: "url(#paint63_radial_19952_150379)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1325 18.8058C18.1325 13.081 22.5884 8.43956 28.0875 8.43956C33.5866 8.43956 38.0425 13.081 38.0425 18.8058C38.0425 24.5305 33.5866 29.172 28.0875 29.172C22.5884 29.172 18.1325 24.5305 18.1325 18.8058ZM10.5098 18.8058C10.5098 30.5243 24.7259 46.3601 27.589 49.4312C27.8626 49.7235 28.3147 49.7235 28.5882 49.4312C31.4537 46.3671 45.6675 30.5777 45.6675 18.8058C45.6675 8.69704 37.7967 0.501953 28.0898 0.501953C18.3829 0.501953 10.5098 8.69704 10.5098 18.8058Z",
    fill: "url(#paint64_radial_19952_150379)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1442 18.8058C18.1442 13.081 22.6001 8.43956 28.0992 8.43956C33.596 8.43956 38.0542 13.081 38.0542 18.8058C38.0542 24.5305 33.5983 29.172 28.0992 29.172C22.6001 29.172 18.1442 24.5305 18.1442 18.8058ZM10.5215 18.8058C10.5215 30.5243 24.7376 46.3624 27.6007 49.4335C27.8743 49.7258 28.3264 49.7258 28.6 49.4335C31.4654 46.3694 45.6769 30.58 45.6769 18.8058C45.6769 8.69704 37.8061 0.501953 28.0992 0.501953C18.3923 0.501953 10.5215 8.69704 10.5215 18.8058Z",
    fill: "url(#paint65_radial_19952_150379)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.154 18.8061C18.154 13.0814 22.6098 8.43993 28.109 8.43993C33.6058 8.43993 38.0639 13.0814 38.0639 18.8061C38.0639 24.5309 33.6081 29.1724 28.109 29.1724C22.6122 29.1724 18.154 24.5309 18.154 18.8061ZM10.5312 18.8061C10.5312 30.5247 24.7474 46.3628 27.6082 49.4339C27.8818 49.7262 28.3338 49.7262 28.6074 49.4339C31.4729 46.3697 45.6843 30.578 45.6843 18.8038C45.6843 8.69508 37.8159 0.5 28.1066 0.5C18.3974 0.5 10.5312 8.6974 10.5312 18.8061Z",
    fill: "url(#paint66_radial_19952_150379)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1657 18.8058C18.1657 13.081 22.6216 8.43956 28.1207 8.43956C33.6175 8.43956 38.0757 13.081 38.0757 18.8058C38.0757 24.5305 33.6198 29.172 28.1207 29.172C22.6216 29.172 18.1657 24.5305 18.1657 18.8058ZM10.543 18.8058C10.543 30.5243 24.7568 46.3647 27.6199 49.4359C27.8935 49.7281 28.3456 49.7281 28.6191 49.4359C31.4846 46.3717 45.6961 30.5777 45.6961 18.8058C45.6961 8.69704 37.8276 0.501953 28.1207 0.501953C18.4138 0.501953 10.543 8.69704 10.543 18.8058Z",
    fill: "url(#paint67_radial_19952_150379)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1735 18.8058C18.1735 13.081 22.6294 8.43956 28.1262 8.43956C33.623 8.43956 38.0788 13.081 38.0788 18.8058C38.0788 24.5305 33.623 29.172 28.1262 29.172C22.6294 29.172 18.1735 24.5305 18.1735 18.8058ZM10.5508 18.8058C10.5508 30.5243 24.7646 46.3647 27.6277 49.4382C27.9013 49.7305 28.3534 49.7305 28.6269 49.4382C31.4924 46.374 45.7039 30.5777 45.7039 18.8058C45.7039 8.69704 37.8354 0.501953 28.1285 0.501953C18.4216 0.501953 10.5508 8.69704 10.5508 18.8058Z",
    fill: "url(#paint68_radial_19952_150379)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1852 18.8058C18.1852 13.081 22.6411 8.43956 28.1379 8.43956C33.6347 8.43956 38.0906 13.081 38.0906 18.8058C38.0906 24.5305 33.6347 29.172 28.1379 29.172C22.6411 29.172 18.1852 24.5305 18.1852 18.8058ZM10.5625 18.8058C10.5625 30.5266 24.7763 46.367 27.6394 49.4405C27.913 49.7328 28.3651 49.7328 28.6387 49.4405C31.5041 46.374 45.7133 30.5777 45.7133 18.8058C45.7133 8.69704 37.8448 0.501953 28.1379 0.501953C18.431 0.501953 10.5625 8.69704 10.5625 18.8058Z",
    fill: "url(#paint69_radial_19952_150379)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.195 18.8061C18.195 13.0814 22.6509 8.43993 28.1477 8.43993C33.6445 8.43993 38.1003 13.0814 38.1003 18.8061C38.1003 24.5309 33.6445 29.1724 28.1477 29.1724C22.6509 29.1724 18.195 24.5309 18.195 18.8061ZM10.5723 18.8061C10.5723 30.527 24.7861 46.3697 27.6492 49.4409C27.9228 49.7331 28.3749 49.7331 28.6484 49.4409C31.5139 46.3744 45.723 30.5757 45.723 18.8038C45.723 8.69508 37.8546 0.5 28.1477 0.5C18.4407 0.5 10.5723 8.6974 10.5723 18.8061Z",
    fill: "url(#paint70_radial_19952_150379)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2044 18.8058C18.2044 13.081 22.6603 8.43956 28.1571 8.43956C33.6539 8.43956 38.1097 13.081 38.1097 18.8058C38.1097 24.5305 33.6539 29.172 28.1571 29.172C22.6603 29.172 18.2044 24.5305 18.2044 18.8058ZM10.584 18.8058C10.584 30.5266 24.7955 46.3694 27.6586 49.4428C27.9322 49.7351 28.3843 49.7351 28.6578 49.4428C31.5233 46.3763 45.7324 30.5753 45.7324 18.8058C45.7324 8.69704 37.864 0.501953 28.1571 0.501953C18.4501 0.501953 10.584 8.69704 10.584 18.8058Z",
    fill: "url(#paint71_radial_19952_150379)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2165 18.8058C18.2165 13.081 22.6723 8.43956 28.1691 8.43956C33.6659 8.43956 38.1218 13.081 38.1218 18.8058C38.1218 24.5305 33.6659 29.172 28.1691 29.172C22.6723 29.172 18.2165 24.5305 18.2165 18.8058ZM10.5938 18.8058C10.5938 30.5266 24.8052 46.3717 27.6684 49.4451C27.9419 49.7374 28.394 49.7374 28.6676 49.4451C31.5331 46.3787 45.7422 30.5753 45.7422 18.8058C45.7422 8.69704 37.8737 0.501953 28.1691 0.501953C18.4645 0.501953 10.5938 8.69704 10.5938 18.8058Z",
    fill: "url(#paint72_radial_19952_150379)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2259 18.8061C18.2259 13.0814 22.6817 8.43993 28.1785 8.43993C33.6753 8.43993 38.1312 13.0814 38.1312 18.8061C38.1312 24.5309 33.6753 29.1724 28.1785 29.1724C22.6817 29.1724 18.2259 24.5309 18.2259 18.8061ZM10.6055 18.8061C10.6055 30.527 24.8169 46.3721 27.6801 49.4455C27.9537 49.7378 28.4057 49.7378 28.6793 49.4455C31.5448 46.379 45.7539 30.5734 45.7539 18.8038C45.7539 8.69508 37.8855 0.5 28.1809 0.5C18.4763 0.5 10.6055 8.6974 10.6055 18.8061Z",
    fill: "url(#paint73_radial_19952_150379)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2376 18.8061C18.2376 13.0814 22.6935 8.43993 28.1903 8.43993C33.6871 8.43993 38.1429 13.0814 38.1429 18.8061C38.1429 24.5309 33.6871 29.1724 28.1903 29.1724C22.6935 29.1724 18.2376 24.5309 18.2376 18.8061ZM10.6172 18.8061C10.6172 30.527 24.8287 46.3744 27.6918 49.4478C27.9654 49.7401 28.4175 49.7401 28.691 49.4478C31.5565 46.379 45.7633 30.5757 45.7633 18.8038C45.7633 8.69508 37.8949 0.5 28.1903 0.5C18.4857 0.5 10.6172 8.6974 10.6172 18.8061Z",
    fill: "url(#paint74_radial_19952_150379)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2454 18.8058C18.2454 13.081 22.7013 8.43956 28.1981 8.43956C33.6949 8.43956 38.1507 13.081 38.1507 18.8058C38.1507 24.5305 33.6949 29.172 28.1981 29.172C22.7013 29.172 18.2454 24.5305 18.2454 18.8058ZM10.625 18.8058C10.625 30.5266 24.8341 46.374 27.6973 49.4498C27.9709 49.742 28.4229 49.742 28.6965 49.4498C31.562 46.381 45.7688 30.5753 45.7688 18.8058C45.7688 8.69704 37.9003 0.501953 28.1957 0.501953C18.4911 0.501953 10.625 8.69704 10.625 18.8058Z",
    fill: "url(#paint75_radial_19952_150379)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2571 18.8058C18.2571 13.081 22.713 8.43956 28.2075 8.43956C33.702 8.43956 38.1578 13.081 38.1578 18.8058C38.1578 24.5305 33.702 29.172 28.2075 29.172C22.713 29.172 18.2571 24.5305 18.2571 18.8058ZM10.6367 18.8058C10.6367 30.5266 24.8459 46.3763 27.709 49.4521C27.9826 49.7444 28.4347 49.7444 28.7082 49.4521C31.5737 46.3833 45.7805 30.5753 45.7805 18.8058C45.7805 8.69704 37.9144 0.501953 28.2098 0.501953C18.5052 0.501953 10.6367 8.69704 10.6367 18.8058Z",
    fill: "url(#paint76_radial_19952_150379)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2669 18.8061C18.2669 13.0814 22.7228 8.43993 28.2172 8.43993C33.714 8.43993 38.1676 13.0814 38.1676 18.8061C38.1676 24.5309 33.7117 29.1724 28.2172 29.1724C22.7228 29.1724 18.2669 24.5309 18.2669 18.8061ZM10.6465 18.8061C10.6465 30.527 24.8556 46.379 27.7188 49.4525C27.9924 49.7447 28.4444 49.7447 28.718 49.4525C31.5835 46.3837 45.7903 30.5734 45.7903 18.8038C45.7903 8.69508 37.9242 0.5 28.2196 0.5C18.515 0.5 10.6465 8.6974 10.6465 18.8061Z",
    fill: "url(#paint77_radial_19952_150379)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2786 18.8058C18.2786 13.081 22.7345 8.43956 28.229 8.43956C33.7234 8.43956 38.1793 13.081 38.1793 18.8058C38.1793 24.5305 33.7234 29.172 28.229 29.172C22.7322 29.172 18.2786 24.5305 18.2786 18.8058ZM10.6582 18.8058C10.6582 30.5289 24.8674 46.3787 27.7305 49.4544C28.0041 49.7467 28.4562 49.7467 28.7297 49.4544C31.5952 46.3856 45.7997 30.573 45.7997 18.8058C45.7997 8.69704 37.9336 0.501953 28.229 0.501953C18.5244 0.501953 10.6582 8.69704 10.6582 18.8058Z",
    fill: "url(#paint78_radial_19952_150379)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2884 18.8058C18.2884 13.081 22.7442 8.43956 28.2387 8.43956C33.7332 8.43956 38.1891 13.081 38.1891 18.8058C38.1891 24.5305 33.7332 29.172 28.2387 29.172C22.7442 29.172 18.2884 24.5305 18.2884 18.8058ZM10.668 18.8058C10.668 30.5289 24.8748 46.381 27.738 49.4567C28.0115 49.749 28.4636 49.7513 28.7372 49.4567C31.6026 46.3856 45.8072 30.573 45.8072 18.8058C45.8072 8.69704 37.941 0.501953 28.2364 0.501953C18.5318 0.501953 10.668 8.69704 10.668 18.8058Z",
    fill: "url(#paint79_radial_19952_150379)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2978 18.8058C18.2978 13.081 22.7536 8.43956 28.2481 8.43956C33.7426 8.43956 38.1985 13.081 38.1985 18.8058C38.1985 24.5305 33.7426 29.172 28.2481 29.172C22.7536 29.172 18.2978 24.5305 18.2978 18.8058ZM10.6797 18.8058C10.6797 30.5289 24.8865 46.381 27.7497 49.4591C28.0232 49.7513 28.4753 49.7536 28.7489 49.4591C31.6144 46.3879 45.8189 30.573 45.8189 18.8058C45.8189 8.69704 37.9527 0.501953 28.2481 0.501953C18.5435 0.501953 10.6797 8.69704 10.6797 18.8058Z",
    fill: "url(#paint80_radial_19952_150379)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3079 18.8061C18.3079 13.0814 22.7614 8.43993 28.2582 8.43993C33.7527 8.43993 38.2086 13.0814 38.2086 18.8061C38.2086 24.5309 33.755 29.1724 28.2582 29.1724C22.7614 29.1724 18.3079 24.5309 18.3079 18.8061ZM10.6875 18.8061C10.6875 30.5293 24.8943 46.3837 27.7575 49.4594C28.0311 49.7517 28.4831 49.754 28.7567 49.4594C31.6222 46.3883 45.8267 30.5711 45.8267 18.8038C45.8267 8.69508 37.9605 0.5 28.2582 0.5C18.556 0.5 10.6875 8.6974 10.6875 18.8061Z",
    fill: "url(#paint81_radial_19952_150379)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3173 18.8058C18.3173 13.081 22.7709 8.43956 28.2677 8.43956C33.7621 8.43956 38.218 13.081 38.218 18.8058C38.218 24.5305 33.7645 29.172 28.2677 29.172C22.7732 29.172 18.3173 24.5305 18.3173 18.8058ZM10.6992 18.8058C10.6992 30.5289 24.9061 46.3833 27.7692 49.4614C28.0428 49.7536 28.4948 49.756 28.7684 49.4614C31.6339 46.3902 45.8361 30.5707 45.8361 18.8058C45.8361 8.69704 37.9699 0.501953 28.2677 0.501953C18.5654 0.501953 10.6992 8.69704 10.6992 18.8058Z",
    fill: "url(#paint82_radial_19952_150379)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3294 18.8058C18.3294 13.081 22.7829 8.43956 28.2774 8.43956C33.7719 8.43956 38.2278 13.081 38.2278 18.8058C38.2278 24.5305 33.7742 29.172 28.2774 29.172C22.7829 29.172 18.3294 24.5305 18.3294 18.8058ZM10.709 18.8058C10.709 30.5289 24.9135 46.3856 27.7767 49.4637C28.0502 49.756 28.5023 49.7583 28.7759 49.4637C31.6413 46.3926 45.8435 30.573 45.8435 18.8058C45.8435 8.69704 37.9774 0.501953 28.2751 0.501953C18.5728 0.501953 10.709 8.69704 10.709 18.8058Z",
    fill: "url(#paint83_radial_19952_150379)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3388 18.8058C18.3388 13.081 22.7923 8.43956 28.2868 8.43956C33.7813 8.43956 38.2348 13.081 38.2348 18.8058C38.2348 24.5305 33.7813 29.172 28.2868 29.172C22.7947 29.172 18.3388 24.5305 18.3388 18.8058ZM10.7207 18.8058C10.7207 30.5289 24.9252 46.3879 27.7884 49.466C28.0619 49.7583 28.514 49.7606 28.7876 49.466C31.6531 46.3926 45.8553 30.573 45.8553 18.8058C45.8553 8.69704 37.9891 0.501953 28.2868 0.501953C18.5845 0.501953 10.7207 8.69704 10.7207 18.8058Z",
    fill: "url(#paint84_radial_19952_150379)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3505 18.8061C18.3505 13.0814 22.8041 8.43993 28.2985 8.43993C33.793 8.43993 38.2466 13.0814 38.2466 18.8061C38.2466 24.5309 33.793 29.1724 28.2985 29.1724C22.8041 29.1724 18.3505 24.5309 18.3505 18.8061ZM10.7324 18.8061C10.7324 30.5293 24.9369 46.3883 27.8001 49.4664C28.0737 49.7586 28.5257 49.761 28.7993 49.4664C31.6648 46.3929 45.867 30.5711 45.867 18.8038C45.867 8.69508 38.0008 0.5 28.3009 0.5C18.6009 0.5 10.7324 8.6974 10.7324 18.8061Z",
    fill: "url(#paint85_radial_19952_150379)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3603 18.8058C18.3603 13.081 22.8138 8.43956 28.3083 8.43956C33.8028 8.43956 38.2563 13.081 38.2563 18.8058C38.2563 24.5305 33.8028 29.172 28.3083 29.172C22.8138 29.172 18.3603 24.5305 18.3603 18.8058ZM10.7422 18.8058C10.7422 30.5289 24.9467 46.3902 27.8099 49.4683C28.0834 49.7629 28.5355 49.7629 28.8091 49.4683C31.6745 46.3949 45.8744 30.5707 45.8744 18.8058C45.8744 8.69704 38.0106 0.501953 28.3083 0.501953C18.606 0.501953 10.7422 8.69704 10.7422 18.8058Z",
    fill: "url(#paint86_radial_19952_150379)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18.372 18.8058C18.372 13.081 22.8255 8.43956 28.32 8.43956C33.8145 8.43956 38.2681 13.081 38.2681 18.8058C38.2681 24.5305 33.8145 29.172 28.32 29.172C22.8255 29.172 18.372 24.5305 18.372 18.8058ZM10.7539 18.8058C10.7539 30.5289 24.9561 46.3903 27.8216 49.4707C28.0951 49.7653 28.5472 49.7653 28.8208 49.4707C31.6863 46.3972 45.8861 30.5707 45.8861 18.8058C45.8861 8.69704 38.0223 0.501953 28.32 0.501953C18.6177 0.501953 10.7539 8.69704 10.7539 18.8058Z",
    fill: "url(#paint87_radial_19952_150379)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3798 18.8058C18.3798 13.081 22.8334 8.43956 28.3278 8.43956C33.8223 8.43956 38.2759 13.081 38.2759 18.8058C38.2759 24.5305 33.8223 29.172 28.3278 29.172C22.8334 29.172 18.3798 24.5305 18.3798 18.8058ZM10.7617 18.8058C10.7617 30.5313 24.9639 46.3926 27.8271 49.473C28.1006 49.7676 28.5527 49.7676 28.8263 49.473C31.6918 46.3995 45.8916 30.5707 45.8916 18.8058C45.8916 8.69704 38.0278 0.501953 28.3255 0.501953C18.6232 0.501953 10.7617 8.69704 10.7617 18.8058Z",
    fill: "url(#paint88_radial_19952_150379)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3915 18.8061C18.3915 13.0814 22.8451 8.43993 28.3396 8.43993C33.834 8.43993 38.2876 13.0814 38.2876 18.8061C38.2876 24.5309 33.834 29.1724 28.3396 29.1724C22.8451 29.1724 18.3915 24.5309 18.3915 18.8061ZM10.7734 18.8061C10.7734 30.5316 24.9756 46.3929 27.8388 49.4733C28.1124 49.7679 28.5644 49.7679 28.838 49.4733C31.7035 46.3976 45.9034 30.5687 45.9034 18.8038C45.9034 8.69508 38.0395 0.5 28.3372 0.5C18.635 0.5 10.7734 8.6974 10.7734 18.8061Z",
    fill: "url(#paint89_radial_19952_150379)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4013 18.8058C18.4013 13.081 22.8548 8.43956 28.3493 8.43956C33.8438 8.43956 38.2973 13.081 38.2973 18.8058C38.2973 24.5305 33.8438 29.172 28.3493 29.172C22.8548 29.172 18.4013 24.5305 18.4013 18.8058ZM10.7832 18.8058C10.7832 30.5313 24.9854 46.3949 27.8486 49.4753C28.1221 49.7699 28.5765 49.7699 28.8478 49.4753C31.7132 46.3995 45.9131 30.5684 45.9131 18.8058C45.9131 8.69704 38.0493 0.501953 28.3493 0.501953C18.6494 0.501953 10.7832 8.69704 10.7832 18.8058Z",
    fill: "url(#paint90_radial_19952_150379)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4107 18.8058C18.4107 13.081 22.8642 8.43956 28.3564 8.43956C33.8486 8.43956 38.3021 13.081 38.3021 18.8058C38.3021 24.5305 33.8486 29.172 28.3564 29.172C22.8642 29.172 18.4107 24.5305 18.4107 18.8058ZM10.7949 18.8058C10.7949 30.5313 24.9948 46.3972 27.8603 49.4776C28.1338 49.7722 28.5882 49.7722 28.8595 49.4776C31.725 46.4018 45.9225 30.5684 45.9225 18.8058C45.9225 8.69704 38.0587 0.501953 28.3587 0.501953C18.6588 0.501953 10.7949 8.69704 10.7949 18.8058Z",
    fill: "url(#paint91_radial_19952_150379)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4228 18.8061C18.4228 13.0814 22.8763 8.43993 28.3685 8.43993C33.863 8.43993 38.3142 13.0814 38.3142 18.8061C38.3142 24.5309 33.8606 29.1724 28.3685 29.1724C22.8763 29.1724 18.4228 24.5309 18.4228 18.8061ZM10.8047 18.8061C10.8047 30.5316 25.0046 46.3976 27.8677 49.478C28.1413 49.7726 28.5957 49.7726 28.8669 49.478C31.7324 46.4022 45.93 30.5687 45.93 18.8038C45.93 8.69508 38.0661 0.5 28.3662 0.5C18.6662 0.5 10.8047 8.6974 10.8047 18.8061Z",
    fill: "url(#paint92_radial_19952_150379)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4322 18.8058C18.4322 13.081 22.8857 8.43956 28.3779 8.43956C33.87 8.43956 38.3236 13.081 38.3236 18.8058C38.3236 24.5305 33.87 29.172 28.3779 29.172C22.8857 29.172 18.4322 24.5305 18.4322 18.8058ZM10.8164 18.8058C10.8164 30.5313 25.0163 46.3995 27.8794 49.4799C28.153 49.7745 28.6074 49.7745 28.8786 49.4799C31.7441 46.4042 45.9417 30.5684 45.9417 18.8058C45.9417 8.69704 38.0778 0.501953 28.3779 0.501953C18.6779 0.501953 10.8164 8.69704 10.8164 18.8058Z",
    fill: "url(#paint93_radial_19952_150379)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4423 18.8058C18.4423 13.081 22.8959 8.43956 28.388 8.43956C33.8802 8.43956 38.3337 13.081 38.3337 18.8058C38.3337 24.5305 33.8802 29.172 28.388 29.172C22.8959 29.172 18.4423 24.5305 18.4423 18.8058ZM10.8242 18.8058C10.8242 30.5313 25.0241 46.3995 27.8873 49.4823C28.1608 49.7768 28.6152 49.7768 28.8865 49.4823C31.7519 46.4065 45.9495 30.5684 45.9495 18.8058C45.9495 8.69704 38.0857 0.501953 28.388 0.501953C18.6904 0.501953 10.8242 8.69704 10.8242 18.8058Z",
    fill: "url(#paint94_radial_19952_150379)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4517 18.8058C18.4517 13.081 22.9053 8.43956 28.3974 8.43956C33.8896 8.43956 38.3431 13.081 38.3431 18.8058C38.3431 24.5305 33.8896 29.172 28.3974 29.172C22.9053 29.172 18.4517 24.5305 18.4517 18.8058ZM10.8359 18.8058C10.8359 30.5313 25.0335 46.4019 27.899 49.4846C28.1725 49.7792 28.6269 49.7792 28.9005 49.4846C31.766 46.4065 45.9612 30.5684 45.9612 18.8058C45.9612 8.69704 38.0974 0.501953 28.3997 0.501953C18.7021 0.501953 10.8359 8.69704 10.8359 18.8058Z",
    fill: "url(#paint95_radial_19952_150379)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4634 18.8061C18.4634 13.0814 22.917 8.43993 28.4091 8.43993C33.9013 8.43993 38.3548 13.0814 38.3548 18.8061C38.3548 24.5309 33.9013 29.1724 28.4091 29.1724C22.917 29.1724 18.4634 24.5309 18.4634 18.8061ZM10.8477 18.8061C10.8477 30.5316 25.0452 46.4022 27.9084 49.4849C28.1819 49.7795 28.6363 49.7795 28.9099 49.4849C31.7754 46.4069 45.9706 30.5664 45.9706 18.8038C45.9706 8.69508 38.1091 0.5 28.4091 0.5C18.7092 0.5 10.8477 8.6974 10.8477 18.8061Z",
    fill: "url(#paint96_radial_19952_150379)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 18.8058C18.4732 13.081 22.9267 8.43956 28.4189 8.43956C33.9111 8.43956 38.3646 13.081 38.3646 18.8058C38.3646 24.5305 33.9111 29.172 28.4189 29.172C22.9267 29.172 18.4732 24.5305 18.4732 18.8058ZM10.8574 18.8058C10.8574 30.5313 25.055 46.4042 27.9181 49.4869C28.1917 49.7815 28.6461 49.7815 28.9197 49.4869C31.7851 46.4088 45.9804 30.5661 45.9804 18.8058C45.9804 8.69704 38.1189 0.501953 28.4189 0.501953C18.7189 0.501953 10.8574 8.69704 10.8574 18.8058Z",
    fill: "url(#paint97_radial_19952_150379)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4849 18.8058C18.4849 13.081 22.9385 8.43956 28.4306 8.43956C33.9228 8.43956 38.3763 13.081 38.3763 18.8058C38.3763 24.5305 33.9228 29.172 28.4306 29.172C22.9361 29.172 18.4849 24.5305 18.4849 18.8058ZM10.8691 18.8058C10.8691 30.5336 25.0667 46.4065 27.9299 49.4892C28.2034 49.7838 28.6578 49.7838 28.9314 49.4892C31.7969 46.4111 45.9921 30.5661 45.9921 18.8058C45.9921 8.69704 38.1306 0.501953 28.4306 0.501953C18.7307 0.501953 10.8691 8.69704 10.8691 18.8058Z",
    fill: "url(#paint98_radial_19952_150379)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4947 18.8058C18.4947 13.081 22.9459 8.43956 28.4381 8.43956C33.9302 8.43956 38.3815 13.081 38.3815 18.8058C38.3815 24.5305 33.9302 29.172 28.4381 29.172C22.9459 29.172 18.4947 24.5305 18.4947 18.8058ZM10.8789 18.8058C10.8789 30.5336 25.0741 46.4065 27.9396 49.4915C28.2132 49.7861 28.6676 49.7861 28.9411 49.4915C31.8066 46.4134 45.9995 30.5661 45.9995 18.8058C45.9995 8.69704 38.138 0.501953 28.4404 0.501953C18.7427 0.501953 10.8789 8.69704 10.8789 18.8058Z",
    fill: "url(#paint99_radial_19952_150379)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5041 18.8061C18.5041 13.0814 22.9553 8.43993 28.4475 8.43993C33.9396 8.43993 38.3909 13.0814 38.3909 18.8061C38.3909 24.5309 33.9396 29.1724 28.4475 29.1724C22.9576 29.1724 18.5041 24.5309 18.5041 18.8061ZM10.8906 18.8061C10.8906 30.5339 25.0859 46.4092 27.949 49.4919C28.2226 49.7865 28.677 49.7865 28.9506 49.4919C31.816 46.4115 46.0089 30.5641 46.0089 18.8038C46.0089 8.69508 38.1474 0.5 28.4498 0.5C18.7521 0.5 10.8906 8.6974 10.8906 18.8061Z",
    fill: "url(#paint100_radial_19952_150379)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5142 18.8058C18.5142 13.081 22.9654 8.43956 28.4576 8.43956C33.9498 8.43956 38.401 13.081 38.401 18.8058C38.401 24.5305 33.9498 29.172 28.4576 29.172C22.9654 29.172 18.5142 24.5305 18.5142 18.8058ZM10.8984 18.8058C10.8984 30.5336 25.0937 46.4088 27.9568 49.4938C28.2304 49.7884 28.6848 49.7884 28.9584 49.4938C31.8238 46.4134 46.0168 30.5661 46.0168 18.8058C46.0168 8.69704 38.1552 0.501953 28.4576 0.501953C18.76 0.501953 10.8984 8.69704 10.8984 18.8058Z",
    fill: "url(#paint101_radial_19952_150379)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5236 18.8058C18.5236 13.081 22.9748 8.43956 28.467 8.43956C33.9592 8.43956 38.4104 13.081 38.4104 18.8058C38.4104 24.5305 33.9592 29.172 28.467 29.172C22.9771 29.172 18.5236 24.5305 18.5236 18.8058ZM10.9102 18.8058C10.9102 30.5336 25.1054 46.4111 27.9685 49.4962C28.2421 49.7908 28.6965 49.7908 28.9701 49.4962C31.8356 46.4158 46.0285 30.5661 46.0285 18.8058C46.0285 8.69704 38.167 0.501953 28.4693 0.501953C18.7717 0.501953 10.9102 8.69704 10.9102 18.8058Z",
    fill: "url(#paint102_radial_19952_150379)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5357 18.8058C18.5357 13.081 22.9869 8.43956 28.4791 8.43956C33.9712 8.43956 38.4225 13.081 38.4225 18.8058C38.4225 24.5305 33.9712 29.172 28.4791 29.172C22.9869 29.172 18.5357 24.5305 18.5357 18.8058ZM10.9199 18.8058C10.9199 30.5336 25.1128 46.4134 27.9783 49.4985C28.2519 49.7931 28.7063 49.7931 28.9798 49.4985C31.8453 46.4181 46.0359 30.5661 46.0359 18.8058C46.0359 8.69704 38.1744 0.501953 28.4791 0.501953C18.7838 0.501953 10.9199 8.69704 10.9199 18.8058Z",
    fill: "url(#paint103_radial_19952_150379)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5451 18.8061C18.5451 13.0814 22.9963 8.43993 28.4885 8.43993C33.9806 8.43993 38.4319 13.0814 38.4319 18.8061C38.4319 24.5309 33.9806 29.1724 28.4885 29.1724C22.9963 29.1724 18.5451 24.5309 18.5451 18.8061ZM10.9316 18.8061C10.9316 30.5339 25.1246 46.4138 27.9877 49.4989C28.2613 49.7934 28.7157 49.7934 28.9892 49.4989C31.8547 46.4184 46.0453 30.5641 46.0453 18.8038C46.0453 8.69508 38.1838 0.5 28.4885 0.5C18.7932 0.5 10.9316 8.6974 10.9316 18.8061Z",
    fill: "url(#paint104_radial_19952_150379)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5572 18.8058C18.5572 13.081 23.0084 8.43956 28.5006 8.43956C33.9927 8.43956 38.444 13.081 38.444 18.8058C38.444 24.5305 33.9927 29.172 28.5006 29.172C23.0084 29.172 18.5572 24.5305 18.5572 18.8058ZM10.9414 18.8058C10.9414 30.5336 25.1343 46.4158 27.9975 49.5008C28.2711 49.7954 28.7254 49.7954 28.999 49.5008C31.8645 46.4181 46.0551 30.5637 46.0551 18.8058C46.0551 8.69704 38.1936 0.501953 28.4982 0.501953C18.8029 0.501953 10.9414 8.69704 10.9414 18.8058Z",
    fill: "url(#paint105_radial_19952_150379)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5666 18.8058C18.5666 13.081 23.0178 8.43956 28.51 8.43956C34.0021 8.43956 38.4534 13.081 38.4534 18.8058C38.4534 24.5305 34.0021 29.172 28.51 29.172C23.0178 29.172 18.5666 24.5305 18.5666 18.8058ZM10.9531 18.8058C10.9531 30.5336 25.1437 46.4158 28.0092 49.5031C28.2828 49.7977 28.7372 49.7977 29.0107 49.5031C31.8762 46.4204 46.0668 30.5637 46.0668 18.8058C46.0668 8.69704 38.2076 0.501953 28.51 0.501953C18.8123 0.501953 10.9531 8.69704 10.9531 18.8058Z",
    fill: "url(#paint106_radial_19952_150379)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5783 18.8058C18.5783 13.081 23.0295 8.43956 28.5194 8.43956C34.0092 8.43956 38.4604 13.081 38.4604 18.8058C38.4604 24.5305 34.0092 29.172 28.5194 29.172C23.0295 29.172 18.5783 24.5305 18.5783 18.8058ZM10.9648 18.8058C10.9648 30.5359 25.1554 46.4181 28.0209 49.5055C28.2945 49.8 28.7489 49.8 29.0224 49.5055C31.8879 46.4227 46.0785 30.5637 46.0785 18.8058C46.0785 8.69704 38.2193 0.501953 28.5217 0.501953C18.824 0.501953 10.9648 8.69704 10.9648 18.8058Z",
    fill: "url(#paint107_radial_19952_150379)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5861 18.8058C18.5861 13.081 23.0373 8.43956 28.5272 8.43956C34.017 8.43956 38.4683 13.081 38.4683 18.8058C38.4683 24.5305 34.017 29.172 28.5272 29.172C23.0373 29.172 18.5861 24.5305 18.5861 18.8058ZM10.9727 18.8058C10.9727 30.5359 25.1633 46.4181 28.0287 49.5055C28.3023 49.8 28.7567 49.8 29.0303 49.5055C31.8957 46.4227 46.084 30.5614 46.084 18.8058C46.084 8.69704 38.2248 0.501953 28.5295 0.501953C18.8342 0.501953 10.9727 8.69704 10.9727 18.8058Z",
    fill: "url(#paint108_radial_19952_150379)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5978 18.8058C18.5978 13.081 23.0491 8.43956 28.5389 8.43956C34.0287 8.43956 38.48 13.081 38.48 18.8058C38.48 24.5305 34.0287 29.172 28.5389 29.172C23.0467 29.172 18.5978 24.5305 18.5978 18.8058ZM10.9844 18.8058C10.9844 30.5359 25.175 46.4204 28.0381 49.5078C28.3117 49.8024 28.7661 49.8024 29.0397 49.5078C31.9051 46.425 46.0934 30.5614 46.0934 18.8058C46.0934 8.69704 38.2342 0.501953 28.5389 0.501953C18.8436 0.501953 10.9844 8.69704 10.9844 18.8058Z",
    fill: "url(#paint109_radial_19952_150379)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6076 18.8058C18.6076 13.081 23.0588 8.43956 28.5487 8.43956C34.0385 8.43956 38.4897 13.081 38.4897 18.8058C38.4897 24.5305 34.0385 29.172 28.5487 29.172C23.0588 29.172 18.6076 24.5305 18.6076 18.8058ZM10.9941 18.8058C10.9941 30.5359 25.1824 46.4227 28.0479 49.5101C28.3215 49.8047 28.7759 49.8047 29.0494 49.5101C31.9149 46.425 46.1032 30.5637 46.1032 18.8058C46.1032 8.69704 38.244 0.501953 28.5487 0.501953C18.8533 0.501953 10.9941 8.69704 10.9941 18.8058Z",
    fill: "url(#paint110_radial_19952_150379)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M18.617 18.8061C18.617 13.0814 23.0682 8.43993 28.5581 8.43993C34.0479 8.43993 38.4991 13.0814 38.4991 18.8061C38.4991 24.5309 34.0479 29.1724 28.5581 29.1724C23.0682 29.1724 18.617 24.5309 18.617 18.8061ZM11.0059 18.8061C11.0059 30.5363 25.1941 46.4231 28.0596 49.5104C28.3332 49.805 28.7876 49.805 29.0611 49.5104C31.9266 46.4254 46.1149 30.5618 46.1149 18.8038C46.1149 8.69508 38.2557 0.5 28.5604 0.5C18.8651 0.5 11.0059 8.6974 11.0059 18.8061Z",
    fill: "url(#paint111_radial_19952_150379)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6291 18.8058C18.6291 13.081 23.0803 8.43956 28.5701 8.43956C34.06 8.43956 38.5112 13.081 38.5112 18.8058C38.5112 24.5305 34.06 29.172 28.5701 29.172C23.0803 29.172 18.6291 24.5305 18.6291 18.8058ZM11.0156 18.8058C11.0156 30.5359 25.2039 46.425 28.0694 49.5124C28.3429 49.807 28.7973 49.807 29.0709 49.5124C31.9364 46.4274 46.1223 30.5614 46.1223 18.8058C46.1223 8.69704 38.2632 0.501953 28.5701 0.501953C18.8771 0.501953 11.0156 8.69704 11.0156 18.8058Z",
    fill: "url(#paint112_radial_19952_150379)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6385 18.8058C18.6385 13.081 23.0897 8.43956 28.5795 8.43956C34.0694 8.43956 38.5206 13.081 38.5206 18.8058C38.5206 24.5305 34.0694 29.172 28.5795 29.172C23.0897 29.172 18.6385 24.5305 18.6385 18.8058ZM11.0273 18.8058C11.0273 30.5359 25.2156 46.425 28.0788 49.5147C28.3524 49.8093 28.8067 49.8093 29.0803 49.5147C31.9458 46.4297 46.1318 30.5614 46.1318 18.8058C46.1318 8.69704 38.2726 0.501953 28.5795 0.501953C18.8865 0.501953 11.0273 8.69704 11.0273 18.8058Z",
    fill: "url(#paint113_radial_19952_150379)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6486 18.8058C18.6486 13.081 23.0998 8.43956 28.5897 8.43956C34.0795 8.43956 38.5308 13.081 38.5308 18.8058C38.5308 24.5305 34.0795 29.172 28.5897 29.172C23.0998 29.172 18.6486 24.5305 18.6486 18.8058ZM11.0352 18.8058C11.0352 30.5359 25.2211 46.4274 28.0866 49.517C28.3602 49.8116 28.8146 49.8116 29.0881 49.517C31.9536 46.432 46.1396 30.5614 46.1396 18.8058C46.1396 8.69704 38.2804 0.501953 28.5874 0.501953C18.8944 0.501953 11.0352 8.69704 11.0352 18.8058Z",
    fill: "url(#paint114_radial_19952_150379)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M18.658 18.8061C18.658 13.0814 23.1092 8.43993 28.5968 8.43993C34.0843 8.43993 38.5355 13.0814 38.5355 18.8061C38.5355 24.5309 34.0843 29.1724 28.5968 29.1724C23.1092 29.1724 18.658 24.5309 18.658 18.8061ZM11.0469 18.8061C11.0469 30.5363 25.2328 46.4277 28.0983 49.5174C28.3719 49.812 28.8263 49.812 29.0998 49.5174C31.9653 46.43 46.1513 30.5595 46.1513 18.8038C46.1513 8.69508 38.2921 0.5 28.5991 0.5C18.9061 0.5 11.0469 8.6974 11.0469 18.8061Z",
    fill: "url(#paint115_radial_19952_150379)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6701 18.8058C18.6701 13.081 23.1213 8.43956 28.6089 8.43956C34.0964 8.43956 38.5476 13.081 38.5476 18.8058C38.5476 24.5305 34.0964 29.172 28.6089 29.172C23.1213 29.172 18.6701 24.5305 18.6701 18.8058ZM11.0566 18.8058C11.0566 30.5359 25.2426 46.4297 28.1081 49.5194C28.3816 49.814 28.8361 49.814 29.1096 49.5194C31.9751 46.432 46.1587 30.5591 46.1587 18.8058C46.1587 8.69704 38.3019 0.501953 28.6065 0.501953C18.9112 0.501953 11.0566 8.69704 11.0566 18.8058Z",
    fill: "url(#paint116_radial_19952_150379)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6795 18.8058C18.6795 13.081 23.1284 8.43956 28.6182 8.43956C34.1081 8.43956 38.557 13.081 38.557 18.8058C38.557 24.5305 34.1081 29.172 28.6182 29.172C23.1307 29.172 18.6795 24.5305 18.6795 18.8058ZM11.0684 18.8058C11.0684 30.5382 25.2543 46.432 28.1175 49.5217C28.3911 49.8163 28.8454 49.8163 29.119 49.5217C31.9845 46.4343 46.1681 30.5591 46.1681 18.8058C46.1681 8.69704 38.3113 0.501953 28.6182 0.501953C18.9252 0.501953 11.0684 8.69704 11.0684 18.8058Z",
    fill: "url(#paint117_radial_19952_150379)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6912 18.8058C18.6912 13.081 23.1401 8.43956 28.63 8.43956C34.1198 8.43956 38.5687 13.081 38.5687 18.8058C38.5687 24.5305 34.1198 29.172 28.63 29.172C23.1401 29.172 18.6912 24.5305 18.6912 18.8058ZM11.0801 18.8058C11.0801 30.5382 25.2637 46.432 28.1292 49.524C28.4028 49.8186 28.8572 49.8186 29.1307 49.524C31.9962 46.4366 46.1799 30.5591 46.1799 18.8058C46.1799 8.69704 38.323 0.501953 28.63 0.501953C18.937 0.501953 11.0801 8.69704 11.0801 18.8058Z",
    fill: "url(#paint118_radial_19952_150379)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18.701 18.8061C18.701 13.0814 23.1499 8.43993 28.6397 8.43993C34.1296 8.43993 38.5785 13.0814 38.5785 18.8061C38.5785 24.5309 34.1296 29.1724 28.6397 29.1724C23.1499 29.1724 18.701 24.5309 18.701 18.8061ZM11.0898 18.8061C11.0898 30.5386 25.2735 46.4347 28.139 49.5244C28.4125 49.819 28.8669 49.819 29.1405 49.5244C32.006 46.437 46.1896 30.5595 46.1896 18.8038C46.1896 8.69508 38.3327 0.5 28.6397 0.5C18.9467 0.5 11.0898 8.6974 11.0898 18.8061Z",
    fill: "url(#paint119_radial_19952_150379)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7104 18.8058C18.7104 13.081 23.1593 8.43956 28.6491 8.43956C34.139 8.43956 38.5879 13.081 38.5879 18.8058C38.5879 24.5305 34.139 29.172 28.6491 29.172C23.1593 29.172 18.7104 24.5305 18.7104 18.8058ZM11.1016 18.8058C11.1016 30.5382 25.2852 46.4343 28.1507 49.5263C28.4242 49.8209 28.8786 49.8209 29.1522 49.5263C32.0177 46.4366 46.2013 30.5591 46.2013 18.8058C46.2013 8.69704 38.3445 0.501953 28.6514 0.501953C18.9584 0.501953 11.1016 8.69704 11.1016 18.8058Z",
    fill: "url(#paint120_radial_19952_150379)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7205 18.8058C18.7205 13.081 23.1694 8.43956 28.6593 8.43956C34.1468 8.43956 38.598 13.081 38.598 18.8058C38.598 24.5305 34.1491 29.172 28.6593 29.172C23.1694 29.172 18.7205 24.5305 18.7205 18.8058ZM11.1094 18.8058C11.1094 30.5382 25.293 46.4366 28.1562 49.5286C28.4297 49.8232 28.8841 49.8232 29.1577 49.5286C32.0232 46.439 46.2045 30.5591 46.2045 18.8058C46.2045 8.69704 38.3476 0.501953 28.6569 0.501953C18.9663 0.501953 11.1094 8.69704 11.1094 18.8058Z",
    fill: "url(#paint121_radial_19952_150379)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7299 18.8058C18.7299 13.081 23.1788 8.43956 28.6687 8.43956C34.1585 8.43956 38.6074 13.081 38.6074 18.8058C38.6074 24.5305 34.1585 29.172 28.6687 29.172C23.1788 29.172 18.7299 24.5305 18.7299 18.8058ZM11.1211 18.8058C11.1211 30.5382 25.3024 46.4366 28.1679 49.531C28.4415 49.8256 28.8959 49.8256 29.1694 49.531C32.0349 46.4413 46.2162 30.5591 46.2162 18.8058C46.2162 8.69704 38.3594 0.501953 28.6687 0.501953C18.978 0.501953 11.1211 8.69704 11.1211 18.8058Z",
    fill: "url(#paint122_radial_19952_150379)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M18.742 18.8058C18.742 13.081 23.1909 8.43956 28.6784 8.43956C34.166 8.43956 38.6149 13.081 38.6149 18.8058C38.6149 24.5305 34.166 29.172 28.6784 29.172C23.1909 29.172 18.742 24.5305 18.742 18.8058ZM11.1309 18.8058C11.1309 30.5382 25.3122 46.439 28.1777 49.531C28.4512 49.8256 28.9056 49.8256 29.1792 49.531C32.0447 46.4413 46.226 30.5568 46.226 18.8058C46.226 8.69704 38.3691 0.501953 28.6784 0.501953C18.9877 0.504273 11.1309 8.69704 11.1309 18.8058Z",
    fill: "url(#paint123_radial_19952_150379)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7514 18.8058C18.7514 13.081 23.2003 8.43956 28.6878 8.43956C34.1754 8.43956 38.6243 13.081 38.6243 18.8058C38.6243 24.5305 34.1754 29.172 28.6878 29.172C23.2003 29.172 18.7514 24.5305 18.7514 18.8058ZM11.1426 18.8058C11.1426 30.5382 25.3239 46.4413 28.1894 49.5333C28.4629 49.8279 28.9173 49.8279 29.1909 49.5333C32.0564 46.4436 46.2377 30.5568 46.2377 18.8058C46.2377 8.69704 38.3808 0.501953 28.6901 0.501953C18.9995 0.501953 11.1426 8.69704 11.1426 18.8058Z",
    fill: "url(#paint124_radial_19952_150379)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7635 18.8058C18.7635 13.081 23.2124 8.43956 28.6999 8.43956C34.1874 8.43956 38.6363 13.081 38.6363 18.8058C38.6363 24.5305 34.1874 29.172 28.6999 29.172C23.2124 29.172 18.7635 24.5305 18.7635 18.8058ZM11.1523 18.8058C11.1523 30.5382 25.3337 46.4413 28.1968 49.5356C28.4704 49.8302 28.9248 49.8302 29.1984 49.5356C32.0638 46.4436 46.2428 30.5568 46.2428 18.8058C46.2428 8.69704 38.386 0.501953 28.6953 0.501953C19.0046 0.501953 11.1523 8.69704 11.1523 18.8058Z",
    fill: "url(#paint125_radial_19952_150379)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7729 18.8058C18.7729 13.081 23.2218 8.43956 28.7093 8.43956C34.1968 8.43956 38.6457 13.081 38.6457 18.8058C38.6457 24.5305 34.1968 29.172 28.7093 29.172C23.2218 29.172 18.7729 24.5305 18.7729 18.8058ZM11.1641 18.8058C11.1641 30.5382 25.3431 46.4436 28.2085 49.5379C28.4821 49.8325 28.9365 49.8325 29.2101 49.5379C32.0755 46.4459 46.2546 30.5568 46.2546 18.8058C46.2546 8.69704 38.4 0.501953 28.7093 0.501953C19.0186 0.501953 11.1641 8.69704 11.1641 18.8058Z",
    fill: "url(#paint126_radial_19952_150379)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.785 18.8058C18.785 13.081 23.2339 8.43956 28.7214 8.43956C34.2089 8.43956 38.6578 13.081 38.6578 18.8058C38.6578 24.5305 34.2089 29.172 28.7214 29.172C23.2339 29.172 18.785 24.5305 18.785 18.8058ZM11.1738 18.8058C11.1738 30.5405 25.3528 46.4436 28.2183 49.5379C28.4919 49.8325 28.9463 49.8325 29.2198 49.5379C32.0853 46.4459 46.2643 30.5545 46.2643 18.8058C46.2643 8.69704 38.4098 0.501953 28.7191 0.501953C19.0284 0.501953 11.1738 8.69704 11.1738 18.8058Z",
    fill: "url(#paint127_radial_19952_150379)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7924 18.8058C18.7924 13.081 23.2413 8.43956 28.7288 8.43956C34.2164 8.43956 38.6653 13.081 38.6653 18.8058C38.6653 24.5305 34.2164 29.172 28.7288 29.172C23.2413 29.172 18.7924 24.5305 18.7924 18.8058ZM11.1836 18.8058C11.1836 30.5405 25.3626 46.4459 28.2281 49.5402C28.5016 49.8348 28.956 49.8348 29.2296 49.5402C32.0951 46.4482 46.2741 30.5545 46.2741 18.8058C46.2741 8.69704 38.4195 0.501953 28.7288 0.501953C19.0382 0.501953 11.1836 8.69704 11.1836 18.8058Z",
    fill: "url(#paint128_radial_19952_150379)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8041 18.8058C18.8041 13.081 23.253 8.43956 28.7406 8.43956C34.2281 8.43956 38.677 13.081 38.677 18.8058C38.677 24.5305 34.2281 29.172 28.7406 29.172C23.2507 29.172 18.8041 24.5305 18.8041 18.8058ZM11.1953 18.8058C11.1953 30.5405 25.3743 46.4482 28.2398 49.5426C28.5134 49.8372 28.9678 49.8372 29.2413 49.5426C32.1068 46.4506 46.2835 30.5568 46.2835 18.8058C46.2835 8.69704 38.4289 0.501953 28.7382 0.501953C19.0476 0.501953 11.1953 8.69704 11.1953 18.8058Z",
    fill: "url(#paint129_radial_19952_150379)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8139 18.8061C18.8139 13.0814 23.2628 8.43993 28.7503 8.43993C34.2379 8.43993 38.6868 13.0814 38.6868 18.8061C38.6868 24.5309 34.2379 29.1724 28.7503 29.1724C23.2628 29.1724 18.8139 24.5309 18.8139 18.8061ZM11.2051 18.8061C11.2051 30.5409 25.3818 46.4486 28.2472 49.5429C28.5208 49.8375 28.9775 49.8375 29.2488 49.5429C32.1142 46.4486 46.2909 30.5548 46.2909 18.8038C46.2909 8.69508 38.4364 0.5 28.748 0.5C19.0596 0.5 11.2051 8.6974 11.2051 18.8061Z",
    fill: "url(#paint130_radial_19952_150379)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8233 18.8058C18.8233 13.081 23.2722 8.43956 28.7574 8.43956C34.2449 8.43956 38.6915 13.081 38.6915 18.8058C38.6915 24.5305 34.2426 29.172 28.7574 29.172C23.2722 29.172 18.8233 24.5305 18.8233 18.8058ZM11.2168 18.8058C11.2168 30.5405 25.3935 46.4506 28.259 49.5449C28.5325 49.8395 28.9892 49.8395 29.2605 49.5449C32.126 46.4506 46.3027 30.5545 46.3027 18.8058C46.3027 8.69704 38.4481 0.501953 28.7597 0.501953C19.0714 0.501953 11.2168 8.69704 11.2168 18.8058Z",
    fill: "url(#paint131_radial_19952_150379)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8354 18.8058C18.8354 13.081 23.2843 8.43956 28.7695 8.43956C34.2547 8.43956 38.7036 13.081 38.7036 18.8058C38.7036 24.5305 34.2547 29.172 28.7695 29.172C23.2843 29.172 18.8354 24.5305 18.8354 18.8058ZM11.2266 18.8058C11.2266 30.5405 25.4033 46.4506 28.2687 49.5472C28.5423 49.8418 28.999 49.8418 29.2703 49.5472C32.1357 46.4529 46.3124 30.5545 46.3124 18.8058C46.3124 8.69704 38.4579 0.501953 28.7695 0.501953C19.0811 0.501953 11.2266 8.69704 11.2266 18.8058Z",
    fill: "url(#paint132_radial_19952_150379)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8448 18.8058C18.8448 13.081 23.2937 8.43956 28.7789 8.43956C34.2641 8.43956 38.713 13.081 38.713 18.8058C38.713 24.5305 34.2641 29.172 28.7789 29.172C23.2937 29.172 18.8448 24.5305 18.8448 18.8058ZM11.2383 18.8058C11.2383 30.5405 25.415 46.4529 28.2805 49.5495C28.554 49.8441 29.0107 49.8441 29.2843 49.5495C32.1498 46.4552 46.3241 30.5545 46.3241 18.8058C46.3241 8.69704 38.4696 0.501953 28.7812 0.501953C19.0928 0.501953 11.2383 8.69704 11.2383 18.8058Z",
    fill: "url(#paint133_radial_19952_150379)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 18.8061C18.8569 13.0814 23.3034 8.43993 28.791 8.43993C34.2785 8.43993 38.7251 13.0814 38.7251 18.8061C38.7251 24.5309 34.2785 29.1724 28.791 29.1724C23.3034 29.1724 18.8569 24.5309 18.8569 18.8061ZM11.248 18.8061C11.248 30.5409 25.4224 46.4532 28.2879 49.5499C28.5615 49.8445 29.0182 49.8445 29.2917 49.5499C32.1572 46.4556 46.3316 30.5525 46.3316 18.8038C46.3316 8.69508 38.477 0.5 28.7887 0.5C19.1003 0.5 11.248 8.6974 11.248 18.8061Z",
    fill: "url(#paint134_radial_19952_150379)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8643 18.8058C18.8643 13.081 23.3109 8.43956 28.7984 8.43956C34.2859 8.43956 38.7325 13.081 38.7325 18.8058C38.7325 24.5305 34.2859 29.172 28.7984 29.172C23.3109 29.172 18.8643 24.5305 18.8643 18.8058ZM11.2578 18.8058C11.2578 30.5405 25.4322 46.4552 28.2977 49.5518C28.5712 49.8464 29.0279 49.8464 29.3015 49.5518C32.167 46.4552 46.3414 30.5521 46.3414 18.8058C46.3414 8.69704 38.4868 0.501953 28.8007 0.501953C19.1147 0.501953 11.2578 8.69704 11.2578 18.8058Z",
    fill: "url(#paint135_radial_19952_150379)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8764 18.8058C18.8764 13.081 23.323 8.43956 28.8105 8.43956C34.298 8.43956 38.7446 13.081 38.7446 18.8058C38.7446 24.5305 34.298 29.172 28.8105 29.172C23.323 29.172 18.8764 24.5305 18.8764 18.8058ZM11.2676 18.8058C11.2676 30.5405 25.442 46.4575 28.3074 49.5542C28.581 49.8487 29.0377 49.8487 29.3113 49.5542C32.1768 46.4575 46.3511 30.5521 46.3511 18.8058C46.3511 8.69704 38.4989 0.501953 28.8105 0.501953C19.1221 0.501953 11.2676 8.69704 11.2676 18.8058Z",
    fill: "url(#paint136_radial_19952_150379)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8858 18.8058C18.8858 13.081 23.3324 8.43956 28.8199 8.43956C34.3051 8.43956 38.754 13.081 38.754 18.8058C38.754 24.5305 34.3074 29.172 28.8199 29.172C23.3324 29.172 18.8858 24.5305 18.8858 18.8058ZM11.2793 18.8058C11.2793 30.5429 25.4537 46.4575 28.3191 49.5565C28.5927 49.8511 29.0494 49.8511 29.323 49.5565C32.1885 46.4598 46.3628 30.5521 46.3628 18.8058C46.3628 8.69704 38.5106 0.501953 28.8222 0.501953C19.1339 0.501953 11.2793 8.69704 11.2793 18.8058Z",
    fill: "url(#paint137_radial_19952_150379)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8979 18.8058C18.8979 13.081 23.3445 8.43956 28.832 8.43956C34.3195 8.43956 38.7661 13.081 38.7661 18.8058C38.7661 24.5305 34.3195 29.172 28.832 29.172C23.3445 29.172 18.8979 24.5305 18.8979 18.8058ZM11.2891 18.8058C11.2891 30.5429 25.4611 46.4598 28.3266 49.5565C28.6002 49.8511 29.0569 49.8511 29.3304 49.5565C32.1959 46.4598 46.368 30.5521 46.368 18.8058C46.368 8.69704 38.5157 0.501953 28.8274 0.501953C19.139 0.501953 11.2891 8.69704 11.2891 18.8058Z",
    fill: "url(#paint138_radial_19952_150379)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9073 18.8058C18.9073 13.081 23.3539 8.43956 28.8391 8.43956C34.3243 8.43956 38.7709 13.081 38.7709 18.8058C38.7709 24.5305 34.3243 29.172 28.8391 29.172C23.3539 29.172 18.9073 24.5305 18.9073 18.8058ZM11.3008 18.8058C11.3008 30.5429 25.4728 46.4598 28.3383 49.5588C28.6119 49.8534 29.0686 49.8534 29.3422 49.5588C32.2076 46.4622 46.3797 30.5521 46.3797 18.8058C46.3797 8.69704 38.5275 0.501953 28.8414 0.501953C19.1553 0.501953 11.3008 8.69704 11.3008 18.8058Z",
    fill: "url(#paint139_radial_19952_150379)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 18.8058C18.9167 13.081 23.3633 8.43956 28.8485 8.43956C34.3337 8.43956 38.7803 13.081 38.7803 18.8058C38.7803 24.5305 34.3337 29.172 28.8485 29.172C23.3633 29.172 18.9167 24.5305 18.9167 18.8058ZM11.3125 18.8058C11.3125 30.5429 25.4846 46.4622 28.35 49.5611C28.6236 49.8557 29.0803 49.8557 29.3539 49.5611C32.2194 46.4622 46.3914 30.5521 46.3914 18.8058C46.3914 8.69704 38.5392 0.501953 28.8531 0.501953C19.1671 0.501953 11.3125 8.69704 11.3125 18.8058Z",
    fill: "url(#paint140_radial_19952_150379)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9268 18.8058C18.9268 13.081 23.3734 8.43956 28.8586 8.43956C34.3438 8.43956 38.7904 13.081 38.7904 18.8058C38.7904 24.5305 34.3438 29.172 28.8586 29.172C23.3734 29.172 18.9268 24.5305 18.9268 18.8058ZM11.3203 18.8058C11.3203 30.5429 25.4924 46.4622 28.3578 49.5634C28.6314 49.858 29.0881 49.8603 29.3617 49.5634C32.2272 46.4645 46.3992 30.5521 46.3992 18.8058C46.3992 8.69704 38.547 0.501953 28.8609 0.501953C19.1749 0.501953 11.3203 8.69704 11.3203 18.8058Z",
    fill: "url(#paint141_radial_19952_150379)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9362 18.8058C18.9362 13.081 23.3828 8.43956 28.868 8.43956C34.3532 8.43956 38.7998 13.081 38.7998 18.8058C38.7998 24.5305 34.3532 29.172 28.868 29.172C23.3828 29.172 18.9362 24.5305 18.9362 18.8058ZM11.332 18.8058C11.332 30.5429 25.5018 46.4645 28.3672 49.5634C28.6408 49.8603 29.0975 49.8603 29.3711 49.5634C32.2366 46.4645 46.4063 30.5498 46.4063 18.8058C46.4063 8.69704 38.5541 0.501953 28.868 0.501953C19.182 0.501953 11.332 8.69704 11.332 18.8058Z",
    fill: "url(#paint142_radial_19952_150379)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9483 18.8058C18.9483 13.081 23.3949 8.43956 28.8801 8.43956C34.3653 8.43956 38.8119 13.081 38.8119 18.8058C38.8119 24.5305 34.3653 29.172 28.8801 29.172C23.3949 29.172 18.9483 24.5305 18.9483 18.8058ZM11.3418 18.8058C11.3418 30.5429 25.5115 46.4668 28.377 49.5658C28.6506 49.8627 29.1073 49.8627 29.3809 49.5658C32.2463 46.4668 46.4161 30.5498 46.4161 18.8058C46.4161 8.69704 38.5638 0.501953 28.8778 0.501953C19.1917 0.501953 11.3418 8.69704 11.3418 18.8058Z",
    fill: "url(#paint143_radial_19952_150379)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9577 18.8058C18.9577 13.081 23.4043 8.43956 28.8895 8.43956C34.3747 8.43956 38.8213 13.081 38.8213 18.8058C38.8213 24.5305 34.3747 29.172 28.8895 29.172C23.4043 29.172 18.9577 24.5305 18.9577 18.8058ZM11.3535 18.8058C11.3535 30.5429 25.5233 46.4668 28.3887 49.5681C28.6623 49.865 29.119 49.865 29.3926 49.5681C32.2581 46.4691 46.4278 30.5498 46.4278 18.8058C46.4278 8.69704 38.5755 0.501953 28.8918 0.501953C19.2081 0.501953 11.3535 8.69704 11.3535 18.8058Z",
    fill: "url(#paint144_radial_19952_150379)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9698 18.8058C18.9698 13.081 23.4164 8.43956 28.9016 8.43956C34.3868 8.43956 38.8334 13.081 38.8334 18.8058C38.8334 24.5305 34.3868 29.172 28.9016 29.172C23.4164 29.172 18.9698 24.5305 18.9698 18.8058ZM11.3633 18.8058C11.3633 30.5429 25.533 46.4691 28.3985 49.5704C28.6721 49.8673 29.1288 49.8673 29.4023 49.5704C32.2678 46.4691 46.4375 30.5498 46.4375 18.8058C46.4375 8.69704 38.5853 0.501953 28.9016 0.501953C19.2178 0.501953 11.3633 8.69704 11.3633 18.8058Z",
    fill: "url(#paint145_radial_19952_150379)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9792 18.8058C18.9792 13.081 23.4258 8.43956 28.911 8.43956C34.3962 8.43956 38.8428 13.081 38.8428 18.8058C38.8428 24.5305 34.3962 29.172 28.911 29.172C23.4258 29.172 18.9792 24.5305 18.9792 18.8058ZM11.375 18.8058C11.375 30.5452 25.5424 46.4691 28.4079 49.5704C28.6815 49.8673 29.1382 49.8673 29.4117 49.5704C32.2772 46.4691 46.4446 30.5475 46.4446 18.8058C46.4446 8.69704 38.5947 0.501953 28.9087 0.501953C19.2226 0.501953 11.375 8.69704 11.375 18.8058Z",
    fill: "url(#paint146_radial_19952_150379)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9913 18.8058C18.9913 13.081 23.4379 8.43956 28.9207 8.43956C34.406 8.43956 38.8502 13.081 38.8502 18.8058C38.8502 24.5305 34.4036 29.172 28.9207 29.172C23.4355 29.172 18.9913 24.5305 18.9913 18.8058ZM11.3848 18.8058C11.3848 30.5452 25.5522 46.4714 28.4177 49.5727C28.6912 49.8696 29.1479 49.8696 29.4215 49.5727C32.287 46.4714 46.4544 30.5498 46.4544 18.8058C46.4544 8.69704 38.6045 0.501953 28.9184 0.501953C19.2324 0.501953 11.3848 8.69704 11.3848 18.8058Z",
    fill: "url(#paint147_radial_19952_150379)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9987 18.8058C18.9987 13.081 23.4453 8.43956 28.9282 8.43956C34.4134 8.43956 38.8577 13.081 38.8577 18.8058C38.8577 24.5305 34.4111 29.172 28.9282 29.172C23.4453 29.172 18.9987 24.5305 18.9987 18.8058ZM11.3945 18.8058C11.3945 30.5452 25.5619 46.4714 28.4274 49.575C28.701 49.8719 29.1577 49.8719 29.4313 49.575C32.2967 46.4738 46.4642 30.5498 46.4642 18.8058C46.4642 8.69704 38.6142 0.501953 28.9305 0.501953C19.2468 0.501953 11.3945 8.69704 11.3945 18.8058Z",
    fill: "url(#paint148_radial_19952_150379)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0108 18.8061C19.0108 13.0814 23.4574 8.43993 28.9403 8.43993C34.4255 8.43993 38.8698 13.0814 38.8698 18.8061C38.8698 24.5309 34.4232 29.1724 28.9403 29.1724C23.4551 29.1724 19.0108 24.5309 19.0108 18.8061ZM11.4043 18.8061C11.4043 30.5455 25.5717 46.4741 28.4372 49.5754C28.7108 49.8723 29.1675 49.8723 29.441 49.5754C32.3065 46.4741 46.4739 30.5479 46.4739 18.8038C46.4739 8.69508 38.624 0.5 28.9403 0.5C19.2565 0.5 11.4043 8.6974 11.4043 18.8061Z",
    fill: "url(#paint149_radial_19952_150379)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0202 18.8058C19.0202 13.081 23.4668 8.43956 28.9497 8.43956C34.4326 8.43956 38.8792 13.081 38.8792 18.8058C38.8792 24.5305 34.4326 29.172 28.9497 29.172C23.4668 29.172 19.0202 24.5305 19.0202 18.8058ZM11.416 18.8058C11.416 30.5452 25.5811 46.4761 28.4489 49.5774C28.7225 49.8743 29.1792 49.8743 29.4528 49.5774C32.3182 46.4761 46.4833 30.5475 46.4833 18.8058C46.4833 8.69704 38.6334 0.501953 28.9497 0.501953C19.2659 0.504273 11.416 8.69704 11.416 18.8058Z",
    fill: "url(#paint150_radial_19952_150379)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0296 18.8058C19.0296 13.081 23.4762 8.43956 28.9591 8.43956C34.442 8.43956 38.8886 13.081 38.8886 18.8058C38.8886 24.5305 34.442 29.172 28.9591 29.172C23.4762 29.172 19.0296 24.5305 19.0296 18.8058ZM11.4277 18.8058C11.4277 30.5452 25.5928 46.4761 28.4583 49.5797C28.7319 49.8766 29.1886 49.8766 29.4622 49.5797C32.3276 46.4761 46.4927 30.5475 46.4927 18.8058C46.4927 8.69704 38.6428 0.501953 28.9591 0.501953C19.2753 0.501953 11.4277 8.69704 11.4277 18.8058Z",
    fill: "url(#paint151_radial_19952_150379)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0417 18.8058C19.0417 13.081 23.4859 8.43956 28.9712 8.43956C34.4564 8.43956 38.9006 13.081 38.9006 18.8058C38.9006 24.5305 34.4564 29.172 28.9712 29.172C23.4859 29.172 19.0417 24.5305 19.0417 18.8058ZM11.4375 18.8058C11.4375 30.5452 25.6026 46.4784 28.4681 49.582C28.7416 49.8789 29.1984 49.8789 29.4719 49.582C32.3374 46.4784 46.5025 30.5475 46.5025 18.8058C46.5025 8.69704 38.6526 0.501953 28.9688 0.501953C19.2851 0.501953 11.4375 8.69704 11.4375 18.8058Z",
    fill: "url(#paint152_radial_19952_150379)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0511 18.8058C19.0511 13.081 23.4953 8.43956 28.9806 8.43956C34.4634 8.43956 38.91 13.081 38.91 18.8058C38.91 24.5305 34.4658 29.172 28.9806 29.172C23.4977 29.172 19.0511 24.5305 19.0511 18.8058ZM11.4492 18.8058C11.4492 30.5452 25.6143 46.4784 28.4798 49.582C28.7534 49.8789 29.2101 49.8789 29.4836 49.582C32.3491 46.4784 46.5142 30.5452 46.5142 18.8058C46.5142 8.69704 38.6643 0.501953 28.9829 0.501953C19.3015 0.501953 11.4492 8.69704 11.4492 18.8058Z",
    fill: "url(#paint153_radial_19952_150379)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0632 18.8058C19.0632 13.081 23.5074 8.43956 28.9926 8.43956C34.4755 8.43956 38.9221 13.081 38.9221 18.8058C38.9221 24.5305 34.4778 29.172 28.9926 29.172C23.5074 29.172 19.0632 24.5305 19.0632 18.8058ZM11.459 18.8058C11.459 30.5452 25.6218 46.4807 28.4896 49.5843C28.7631 49.8812 29.2198 49.8812 29.4934 49.5843C32.3589 46.4807 46.524 30.5452 46.524 18.8058C46.524 8.69704 38.6741 0.501953 28.9926 0.501953C19.3112 0.501953 11.459 8.69704 11.459 18.8058Z",
    fill: "url(#paint154_radial_19952_150379)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0706 18.8058C19.0706 13.081 23.5149 8.43956 28.9978 8.43956C34.4807 8.43956 38.9249 13.081 38.9249 18.8058C38.9249 24.5305 34.4807 29.172 28.9978 29.172C23.5172 29.172 19.0706 24.5305 19.0706 18.8058ZM11.4688 18.8058C11.4688 30.5452 25.6315 46.4807 28.497 49.5866C28.7706 49.8835 29.2273 49.8835 29.5009 49.5866C32.3663 46.483 46.5291 30.5452 46.5291 18.8058C46.5291 8.69704 38.6792 0.501953 28.9978 0.501953C19.3164 0.501953 11.4688 8.69704 11.4688 18.8058Z",
    fill: "url(#paint155_radial_19952_150379)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0827 18.8058C19.0827 13.081 23.527 8.43956 29.0099 8.43956C34.4927 8.43956 38.937 13.081 38.937 18.8058C38.937 24.5305 34.4927 29.172 29.0099 29.172C23.527 29.172 19.0827 24.5305 19.0827 18.8058ZM11.4785 18.8058C11.4785 30.5475 25.6413 46.483 28.5068 49.589C28.7803 49.8859 29.237 49.8859 29.5106 49.589C32.3761 46.483 46.5389 30.5475 46.5389 18.8058C46.5389 8.69704 38.6913 0.501953 29.0075 0.501953C19.3238 0.501953 11.4785 8.69704 11.4785 18.8058Z",
    fill: "url(#paint156_radial_19952_150379)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0921 18.8058C19.0921 13.081 23.5364 8.43956 29.0193 8.43956C34.5021 8.43956 38.9464 13.081 38.9464 18.8058C38.9464 24.5305 34.5021 29.172 29.0193 29.172C23.5364 29.172 19.0921 24.5305 19.0921 18.8058ZM11.4902 18.8058C11.4902 30.5475 25.653 46.4854 28.5185 49.589C28.7921 49.8859 29.2488 49.8859 29.5223 49.589C32.3878 46.483 46.5506 30.5452 46.5506 18.8058C46.5506 8.69704 38.703 0.501953 29.0216 0.501953C19.3402 0.501953 11.4902 8.69704 11.4902 18.8058Z",
    fill: "url(#paint157_radial_19952_150379)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1042 18.8058C19.1042 13.081 23.5484 8.43956 29.0313 8.43956C34.5142 8.43956 38.9585 13.081 38.9585 18.8058C38.9585 24.5305 34.5142 29.172 29.0313 29.172C23.5484 29.172 19.1042 24.5305 19.1042 18.8058ZM11.5 18.8058C11.5 30.5475 25.6605 46.4853 28.5283 49.5913C28.8018 49.8882 29.2585 49.8882 29.5321 49.5913C32.3976 46.4853 46.5604 30.5452 46.5604 18.8058C46.5604 8.69704 38.7128 0.501953 29.0313 0.501953C19.3499 0.501953 11.5 8.69704 11.5 18.8058Z",
    fill: "url(#paint158_radial_19952_150379)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1136 18.8058C19.1136 13.081 23.5579 8.43956 29.0407 8.43956C34.5236 8.43956 38.9679 13.081 38.9679 18.8058C38.9679 24.5305 34.5236 29.172 29.0407 29.172C23.5579 29.172 19.1136 24.5305 19.1136 18.8058ZM11.5117 18.8058C11.5117 30.5475 25.6722 46.4877 28.5377 49.5936C28.8112 49.8905 29.2679 49.8905 29.5415 49.5936C32.407 46.4877 46.5674 30.5452 46.5674 18.8058C46.5674 8.69704 38.7198 0.501953 29.0384 0.501953C19.357 0.501953 11.5117 8.69704 11.5117 18.8058Z",
    fill: "url(#paint159_radial_19952_150379)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1233 18.8058C19.1233 13.081 23.5676 8.43956 29.0505 8.43956C34.5334 8.43956 38.9777 13.081 38.9777 18.8058C38.9777 24.5305 34.5334 29.172 29.0505 29.172C23.5676 29.172 19.1233 24.5305 19.1233 18.8058ZM11.5215 18.8058C11.5215 30.5475 25.682 46.4877 28.5474 49.5959C28.821 49.8928 29.2777 49.8928 29.5513 49.5959C32.4168 46.49 46.5772 30.5452 46.5772 18.8058C46.5772 8.69704 38.7296 0.501953 29.0482 0.501953C19.3668 0.501953 11.5215 8.69704 11.5215 18.8058Z",
    fill: "url(#paint160_radial_19952_150379)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1351 18.8058C19.1351 13.081 23.5793 8.43956 29.0622 8.43956C34.5451 8.43956 38.9894 13.081 38.9894 18.8058C38.9894 24.5305 34.5451 29.172 29.0622 29.172C23.5793 29.172 19.1351 24.5305 19.1351 18.8058ZM11.5332 18.8058C11.5332 30.5475 25.6937 46.49 28.5591 49.5959C28.8327 49.8928 29.2894 49.8928 29.563 49.5959C32.4285 46.4877 46.5889 30.5429 46.5889 18.8058C46.5889 8.69704 38.7413 0.501953 29.0599 0.501953C19.3785 0.501953 11.5332 8.69704 11.5332 18.8058Z",
    fill: "url(#paint161_radial_19952_150379)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1425 18.8058C19.1425 13.081 23.5868 8.43956 29.0697 8.43956C34.5526 8.43956 38.9968 13.081 38.9968 18.8058C38.9968 24.5305 34.5526 29.172 29.0697 29.172C23.5868 29.172 19.1425 24.5305 19.1425 18.8058ZM11.543 18.8058C11.543 30.5475 25.7011 46.4923 28.5689 49.5982C28.8425 49.8951 29.2992 49.8951 29.5728 49.5982C32.4382 46.49 46.5987 30.5429 46.5987 18.8058C46.5987 8.69704 38.7511 0.501953 29.072 0.501953C19.3929 0.501953 11.543 8.69704 11.543 18.8058Z",
    fill: "url(#paint162_radial_19952_150379)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1546 18.8058C19.1546 13.081 23.5989 8.43956 29.0794 8.43956C34.56 8.43956 39.0043 13.081 39.0043 18.8058C39.0043 24.5305 34.56 29.172 29.0794 29.172C23.5989 29.172 19.1546 24.5305 19.1546 18.8058ZM11.5527 18.8058C11.5527 30.5475 25.7109 46.4923 28.5764 49.6006C28.8499 49.8975 29.3066 49.8975 29.5802 49.6006C32.4457 46.4923 46.6038 30.5429 46.6038 18.8058C46.6038 8.69704 38.7562 0.501953 29.0771 0.501953C19.398 0.501953 11.5527 8.69704 11.5527 18.8058Z",
    fill: "url(#paint163_radial_19952_150379)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M19.164 18.8058C19.164 13.081 23.6083 8.43956 29.0888 8.43956C34.5694 8.43956 39.0137 13.081 39.0137 18.8058C39.0137 24.5305 34.5694 29.172 29.0888 29.172C23.6083 29.172 19.164 24.5305 19.164 18.8058ZM11.5645 18.8058C11.5645 30.5475 25.7226 46.4946 28.5881 49.6029C28.8616 49.8998 29.3184 49.8998 29.5919 49.6029C32.4574 46.4946 46.6155 30.5429 46.6155 18.8058C46.6155 8.69704 38.7679 0.501953 29.0888 0.501953C19.4097 0.501953 11.5645 8.69704 11.5645 18.8058Z",
    fill: "url(#paint164_radial_19952_150379)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1761 18.8058C19.1761 13.081 23.6203 8.43956 29.1009 8.43956C34.5815 8.43956 39.0258 13.081 39.0258 18.8058C39.0258 24.5305 34.5815 29.172 29.1009 29.172C23.6203 29.172 19.1761 24.5305 19.1761 18.8058ZM11.5742 18.8058C11.5742 30.5475 25.7324 46.4946 28.5978 49.6029C28.8714 49.8998 29.3281 49.8998 29.6017 49.6029C32.4672 46.4946 46.6253 30.5429 46.6253 18.8058C46.6253 8.69704 38.7777 0.501953 29.0986 0.501953C19.4195 0.501953 11.5742 8.69704 11.5742 18.8058Z",
    fill: "url(#paint165_radial_19952_150379)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1855 18.8058C19.1855 13.081 23.6298 8.43956 29.1103 8.43956C34.5909 8.43956 39.0352 13.081 39.0352 18.8058C39.0352 24.5305 34.5909 29.172 29.1103 29.172C23.6298 29.172 19.1855 24.5305 19.1855 18.8058ZM11.5859 18.8058C11.5859 30.5498 25.7418 46.4969 28.6096 49.6052C28.8831 49.9021 29.3398 49.9021 29.6134 49.6052C32.4789 46.4946 46.637 30.5429 46.637 18.8058C46.637 8.69704 38.7917 0.501953 29.1126 0.501953C19.4335 0.501953 11.5859 8.69704 11.5859 18.8058Z",
    fill: "url(#paint166_radial_19952_150379)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1976 18.8058C19.1976 13.081 23.6418 8.43956 29.1224 8.43956C34.603 8.43956 39.0472 13.081 39.0472 18.8058C39.0472 24.5305 34.603 29.172 29.1224 29.172C23.6418 29.172 19.1976 24.5305 19.1976 18.8058ZM11.5957 18.8058C11.5957 30.5498 25.7515 46.4969 28.617 49.6075C28.8906 49.9044 29.3473 49.9044 29.6209 49.6075C32.4863 46.4969 46.6445 30.5429 46.6445 18.8058C46.6445 8.69704 38.7992 0.501953 29.1201 0.501953C19.441 0.501953 11.5957 8.69704 11.5957 18.8058Z",
    fill: "url(#paint167_radial_19952_150379)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M19.205 18.8054C19.205 13.0807 23.6493 8.4392 29.1299 8.4392C34.6104 8.4392 39.0547 13.0807 39.0547 18.8054C39.0547 24.5301 34.6104 29.1716 29.1299 29.1716C23.6493 29.1716 19.205 24.5301 19.205 18.8054ZM11.6055 18.8054C11.6055 30.5495 25.7613 46.4989 28.6268 49.6095C28.9003 49.9064 29.357 49.9064 29.6306 49.6095C32.4961 46.4989 46.6519 30.5425 46.6519 18.8077C46.6519 8.69899 38.8066 0.503906 29.1275 0.503906C19.4484 0.503906 11.6055 8.69667 11.6055 18.8054Z",
    fill: "url(#paint168_radial_19952_150379)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2171 18.8058C19.2171 13.081 23.6614 8.43956 29.1419 8.43956C34.6225 8.43956 39.0668 13.081 39.0668 18.8058C39.0668 24.5305 34.6225 29.172 29.1419 29.172C23.659 29.172 19.2171 24.5305 19.2171 18.8058ZM11.6152 18.8058C11.6152 30.5498 25.7711 46.5016 28.6365 49.6098C28.9101 49.9067 29.3668 49.9067 29.6404 49.6098C32.5059 46.4993 46.6617 30.5405 46.6617 18.8058C46.6617 8.69704 38.8164 0.501953 29.1373 0.501953C19.4582 0.501953 11.6152 8.69704 11.6152 18.8058Z",
    fill: "url(#paint169_radial_19952_150379)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2265 18.8058C19.2265 13.081 23.6684 8.43956 29.1513 8.43956C34.6319 8.43956 39.0762 13.081 39.0762 18.8058C39.0762 24.5305 34.6342 29.172 29.1513 29.172C23.6684 29.172 19.2265 24.5305 19.2265 18.8058ZM11.627 18.8058C11.627 30.5498 25.7805 46.5016 28.6483 49.6122C28.9218 49.9091 29.3809 49.9091 29.6544 49.6122C32.5199 46.5016 46.6757 30.5405 46.6757 18.8058C46.6757 8.69704 38.8304 0.501953 29.1513 0.501953C19.4722 0.501953 11.627 8.69704 11.627 18.8058Z",
    fill: "url(#paint170_radial_19952_150379)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2363 18.8058C19.2363 13.081 23.6782 8.43956 29.1588 8.43956C34.6394 8.43956 39.0813 13.081 39.0813 18.8058C39.0813 24.5305 34.6394 29.172 29.1588 29.172C23.6782 29.172 19.2363 24.5305 19.2363 18.8058ZM11.6367 18.8058C11.6367 30.5498 25.7902 46.5039 28.658 49.6145C28.9316 49.9114 29.3906 49.9114 29.6642 49.6145C32.5297 46.5016 46.6855 30.5405 46.6855 18.8058C46.6855 8.69704 38.8402 0.501953 29.1634 0.501953C19.4866 0.501953 11.6367 8.69704 11.6367 18.8058Z",
    fill: "url(#paint171_radial_19952_150379)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M19.248 18.8058C19.248 13.081 23.6899 8.43956 29.1705 8.43956C34.6511 8.43956 39.093 13.081 39.093 18.8058C39.093 24.5305 34.6511 29.172 29.1705 29.172C23.6899 29.172 19.248 24.5305 19.248 18.8058ZM11.6484 18.8058C11.6484 30.5498 25.8019 46.5039 28.6674 49.6145C28.941 49.9114 29.4 49.9114 29.6736 49.6145C32.5391 46.5016 46.6926 30.5382 46.6926 18.8058C46.6926 8.69704 38.8473 0.501953 29.1705 0.501953C19.4937 0.501953 11.6484 8.69704 11.6484 18.8058Z",
    fill: "url(#paint172_radial_19952_150379)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2574 18.8058C19.2574 13.081 23.6993 8.43956 29.1799 8.43956C34.6605 8.43956 39.1024 13.081 39.1024 18.8058C39.1024 24.5305 34.6605 29.172 29.1799 29.172C23.6993 29.172 19.2574 24.5305 19.2574 18.8058ZM11.6602 18.8058C11.6602 30.5498 25.8137 46.5062 28.6791 49.6168C28.9527 49.9137 29.4117 49.9137 29.6853 49.6168C32.5508 46.5039 46.7043 30.5382 46.7043 18.8058C46.7043 8.69704 38.859 0.501953 29.1822 0.501953C19.5054 0.501953 11.6602 8.69704 11.6602 18.8058Z",
    fill: "url(#paint173_radial_19952_150379)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2695 18.8058C19.2695 13.081 23.7114 8.43956 29.192 8.43956C34.6726 8.43956 39.1145 13.081 39.1145 18.8058C39.1145 24.5305 34.6726 29.172 29.192 29.172C23.7114 29.172 19.2695 24.5305 19.2695 18.8058ZM11.6699 18.8058C11.6699 30.5498 25.8211 46.5062 28.6889 49.6191C28.9625 49.916 29.4215 49.916 29.6951 49.6191C32.5605 46.5062 46.7141 30.5405 46.7141 18.8058C46.7141 8.69704 38.8688 0.501953 29.192 0.501953C19.5152 0.501953 11.6699 8.69704 11.6699 18.8058Z",
    fill: "url(#paint174_radial_19952_150379)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2769 18.8058C19.2769 13.081 23.7189 8.43956 29.1994 8.43956C34.68 8.43956 39.122 13.081 39.122 18.8058C39.122 24.5305 34.68 29.172 29.1994 29.172C23.7189 29.172 19.2769 24.5305 19.2769 18.8058ZM11.6797 18.8058C11.6797 30.5521 25.8309 46.5085 28.6987 49.6214C28.9722 49.9183 29.4313 49.9183 29.7048 49.6214C32.5703 46.5085 46.7238 30.5405 46.7238 18.8058C46.7238 8.69704 38.8785 0.501953 29.2041 0.501953C19.5296 0.501953 11.6797 8.69704 11.6797 18.8058Z",
    fill: "url(#paint175_radial_19952_150379)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M19.289 18.8058C19.289 13.081 23.7309 8.43956 29.2115 8.43956C34.6921 8.43956 39.134 13.081 39.134 18.8058C39.134 24.5305 34.6921 29.172 29.2115 29.172C23.7309 29.172 19.289 24.5305 19.289 18.8058ZM11.6895 18.8058C11.6895 30.5521 25.8406 46.5109 28.7061 49.6214C28.9797 49.9183 29.4387 49.9183 29.7123 49.6214C32.5778 46.5062 46.729 30.5382 46.729 18.8058C46.729 8.69704 38.886 0.501953 29.2092 0.501953C19.5324 0.501953 11.6895 8.69704 11.6895 18.8058Z",
    fill: "url(#paint176_radial_19952_150379)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2984 18.8058C19.2984 13.081 23.7403 8.43956 29.2209 8.43956C34.7015 8.43956 39.1434 13.081 39.1434 18.8058C39.1434 24.5305 34.7015 29.172 29.2209 29.172C23.7403 29.172 19.2984 24.5305 19.2984 18.8058ZM11.7012 18.8058C11.7012 30.5521 25.8524 46.5109 28.7178 49.6237C28.9914 49.9207 29.4504 49.9207 29.724 49.6237C32.5895 46.5085 46.7407 30.5382 46.7407 18.8058C46.7407 8.69704 38.8977 0.501953 29.2209 0.501953C19.5441 0.501953 11.7012 8.69704 11.7012 18.8058Z",
    fill: "url(#paint177_radial_19952_150379)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3105 18.8058C19.3105 13.081 23.7524 8.43956 29.233 8.43956C34.7136 8.43956 39.1555 13.081 39.1555 18.8058C39.1555 24.5305 34.7136 29.172 29.233 29.172C23.7524 29.172 19.3105 24.5305 19.3105 18.8058ZM11.7109 18.8058C11.7109 30.5521 25.8598 46.5132 28.7276 49.6261C29.0012 49.923 29.4602 49.923 29.7338 49.6261C32.5992 46.5109 46.7504 30.5382 46.7504 18.8058C46.7504 8.69704 38.9075 0.501953 29.2307 0.501953C19.5539 0.501953 11.7109 8.69704 11.7109 18.8058Z",
    fill: "url(#paint178_radial_19952_150379)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3199 18.8058C19.3199 13.081 23.7618 8.43956 29.2401 8.43956C34.7183 8.43956 39.1603 13.081 39.1603 18.8058C39.1603 24.5305 34.7183 29.172 29.2401 29.172C23.7618 29.172 19.3199 24.5305 19.3199 18.8058ZM11.7227 18.8058C11.7227 30.5521 25.8715 46.5132 28.7393 49.6284C29.0129 49.9253 29.4719 49.9253 29.7455 49.6284C32.611 46.5132 46.7621 30.5382 46.7621 18.8058C46.7621 8.69704 38.9192 0.501953 29.2424 0.501953C19.5656 0.501953 11.7227 8.69704 11.7227 18.8058Z",
    fill: "url(#paint179_radial_19952_150379)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3296 18.8058C19.3296 13.081 23.7716 8.43956 29.2499 8.43956C34.7281 8.43956 39.1701 13.081 39.1701 18.8058C39.1701 24.5305 34.7281 29.172 29.2499 29.172C23.7716 29.172 19.3296 24.5305 19.3296 18.8058ZM11.7324 18.8058C11.7324 30.5521 25.8813 46.5155 28.7468 49.6284C29.0203 49.9253 29.4794 49.9253 29.7529 49.6284C32.6184 46.5132 46.7673 30.5359 46.7673 18.8058C46.7673 8.69704 38.9243 0.501953 29.2499 0.501953C19.5754 0.501953 11.7324 8.69704 11.7324 18.8058Z",
    fill: "url(#paint180_radial_19952_150379)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3414 18.8058C19.3414 13.081 23.7833 8.43956 29.2616 8.43956C34.7398 8.43956 39.1818 13.081 39.1818 18.8058C39.1818 24.5305 34.7398 29.172 29.2616 29.172C23.7833 29.172 19.3414 24.5305 19.3414 18.8058ZM11.7441 18.8058C11.7441 30.5521 25.893 46.5155 28.7585 49.6307C29.0321 49.9276 29.4911 49.9276 29.7647 49.6307C32.6301 46.5132 46.779 30.5359 46.779 18.8058C46.779 8.69704 38.936 0.501953 29.2616 0.501953C19.5871 0.501953 11.7441 8.69704 11.7441 18.8058Z",
    fill: "url(#paint181_radial_19952_150379)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3492 18.8058C19.3492 13.081 23.7911 8.43956 29.2694 8.43956C34.7476 8.43956 39.1896 13.081 39.1896 18.8058C39.1896 24.5305 34.7476 29.172 29.2694 29.172C23.7911 29.172 19.3492 24.5305 19.3492 18.8058ZM11.752 18.8058C11.752 30.5521 25.8985 46.5178 28.7663 49.633C29.0399 49.9299 29.4989 49.9299 29.7725 49.633C32.6379 46.5155 46.7868 30.5359 46.7868 18.8058C46.7868 8.69704 38.9438 0.501953 29.2694 0.501953C19.5949 0.501953 11.752 8.69704 11.752 18.8058Z",
    fill: "url(#paint182_radial_19952_150379)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3609 18.8054C19.3609 13.0807 23.8028 8.4392 29.2811 8.4392C34.7594 8.4392 39.2013 13.0807 39.2013 18.8054C39.2013 24.5301 34.7594 29.1716 29.2811 29.1716C23.8028 29.1716 19.3609 24.5301 19.3609 18.8054ZM11.7637 18.8054C11.7637 30.5518 25.9102 46.5198 28.778 49.635C29.0516 49.9319 29.5106 49.9319 29.7842 49.635C32.6497 46.5175 46.7985 30.5379 46.7985 18.8077C46.7985 8.69899 38.9556 0.503906 29.2811 0.503906C19.6066 0.503906 11.7637 8.69667 11.7637 18.8054Z",
    fill: "url(#paint183_radial_19952_150379)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3703 18.8058C19.3703 13.081 23.8122 8.43956 29.2905 8.43956C34.7688 8.43956 39.2107 13.081 39.2107 18.8058C39.2107 24.5305 34.7688 29.172 29.2905 29.172C23.8122 29.172 19.3703 24.5305 19.3703 18.8058ZM11.7754 18.8058C11.7754 30.5521 25.9219 46.5201 28.7874 49.6353C29.061 49.9323 29.52 49.9323 29.7936 49.6353C32.6591 46.5178 46.8079 30.5359 46.8079 18.8058C46.8079 8.69704 38.965 0.501953 29.2928 0.501953C19.6207 0.501953 11.7754 8.69704 11.7754 18.8058Z",
    fill: "url(#paint184_radial_19952_150379)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3824 18.8058C19.3824 13.081 23.8243 8.43956 29.3026 8.43956C34.7808 8.43956 39.2228 13.081 39.2228 18.8058C39.2228 24.5305 34.7808 29.172 29.3026 29.172C23.8243 29.172 19.3824 24.5305 19.3824 18.8058ZM11.7852 18.8058C11.7852 30.5545 25.9317 46.5225 28.7972 49.6377C29.0708 49.9346 29.5298 49.9346 29.8033 49.6377C32.6688 46.5201 46.8154 30.5359 46.8154 18.8058C46.8154 8.69704 38.9724 0.501953 29.3003 0.501953C19.6281 0.501953 11.7852 8.69704 11.7852 18.8058Z",
    fill: "url(#paint185_radial_19952_150379)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3918 18.8058C19.3918 13.081 23.8337 8.43956 29.312 8.43956C34.7902 8.43956 39.2322 13.081 39.2322 18.8058C39.2322 24.5305 34.7902 29.172 29.312 29.172C23.8337 29.172 19.3918 24.5305 19.3918 18.8058ZM11.7969 18.8058C11.7969 30.5545 25.9411 46.5225 28.8089 49.64C29.0825 49.9369 29.5415 49.9369 29.8151 49.64C32.6805 46.5201 46.8271 30.5359 46.8271 18.8058C46.8271 8.69704 38.9864 0.501953 29.312 0.501953C19.6375 0.501953 11.7969 8.69704 11.7969 18.8058Z",
    fill: "url(#paint186_radial_19952_150379)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4039 18.8054C19.4039 13.0807 23.8458 8.4392 29.3218 8.4392C34.7977 8.4392 39.2396 13.0807 39.2396 18.8054C39.2396 24.5301 34.7977 29.1716 29.3218 29.1716C23.8458 29.1716 19.4039 24.5301 19.4039 18.8054ZM11.8066 18.8054C11.8066 30.5541 25.9509 46.5244 28.8187 49.6419C29.0922 49.9388 29.5513 49.9388 29.8248 49.6419C32.6903 46.5221 46.8369 30.5355 46.8369 18.8077C46.8369 8.69899 38.9962 0.503906 29.3218 0.503906C19.6473 0.503906 11.8066 8.69667 11.8066 18.8054Z",
    fill: "url(#paint187_radial_19952_150379)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4133 18.8058C19.4133 13.081 23.8529 8.43956 29.3312 8.43956C34.8094 8.43956 39.249 13.081 39.249 18.8058C39.249 24.5305 34.8094 29.172 29.3312 29.172C23.8529 29.172 19.4133 24.5305 19.4133 18.8058ZM11.8184 18.8058C11.8184 30.5545 25.9626 46.5248 28.8281 49.6423C29.1016 49.9392 29.5607 49.9392 29.8342 49.6423C32.6997 46.5225 46.8463 30.5336 46.8463 18.8058C46.8463 8.69704 39.0056 0.501953 29.3312 0.501953C19.6567 0.501953 11.8184 8.69704 11.8184 18.8058Z",
    fill: "url(#paint188_radial_19952_150379)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4234 18.8058C19.4234 13.081 23.863 8.43956 29.3413 8.43956C34.8195 8.43956 39.2592 13.081 39.2592 18.8058C39.2592 24.5305 34.8195 29.172 29.3413 29.172C23.863 29.172 19.4234 24.5305 19.4234 18.8058ZM11.8262 18.8058C11.8262 30.5545 25.9704 46.5271 28.8359 49.6446C29.1094 49.9415 29.5685 49.9415 29.842 49.6446C32.7075 46.5248 46.8518 30.5336 46.8518 18.8058C46.8518 8.69704 39.0111 0.501953 29.339 0.501953C19.6668 0.501953 11.8262 8.69704 11.8262 18.8058Z",
    fill: "url(#paint189_radial_19952_150379)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4328 18.8058C19.4328 13.081 23.8724 8.43956 29.3507 8.43956C34.8289 8.43956 39.2686 13.081 39.2686 18.8058C39.2686 24.5305 34.8289 29.172 29.3507 29.172C23.8724 29.172 19.4328 24.5305 19.4328 18.8058ZM11.8379 18.8058C11.8379 30.5545 25.9798 46.5294 28.8476 49.6469C29.1212 49.9439 29.5802 49.9439 29.8538 49.6469C32.7192 46.5271 46.8635 30.5336 46.8635 18.8058C46.8635 8.69704 39.0228 0.501953 29.3507 0.501953C19.6785 0.501953 11.8379 8.69704 11.8379 18.8058Z",
    fill: "url(#paint190_radial_19952_150379)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4426 18.8058C19.4426 13.081 23.8822 8.43956 29.3604 8.43956C34.8387 8.43956 39.2783 13.081 39.2783 18.8058C39.2783 24.5305 34.8387 29.172 29.3604 29.172C23.8845 29.172 19.4426 24.5305 19.4426 18.8058ZM11.8477 18.8058C11.8477 30.5545 25.9896 46.5294 28.8574 49.6469C29.1309 49.9439 29.59 49.9439 29.8635 49.6469C32.729 46.5248 46.8732 30.5313 46.8732 18.8058C46.8732 8.69704 39.0326 0.501953 29.3604 0.501953C19.6883 0.501953 11.8477 8.69704 11.8477 18.8058Z",
    fill: "url(#paint191_radial_19952_150379)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4543 18.8058C19.4543 13.081 23.8939 8.43956 29.3722 8.43956C34.8504 8.43956 39.2901 13.081 39.2901 18.8058C39.2901 24.5305 34.8504 29.172 29.3722 29.172C23.8939 29.172 19.4543 24.5305 19.4543 18.8058ZM11.8594 18.8058C11.8594 30.5545 26.0013 46.5317 28.8691 49.6493C29.1427 49.9462 29.6017 49.9462 29.8752 49.6493C32.7407 46.5271 46.885 30.5336 46.885 18.8058C46.885 8.69704 39.0443 0.501953 29.3722 0.501953C19.7 0.501953 11.8594 8.69704 11.8594 18.8058Z",
    fill: "url(#paint192_radial_19952_150379)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4637 18.8058C19.4637 13.081 23.9033 8.43956 29.3816 8.43956C34.8575 8.43956 39.2995 13.081 39.2995 18.8058C39.2995 24.5305 34.8598 29.172 29.3816 29.172C23.9033 29.172 19.4637 24.5305 19.4637 18.8058ZM11.8711 18.8058C11.8711 30.5545 26.013 46.5317 28.8785 49.6516C29.1521 49.9485 29.6111 49.9485 29.8846 49.6516C32.7501 46.5294 46.892 30.5336 46.892 18.8058C46.892 8.69704 39.0514 0.501953 29.3816 0.501953C19.7117 0.501953 11.8711 8.69704 11.8711 18.8058Z",
    fill: "url(#paint193_radial_19952_150379)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4758 18.8058C19.4758 13.081 23.9154 8.43956 29.3937 8.43956C34.8696 8.43956 39.3115 13.081 39.3115 18.8058C39.3115 24.5305 34.8719 29.172 29.3937 29.172C23.9154 29.172 19.4758 24.5305 19.4758 18.8058ZM11.8809 18.8058C11.8809 30.5545 26.0205 46.5341 28.8883 49.6539C29.1618 49.9508 29.6208 49.9508 29.8944 49.6539C32.7622 46.5317 46.9018 30.5313 46.9018 18.8058C46.9018 8.69704 39.0612 0.501953 29.3913 0.501953C19.7215 0.501953 11.8809 8.69704 11.8809 18.8058Z",
    fill: "url(#paint194_radial_19952_150379)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4832 18.8058C19.4832 13.081 23.9228 8.43956 29.3988 8.43956C34.8747 8.43956 39.3144 13.081 39.3144 18.8058C39.3144 24.5305 34.8747 29.172 29.3988 29.172C23.9228 29.172 19.4832 24.5305 19.4832 18.8058ZM11.8906 18.8058C11.8906 30.5568 26.0302 46.5364 28.898 49.6539C29.1716 49.9508 29.6306 49.9508 29.9042 49.6539C32.7697 46.5317 46.9116 30.5313 46.9116 18.8058C46.9116 8.69704 39.0709 0.501953 29.4011 0.501953C19.7313 0.501953 11.8906 8.69704 11.8906 18.8058Z",
    fill: "url(#paint195_radial_19952_150379)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4953 18.8058C19.4953 13.081 23.9349 8.43956 29.4109 8.43956C34.8868 8.43956 39.3264 13.081 39.3264 18.8058C39.3264 24.5305 34.8868 29.172 29.4109 29.172C23.9349 29.172 19.4953 24.5305 19.4953 18.8058ZM11.9004 18.8058C11.9004 30.5568 26.04 46.5364 28.9078 49.6562C29.1813 49.9531 29.6404 49.9531 29.9139 49.6562C32.7794 46.5317 46.9213 30.5313 46.9213 18.8058C46.9213 8.69704 39.083 0.501953 29.4109 0.501953C19.7387 0.501953 11.9004 8.69704 11.9004 18.8058Z",
    fill: "url(#paint196_radial_19952_150379)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5047 18.8058C19.5047 13.081 23.9443 8.43956 29.4203 8.43956C34.8962 8.43956 39.3358 13.081 39.3358 18.8058C39.3358 24.5305 34.8962 29.172 29.4203 29.172C23.9443 29.172 19.5047 24.5305 19.5047 18.8058ZM11.9121 18.8058C11.9121 30.5568 26.0517 46.5387 28.9172 49.6585C29.1908 49.9578 29.6498 49.9554 29.9233 49.6585C32.7888 46.5341 46.9307 30.5313 46.9307 18.8058C46.9307 8.69704 39.0924 0.501953 29.4203 0.501953C19.7481 0.501953 11.9121 8.69704 11.9121 18.8058Z",
    fill: "url(#paint197_radial_19952_150379)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5168 18.8054C19.5168 13.0807 23.9564 8.4392 29.4324 8.4392C34.9083 8.4392 39.3479 13.0807 39.3479 18.8054C39.3479 24.5301 34.9083 29.1716 29.4324 29.1716C23.9564 29.1716 19.5168 24.5301 19.5168 18.8054ZM11.9219 18.8054C11.9219 30.5564 26.0592 46.5383 28.9269 49.6605C29.2005 49.9597 29.6595 49.9574 29.9331 49.6605C32.7986 46.536 46.9382 30.5309 46.9382 18.8077C46.9382 8.69899 39.0999 0.503906 29.43 0.503906C19.7602 0.503906 11.9219 8.69667 11.9219 18.8054Z",
    fill: "url(#paint198_radial_19952_150379)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5262 18.8058C19.5262 13.081 23.9658 8.43956 29.4417 8.43956C34.9177 8.43956 39.3573 13.081 39.3573 18.8058C39.3573 24.5305 34.9177 29.172 29.4417 29.172C23.9658 29.172 19.5262 24.5305 19.5262 18.8058ZM11.9336 18.8058C11.9336 30.5568 26.0709 46.541 28.9387 49.6609C29.2122 49.9601 29.6713 49.9578 29.9448 49.6609C32.8103 46.5364 46.9499 30.5289 46.9499 18.8058C46.9499 8.69704 39.1116 0.501953 29.4417 0.501953C19.7719 0.501953 11.9336 8.69704 11.9336 18.8058Z",
    fill: "url(#paint199_radial_19952_150379)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5359 18.8058C19.5359 13.081 23.9756 8.43956 29.4515 8.43956C34.9275 8.43956 39.3671 13.081 39.3671 18.8058C39.3671 24.5305 34.9275 29.172 29.4515 29.172C23.9756 29.172 19.5359 24.5305 19.5359 18.8058ZM11.9434 18.8058C11.9434 30.5568 26.0806 46.541 28.9484 49.6632C29.222 49.9624 29.681 49.9601 29.9546 49.6632C32.8201 46.5387 46.9597 30.5289 46.9597 18.8058C46.9597 8.69704 39.1213 0.501953 29.4515 0.501953C19.7817 0.501953 11.9434 8.69704 11.9434 18.8058Z",
    fill: "url(#paint200_radial_19952_150379)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5477 18.8058C19.5477 13.081 23.9873 8.43956 29.4632 8.43956C34.9392 8.43956 39.3788 13.081 39.3788 18.8058C39.3788 24.5305 34.9392 29.172 29.4632 29.172C23.9873 29.172 19.5477 24.5305 19.5477 18.8058ZM11.9551 18.8058C11.9551 30.5568 26.0924 46.5433 28.9578 49.6655C29.2314 49.9647 29.6904 49.9624 29.964 49.6655C32.8295 46.5387 46.9691 30.5289 46.9691 18.8058C46.9691 8.69704 39.1307 0.501953 29.4609 0.501953C19.7911 0.501953 11.9551 8.69704 11.9551 18.8058Z",
    fill: "url(#paint201_radial_19952_150379)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5555 18.8054C19.5555 13.0807 23.9951 8.4392 29.471 8.4392C34.947 8.4392 39.3866 13.0807 39.3866 18.8054C39.3866 24.5301 34.947 29.1716 29.471 29.1716C23.9951 29.1716 19.5555 24.5301 19.5555 18.8054ZM11.9629 18.8054C11.9629 30.5564 26.0979 46.5453 28.9656 49.6674C29.2392 49.9667 29.6982 49.9667 29.9718 49.6674C32.8373 46.5406 46.9746 30.5309 46.9746 18.8077C46.9746 8.69899 39.1362 0.503906 29.4687 0.503906C19.8012 0.503906 11.9629 8.69667 11.9629 18.8054Z",
    fill: "url(#paint202_radial_19952_150379)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5672 18.8058C19.5672 13.081 24.0068 8.43956 29.4804 8.43956C34.9541 8.43956 39.3937 13.081 39.3937 18.8058C39.3937 24.5305 34.9541 29.172 29.4804 29.172C24.0068 29.172 19.5672 24.5305 19.5672 18.8058ZM11.9746 18.8058C11.9746 30.5568 26.1096 46.5457 28.9774 49.6678C29.2509 49.967 29.71 49.967 29.9835 49.6678C32.849 46.541 46.9863 30.5289 46.9863 18.8058C46.9863 8.69704 39.148 0.501953 29.4804 0.501953C19.8129 0.501953 11.9746 8.69704 11.9746 18.8058Z",
    fill: "url(#paint203_radial_19952_150379)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5766 18.8058C19.5766 13.081 24.0162 8.43956 29.4898 8.43956C34.9635 8.43956 39.4031 13.081 39.4031 18.8058C39.4031 24.5305 34.9635 29.172 29.4898 29.172C24.0162 29.172 19.5766 24.5305 19.5766 18.8058ZM11.9863 18.8058C11.9863 30.5591 26.1213 46.548 28.9891 49.6701C29.2626 49.9694 29.7217 49.9694 29.9952 49.6701C32.8607 46.5433 46.998 30.5289 46.998 18.8058C46.998 8.69704 39.1597 0.501953 29.4922 0.501953C19.8247 0.501953 11.9863 8.69704 11.9863 18.8058Z",
    fill: "url(#paint204_radial_19952_150379)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5887 18.8058C19.5887 13.081 24.026 8.43956 29.5019 8.43956C34.9779 8.43956 39.4152 13.081 39.4152 18.8058C39.4152 24.5305 34.9779 29.172 29.5019 29.172C24.026 29.172 19.5887 24.5305 19.5887 18.8058ZM11.9961 18.8058C11.9961 30.5591 26.1311 46.548 28.9965 49.6725C29.2701 49.9717 29.7291 49.9717 30.0027 49.6725C32.8682 46.5457 47.0055 30.5289 47.0055 18.8058C47.0055 8.69704 39.1671 0.501953 29.4996 0.501953C19.8321 0.501953 11.9961 8.69704 11.9961 18.8058Z",
    fill: "url(#paint205_radial_19952_150379)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5981 18.8054C19.5981 13.0807 24.0354 8.4392 29.5113 8.4392C34.9873 8.4392 39.4246 13.0807 39.4246 18.8054C39.4246 24.5301 34.9873 29.1716 29.5113 29.1716C24.0354 29.1716 19.5981 24.5301 19.5981 18.8054ZM12.0078 18.8054C12.0078 30.5587 26.1405 46.5499 29.0082 49.6744C29.2818 49.9736 29.7409 49.9736 30.0144 49.6744C32.8799 46.5476 47.0148 30.5286 47.0148 18.8077C47.0148 8.69899 39.1788 0.503906 29.509 0.503906C19.8392 0.503906 12.0078 8.69667 12.0078 18.8054Z",
    fill: "url(#paint206_radial_19952_150379)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6102 18.8058C19.6102 13.081 24.0475 8.43956 29.5234 8.43956C34.997 8.43956 39.4367 13.081 39.4367 18.8058C39.4367 24.5305 34.9993 29.172 29.5234 29.172C24.0475 29.172 19.6102 24.5305 19.6102 18.8058ZM12.0176 18.8058C12.0176 30.5591 26.1502 46.5503 29.018 49.6748C29.2916 49.974 29.7506 49.974 30.0242 49.6748C32.8897 46.5457 47.0246 30.5266 47.0246 18.8058C47.0246 8.69704 39.1886 0.501953 29.5211 0.501953C19.8536 0.501953 12.0176 8.69704 12.0176 18.8058Z",
    fill: "url(#paint207_radial_19952_150379)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6196 18.8058C19.6196 13.081 24.0569 8.43956 29.5328 8.43956C35.0088 8.43956 39.4461 13.081 39.4461 18.8058C39.4461 24.5305 35.0088 29.172 29.5328 29.172C24.0569 29.172 19.6196 24.5305 19.6196 18.8058ZM12.0293 18.8058C12.0293 30.5591 26.1619 46.5526 29.0297 49.6771C29.3033 49.9763 29.7623 49.9763 30.0382 49.6771C32.9037 46.548 47.0387 30.5266 47.0387 18.8058C47.0387 8.69704 39.2026 0.501953 29.5351 0.501953C19.8676 0.501953 12.0293 8.69704 12.0293 18.8058Z",
    fill: "url(#paint208_radial_19952_150379)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6274 18.8058C19.6274 13.081 24.0647 8.43956 29.5406 8.43956C35.0166 8.43956 39.4539 13.081 39.4539 18.8058C39.4539 24.5305 35.0166 29.172 29.5406 29.172C24.0647 29.172 19.6274 24.5305 19.6274 18.8058ZM12.0371 18.8058C12.0371 30.5591 26.1697 46.5549 29.0352 49.6794C29.3088 49.9786 29.7678 49.9786 30.0437 49.6794C32.9092 46.5503 47.0441 30.5266 47.0441 18.8058C47.0441 8.69704 39.2081 0.501953 29.5406 0.501953C19.8731 0.501953 12.0371 8.69704 12.0371 18.8058Z",
    fill: "url(#paint209_radial_19952_150379)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6391 18.8058C19.6391 13.081 24.0764 8.43956 29.55 8.43956C35.0237 8.43956 39.461 13.081 39.461 18.8058C39.461 24.5305 35.0237 29.172 29.55 29.172C24.0764 29.172 19.6391 24.5305 19.6391 18.8058ZM12.0488 18.8058C12.0488 30.5591 26.1792 46.5549 29.0469 49.6794C29.3205 49.9786 29.7795 49.9786 30.0554 49.6794C32.9209 46.5503 47.0536 30.5243 47.0536 18.8058C47.0536 8.69704 39.2175 0.501953 29.55 0.501953C19.8825 0.501953 12.0488 8.69704 12.0488 18.8058Z",
    fill: "url(#paint210_radial_19952_150379)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6489 18.8058C19.6489 13.081 24.0862 8.43956 29.5598 8.43956C35.0334 8.43956 39.4707 13.081 39.4707 18.8058C39.4707 24.5305 35.0334 29.172 29.5598 29.172C24.0885 29.172 19.6489 24.5305 19.6489 18.8058ZM12.0586 18.8058C12.0586 30.5591 26.1889 46.5573 29.0567 49.6817C29.3303 49.981 29.7916 49.981 30.0652 49.6817C32.9307 46.5526 47.0633 30.5266 47.0633 18.8058C47.0633 8.69704 39.2273 0.501953 29.5621 0.501953C19.8969 0.501953 12.0586 8.69704 12.0586 18.8058Z",
    fill: "url(#paint211_radial_19952_150379)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6606 18.8058C19.6606 13.081 24.0979 8.43956 29.5715 8.43956C35.0451 8.43956 39.4824 13.081 39.4824 18.8058C39.4824 24.5305 35.0451 29.172 29.5715 29.172C24.0979 29.172 19.6606 24.5305 19.6606 18.8058ZM12.0703 18.8058C12.0703 30.5591 26.2006 46.5573 29.0684 49.684C29.342 49.9833 29.8033 49.9833 30.0769 49.684C32.9424 46.5526 47.075 30.5266 47.075 18.8058C47.075 8.69704 39.239 0.501953 29.5738 0.501953C19.9086 0.501953 12.0703 8.69704 12.0703 18.8058Z",
    fill: "url(#paint212_radial_19952_150379)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6703 18.8054C19.6703 13.0807 24.1077 8.4392 29.5813 8.4392C35.0549 8.4392 39.4922 13.0807 39.4922 18.8054C39.4922 24.5301 35.0549 29.1716 29.5813 29.1716C24.1077 29.1716 19.6703 24.5301 19.6703 18.8054ZM12.0801 18.8054C12.0801 30.5587 26.2104 46.5592 29.0782 49.686C29.3518 49.9852 29.8131 49.9852 30.0867 49.686C32.9522 46.5546 47.0848 30.5263 47.0848 18.8077C47.0848 8.69899 39.2488 0.503906 29.5836 0.503906C19.9184 0.503906 12.0801 8.69667 12.0801 18.8054Z",
    fill: "url(#paint213_radial_19952_150379)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6821 18.8058C19.6821 13.081 24.1194 8.43956 29.593 8.43956C35.0666 8.43956 39.5039 13.081 39.5039 18.8058C39.5039 24.5305 35.0666 29.172 29.593 29.172C24.1194 29.172 19.6821 24.5305 19.6821 18.8058ZM12.0918 18.8058C12.0918 30.5614 26.2198 46.5596 29.0876 49.6864C29.3612 49.9856 29.8225 49.9856 30.0961 49.6864C32.9616 46.5549 47.0942 30.5243 47.0942 18.8058C47.0942 8.69704 39.2582 0.501953 29.593 0.501953C19.9278 0.501953 12.0918 8.69704 12.0918 18.8058Z",
    fill: "url(#paint214_radial_19952_150379)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6915 18.8058C19.6915 13.081 24.1288 8.43956 29.6024 8.43956C35.076 8.43956 39.5133 13.081 39.5133 18.8058C39.5133 24.5305 35.076 29.172 29.6024 29.172C24.1288 29.172 19.6915 24.5305 19.6915 18.8058ZM12.1035 18.8058C12.1035 30.5614 26.2315 46.5619 29.0993 49.6887C29.3729 49.9879 29.8342 49.9879 30.1078 49.6887C32.9733 46.5573 47.1036 30.5243 47.1036 18.8058C47.1036 8.69704 39.2676 0.501953 29.6024 0.501953C19.9372 0.501953 12.1035 8.69704 12.1035 18.8058Z",
    fill: "url(#paint215_radial_19952_150379)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7016 18.8058C19.7016 13.081 24.1389 8.43956 29.6125 8.43956C35.0861 8.43956 39.5235 13.081 39.5235 18.8058C39.5235 24.5305 35.0861 29.172 29.6125 29.172C24.1389 29.172 19.7016 24.5305 19.7016 18.8058ZM12.1113 18.8058C12.1113 30.5614 26.2393 46.5642 29.1071 49.691C29.3807 49.9902 29.842 49.9902 30.1156 49.691C32.9811 46.5596 47.1114 30.5243 47.1114 18.8058C47.1114 8.69704 39.2777 0.501953 29.6125 0.501953C19.9473 0.501953 12.1113 8.69704 12.1113 18.8058Z",
    fill: "url(#paint216_radial_19952_150379)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M19.711 18.8054C19.711 13.0807 24.1483 8.4392 29.6219 8.4392C35.0955 8.4392 39.5329 13.0807 39.5329 18.8054C39.5329 24.5301 35.0955 29.1716 29.6219 29.1716C24.1483 29.1716 19.711 24.5301 19.711 18.8054ZM12.123 18.8054C12.123 30.5611 26.2511 46.5639 29.1189 49.693C29.3924 49.9922 29.8538 49.9922 30.1273 49.693C32.9928 46.5592 47.1231 30.5239 47.1231 18.8077C47.1231 8.69899 39.2894 0.503906 29.6243 0.503906C19.9591 0.503906 12.123 8.69667 12.123 18.8054Z",
    fill: "url(#paint217_radial_19952_150379)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 18.8058C19.7231 13.081 24.1604 8.43956 29.6317 8.43956C35.1053 8.43956 39.5403 13.081 39.5403 18.8058C39.5403 24.5305 35.103 29.172 29.6317 29.172C24.1581 29.172 19.7231 24.5305 19.7231 18.8058ZM12.1328 18.8058C12.1328 30.5614 26.2585 46.5665 29.1263 49.6933C29.3999 49.9926 29.8612 49.9926 30.1348 49.6933C33.0003 46.5596 47.1306 30.522 47.1306 18.8058C47.1306 8.69704 39.2969 0.501953 29.6317 0.501953C19.9665 0.501953 12.1328 8.69704 12.1328 18.8058Z",
    fill: "url(#paint218_radial_19952_150379)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7325 18.8058C19.7325 13.081 24.1698 8.43956 29.6411 8.43956C35.1147 8.43956 39.5497 13.081 39.5497 18.8058C39.5497 24.5305 35.1124 29.172 29.6411 29.172C24.1698 29.172 19.7325 24.5305 19.7325 18.8058ZM12.1445 18.8058C12.1445 30.5614 26.2702 46.5665 29.138 49.6957C29.4116 49.9949 29.8729 49.9949 30.1465 49.6957C33.012 46.5619 47.14 30.522 47.14 18.8058C47.14 8.69704 39.3063 0.501953 29.6411 0.501953C19.9759 0.501953 12.1445 8.69704 12.1445 18.8058Z",
    fill: "url(#paint219_radial_19952_150379)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7422 18.8058C19.7422 13.081 24.1796 8.43956 29.6509 8.43956C35.1222 8.43956 39.5595 13.081 39.5595 18.8058C39.5595 24.5305 35.1245 29.172 29.6532 29.172C24.1819 29.172 19.7422 24.5305 19.7422 18.8058ZM12.1543 18.8058C12.1543 30.5614 26.28 46.5689 29.1478 49.698C29.4213 49.9972 29.8827 49.9972 30.1563 49.698C33.0217 46.5642 47.1497 30.5243 47.1497 18.8058C47.1497 8.69704 39.316 0.501953 29.6532 0.501953C19.9903 0.501953 12.1543 8.69704 12.1543 18.8058Z",
    fill: "url(#paint220_radial_19952_150379)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M19.754 18.8054C19.754 13.0807 24.1913 8.4392 29.6626 8.4392C35.1362 8.4392 39.5712 13.0807 39.5712 18.8054C39.5712 24.5301 35.1339 29.1716 29.6626 29.1716C24.189 29.1716 19.754 24.5301 19.754 18.8054ZM12.166 18.8054C12.166 30.5611 26.2917 46.5685 29.1595 49.6999C29.4331 49.9992 29.8944 49.9992 30.168 49.6999C33.0335 46.5662 47.1615 30.5239 47.1615 18.8077C47.1615 8.69899 39.3278 0.503906 29.6649 0.503906C20.002 0.503906 12.166 8.69667 12.166 18.8054Z",
    fill: "url(#paint221_radial_19952_150379)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7618 18.8058C19.7618 13.081 24.1991 8.43956 29.6704 8.43956C35.1417 8.43956 39.579 13.081 39.579 18.8058C39.579 24.5305 35.1417 29.172 29.6704 29.172C24.1991 29.172 19.7618 24.5305 19.7618 18.8058ZM12.1738 18.8058C12.1738 30.5614 26.2972 46.5712 29.165 49.7003C29.4386 49.9995 29.8999 49.9995 30.1735 49.7003C33.039 46.5642 47.167 30.522 47.167 18.8058C47.167 8.69704 39.3333 0.501953 29.6704 0.501953C20.0075 0.501953 12.1738 8.69704 12.1738 18.8058Z",
    fill: "url(#paint222_radial_19952_150379)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7735 18.8058C19.7735 13.081 24.2085 8.43956 29.6821 8.43956C35.1557 8.43956 39.5907 13.081 39.5907 18.8058C39.5907 24.5305 35.1557 29.172 29.6821 29.172C24.2085 29.172 19.7735 24.5305 19.7735 18.8058ZM12.1855 18.8058C12.1855 30.5614 26.3089 46.5735 29.1767 49.7026C29.4503 50.0018 29.9116 50.0018 30.1852 49.7026C33.0507 46.5665 47.1764 30.522 47.1764 18.8058C47.1764 8.69704 39.3427 0.501953 29.6798 0.501953C20.0169 0.501953 12.1855 8.69704 12.1855 18.8058Z",
    fill: "url(#paint223_radial_19952_150379)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7833 18.8058C19.7833 13.081 24.2183 8.43956 29.6919 8.43956C35.1655 8.43956 39.6005 13.081 39.6005 18.8058C39.6005 24.5305 35.1655 29.172 29.6919 29.172C24.2183 29.172 19.7833 24.5305 19.7833 18.8058ZM12.1953 18.8058C12.1953 30.5637 26.3187 46.5735 29.1865 49.7049C29.46 50.0042 29.9214 50.0042 30.195 49.7049C33.0604 46.5689 47.1861 30.522 47.1861 18.8058C47.1861 8.69704 39.3524 0.501953 29.6896 0.501953C20.0267 0.501953 12.1953 8.69704 12.1953 18.8058Z",
    fill: "url(#paint224_radial_19952_150379)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 18.8054C19.795 13.0807 24.23 8.4392 29.7036 8.4392C35.1749 8.4392 39.6122 13.0807 39.6122 18.8054C39.6122 24.5301 35.1772 29.1716 29.7036 29.1716C24.23 29.1716 19.795 24.5301 19.795 18.8054ZM12.207 18.8054C12.207 30.5634 26.3304 46.5754 29.1982 49.7069C29.4718 50.0061 29.9331 50.0061 30.2067 49.7069C33.0722 46.5708 47.1978 30.5216 47.1978 18.8077C47.1978 8.69899 39.3641 0.503906 29.7036 0.503906C20.043 0.503906 12.207 8.69667 12.207 18.8054Z",
    fill: "url(#paint225_radial_19952_150379)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8044 18.8058C19.8044 13.081 24.2394 8.43956 29.7107 8.43956C35.182 8.43956 39.617 13.081 39.617 18.8058C39.617 24.5305 35.182 29.172 29.7107 29.172C24.2394 29.172 19.8044 24.5305 19.8044 18.8058ZM12.2188 18.8058C12.2188 30.5637 26.3398 46.5758 29.2076 49.7072C29.4812 50.0065 29.9425 50.0065 30.2161 49.7072C33.0816 46.5712 47.2072 30.5197 47.2072 18.8058C47.2072 8.69704 39.3759 0.501953 29.713 0.501953C20.0501 0.501953 12.2188 8.69704 12.2188 18.8058Z",
    fill: "url(#paint226_radial_19952_150379)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8165 18.8058C19.8165 13.081 24.2515 8.43956 29.7228 8.43956C35.1941 8.43956 39.6291 13.081 39.6291 18.8058C39.6291 24.5305 35.1941 29.172 29.7228 29.172C24.2515 29.172 19.8165 24.5305 19.8165 18.8058ZM12.2285 18.8058C12.2285 30.5637 26.3496 46.5781 29.2174 49.7096C29.4909 50.0088 29.9523 50.0088 30.2258 49.7096C33.0913 46.5712 47.2147 30.5197 47.2147 18.8058C47.2147 8.69704 39.3833 0.501953 29.7204 0.501953C20.0576 0.501953 12.2285 8.69704 12.2285 18.8058Z",
    fill: "url(#paint227_radial_19952_150379)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8259 18.8054C19.8259 13.0807 24.2609 8.4392 29.7322 8.4392C35.2035 8.4392 39.6385 13.0807 39.6385 18.8054C39.6385 24.5301 35.2035 29.1716 29.7322 29.1716C24.2609 29.1716 19.8259 24.5301 19.8259 18.8054ZM12.2402 18.8054C12.2402 30.5634 26.3613 46.5801 29.2291 49.7115C29.5026 50.0108 29.964 50.0108 30.2376 49.7115C33.103 46.5731 47.2264 30.5193 47.2264 18.8077C47.2264 8.69899 39.395 0.503906 29.7322 0.503906C20.0693 0.503906 12.2402 8.69667 12.2402 18.8054Z",
    fill: "url(#paint228_radial_19952_150379)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8337 18.8058C19.8337 13.081 24.2687 8.43956 29.74 8.43956C35.2113 8.43956 39.6463 13.081 39.6463 18.8058C39.6463 24.5305 35.2113 29.172 29.74 29.172C24.271 29.172 19.8337 24.5305 19.8337 18.8058ZM12.248 18.8058C12.248 30.5637 26.3691 46.5805 29.2369 49.7119C29.5105 50.0111 29.9718 50.0111 30.2454 49.7119C33.1109 46.5735 47.2342 30.5197 47.2342 18.8058C47.2342 8.69704 39.4028 0.501953 29.7423 0.501953C20.0817 0.501953 12.248 8.69704 12.248 18.8058Z",
    fill: "url(#paint229_radial_19952_150379)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8454 18.8058C19.8454 13.081 24.2804 8.43956 29.7517 8.43956C35.223 8.43956 39.658 13.081 39.658 18.8058C39.658 24.5305 35.223 29.172 29.7517 29.172C24.2804 29.172 19.8454 24.5305 19.8454 18.8058ZM12.2598 18.8058C12.2598 30.5637 26.3785 46.5828 29.2463 49.7142C29.5199 50.0134 29.9812 50.0134 30.2548 49.7142C33.1202 46.5758 47.2436 30.5197 47.2436 18.8058C47.2436 8.69704 39.4122 0.501953 29.7517 0.501953C20.0911 0.501953 12.2598 8.69704 12.2598 18.8058Z",
    fill: "url(#paint230_radial_19952_150379)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8552 18.8058C19.8552 13.081 24.2902 8.43956 29.7615 8.43956C35.2328 8.43956 39.6678 13.081 39.6678 18.8058C39.6678 24.5305 35.2328 29.172 29.7615 29.172C24.2902 29.172 19.8552 24.5305 19.8552 18.8058ZM12.2695 18.8058C12.2695 30.5637 26.3883 46.5828 29.2561 49.7165C29.5296 50.0158 29.991 50.0158 30.2645 49.7165C33.13 46.5781 47.2534 30.5197 47.2534 18.8058C47.2534 8.69704 39.422 0.501953 29.7615 0.501953C20.1009 0.501953 12.2695 8.69704 12.2695 18.8058Z",
    fill: "url(#paint231_radial_19952_150379)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8669 18.8054C19.8669 13.0807 24.3019 8.4392 29.7732 8.4392C35.2445 8.4392 39.6795 13.0807 39.6795 18.8054C39.6795 24.5301 35.2445 29.1716 29.7732 29.1716C24.3019 29.1716 19.8669 24.5301 19.8669 18.8054ZM12.2812 18.8054C12.2812 30.5634 26.4 46.5847 29.2678 49.7185C29.5413 50.0177 30.0027 50.0177 30.2763 49.7185C33.1417 46.5778 47.2628 30.5193 47.2628 18.8077C47.2628 8.69899 39.4314 0.503906 29.7709 0.503906C20.1103 0.503906 12.2812 8.69667 12.2812 18.8054Z",
    fill: "url(#paint232_radial_19952_150379)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8766 18.8058C19.8766 13.081 24.3116 8.43956 29.7829 8.43956C35.2542 8.43956 39.6892 13.081 39.6892 18.8058C39.6892 24.5305 35.2542 29.172 29.7829 29.172C24.3116 29.172 19.8766 24.5305 19.8766 18.8058ZM12.291 18.8058C12.291 30.5661 26.4097 46.5851 29.2775 49.7188C29.5511 50.0181 30.0125 50.0181 30.286 49.7188C33.1538 46.5781 47.2726 30.5173 47.2726 18.8058C47.2726 8.69704 39.4412 0.501953 29.7806 0.501953C20.1201 0.501953 12.291 8.69704 12.291 18.8058Z",
    fill: "url(#paint233_radial_19952_150379)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8884 18.8058C19.8884 13.081 24.3234 8.43956 29.7923 8.43956C35.2613 8.43956 39.6963 13.081 39.6963 18.8058C39.6963 24.5305 35.2636 29.172 29.7923 29.172C24.321 29.172 19.8884 24.5305 19.8884 18.8058ZM12.3027 18.8058C12.3027 30.5661 26.4191 46.5874 29.2893 49.7212C29.5628 50.0204 30.0242 50.0204 30.2977 49.7212C33.1632 46.5804 47.2843 30.5173 47.2843 18.8058C47.2843 8.69704 39.4529 0.501953 29.7947 0.501953C20.1364 0.501953 12.3027 8.69704 12.3027 18.8058Z",
    fill: "url(#paint234_radial_19952_150379)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8962 18.8058C19.8962 13.081 24.3312 8.43956 29.8002 8.43956C35.2715 8.43956 39.7041 13.081 39.7041 18.8058C39.7041 24.5305 35.2691 29.172 29.8002 29.172C24.3312 29.172 19.8962 24.5305 19.8962 18.8058ZM12.3105 18.8058C12.3105 30.5661 26.427 46.5897 29.2948 49.7235C29.5683 50.0227 30.0297 50.0227 30.3032 49.7235C33.1687 46.5828 47.2898 30.5173 47.2898 18.8058C47.2898 8.69704 39.4584 0.501953 29.8002 0.501953C20.1419 0.501953 12.3105 8.69704 12.3105 18.8058Z",
    fill: "url(#paint235_radial_19952_150379)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9079 18.8054C19.9079 13.0807 24.3429 8.4392 29.8119 8.4392C35.2809 8.4392 39.7159 13.0807 39.7159 18.8054C39.7159 24.5301 35.2809 29.1716 29.8119 29.1716C24.3429 29.1716 19.9079 24.5301 19.9079 18.8054ZM12.3223 18.8054C12.3223 30.5657 26.4387 46.5894 29.3065 49.7254C29.58 50.0247 30.0414 50.0247 30.315 49.7254C33.1804 46.5847 47.2992 30.517 47.2992 18.8077C47.2992 8.69899 39.4701 0.503906 29.8096 0.503906C20.149 0.503906 12.3223 8.69667 12.3223 18.8054Z",
    fill: "url(#paint236_radial_19952_150379)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9173 18.8058C19.9173 13.081 24.3523 8.43956 29.8213 8.43956C35.2903 8.43956 39.7253 13.081 39.7253 18.8058C39.7253 24.5305 35.2903 29.172 29.8213 29.172C24.3523 29.172 19.9173 24.5305 19.9173 18.8058ZM12.334 18.8058C12.334 30.5661 26.4504 46.5921 29.3182 49.7258C29.5918 50.025 30.0531 50.025 30.3267 49.7258C33.1922 46.5828 47.3109 30.515 47.3109 18.8058C47.3109 8.69704 39.4818 0.501953 29.8213 0.501953C20.1607 0.501953 12.334 8.69704 12.334 18.8058Z",
    fill: "url(#paint237_radial_19952_150379)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9294 18.8058C19.9294 13.081 24.3644 8.43956 29.8334 8.43956C35.3023 8.43956 39.7373 13.081 39.7373 18.8058C39.7373 24.5305 35.3023 29.172 29.8334 29.172C24.3621 29.172 19.9294 24.5305 19.9294 18.8058ZM12.3438 18.8058C12.3438 30.5661 26.4578 46.5921 29.328 49.7281C29.6015 50.0274 30.0629 50.0274 30.3364 49.7281C33.2019 46.5851 47.3207 30.5174 47.3207 18.8058C47.3207 8.69704 39.4916 0.501953 29.8334 0.501953C20.1751 0.501953 12.3438 8.69704 12.3438 18.8058Z",
    fill: "url(#paint238_radial_19952_150379)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9388 18.8058C19.9388 13.081 24.3738 8.43956 29.8428 8.43956C35.3117 8.43956 39.7467 13.081 39.7467 18.8058C39.7467 24.5305 35.3117 29.172 29.8428 29.172C24.3738 29.172 19.9388 24.5305 19.9388 18.8058ZM12.3555 18.8058C12.3555 30.5661 26.4696 46.5944 29.3374 49.7304C29.6109 50.0297 30.0723 50.0297 30.3458 49.7304C33.2113 46.5874 47.3301 30.5173 47.3301 18.8058C47.3301 8.69704 39.501 0.501953 29.8428 0.501953C20.1845 0.501953 12.3555 8.69704 12.3555 18.8058Z",
    fill: "url(#paint239_radial_19952_150379)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9485 18.8054C19.9485 13.0807 24.3835 8.4392 29.8525 8.4392C35.3215 8.4392 39.7565 13.0807 39.7565 18.8054C39.7565 24.5301 35.3215 29.1716 29.8525 29.1716C24.3835 29.1716 19.9485 24.5301 19.9485 18.8054ZM12.3652 18.8054C12.3652 30.5657 26.4793 46.594 29.3471 49.7324C29.6207 50.0316 30.082 50.0316 30.3556 49.7324C33.2211 46.5894 47.3375 30.517 47.3375 18.8077C47.3375 8.69899 39.5084 0.503906 29.8502 0.503906C20.192 0.503906 12.3652 8.69667 12.3652 18.8054Z",
    fill: "url(#paint240_radial_19952_150379)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9603 18.8058C19.9603 13.081 24.3929 8.43956 29.8642 8.43956C35.3332 8.43956 39.7682 13.081 39.7682 18.8058C39.7682 24.5305 35.3332 29.172 29.8619 29.172C24.3929 29.172 19.9603 24.5305 19.9603 18.8058ZM12.377 18.8058C12.377 30.5661 26.491 46.5967 29.3588 49.7328C29.6324 50.032 30.0938 50.032 30.3673 49.7328C33.2328 46.5897 47.3492 30.515 47.3492 18.8058C47.3492 8.69704 39.5202 0.501953 29.8619 0.501953C20.2037 0.501953 12.377 8.69704 12.377 18.8058Z",
    fill: "url(#paint241_radial_19952_150379)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9681 18.8058C19.9681 13.081 24.4008 8.43956 29.8697 8.43956C35.3387 8.43956 39.7714 13.081 39.7714 18.8058C39.7714 24.5305 35.3387 29.172 29.8697 29.172C24.4031 29.172 19.9681 24.5305 19.9681 18.8058ZM12.3848 18.8058C12.3848 30.5661 26.4965 46.599 29.3667 49.7351C29.6402 50.0343 30.1016 50.0343 30.3751 49.7351C33.2406 46.5897 47.357 30.515 47.357 18.8058C47.357 8.69704 39.528 0.501953 29.8697 0.501953C20.2115 0.501953 12.3848 8.69704 12.3848 18.8058Z",
    fill: "url(#paint242_radial_19952_150379)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9798 18.8054C19.9798 13.0807 24.4125 8.4392 29.8815 8.4392C35.3504 8.4392 39.7831 13.0807 39.7831 18.8054C39.7831 24.5301 35.3504 29.1716 29.8815 29.1716C24.4125 29.1716 19.9798 24.5301 19.9798 18.8054ZM12.3965 18.8054C12.3965 30.568 26.5083 46.5986 29.3761 49.737C29.6496 50.0363 30.111 50.0363 30.3845 49.737C33.2523 46.5917 47.3664 30.5147 47.3664 18.8077C47.3664 8.69899 39.5374 0.503906 29.8815 0.503906C20.2255 0.503906 12.3965 8.69667 12.3965 18.8054Z",
    fill: "url(#paint243_radial_19952_150379)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9896 18.8054C19.9896 13.0807 24.4222 8.4392 29.8912 8.4392C35.3602 8.4392 39.7929 13.0807 39.7929 18.8054C39.7929 24.5301 35.3602 29.1716 29.8912 29.1716C24.4222 29.1716 19.9896 24.5301 19.9896 18.8054ZM12.4062 18.8054C12.4062 30.568 26.518 46.601 29.3858 49.7394C29.6594 50.0386 30.1207 50.0386 30.3943 49.7394C33.2621 46.594 47.3762 30.5147 47.3762 18.8077C47.3762 8.69899 39.5471 0.503906 29.8912 0.503906C20.2353 0.503906 12.4062 8.69667 12.4062 18.8054Z",
    fill: "url(#paint244_radial_19952_150379)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 18.8058C20.0013 13.081 24.434 8.43956 29.9029 8.43956C35.3719 8.43956 39.8046 13.081 39.8046 18.8058C39.8046 24.5305 35.3719 29.172 29.9029 29.172C24.434 29.172 20.0013 24.5305 20.0013 18.8058ZM12.418 18.8058C12.418 30.5684 26.5297 46.6013 29.3975 49.7397C29.6711 50.039 30.1325 50.039 30.406 49.7397C33.2738 46.5944 47.3856 30.5127 47.3856 18.8058C47.3856 8.69704 39.5565 0.501953 29.9006 0.501953C20.2447 0.501953 12.418 8.69704 12.418 18.8058Z",
    fill: "url(#paint245_radial_19952_150379)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M20.011 18.8058C20.011 13.081 24.4437 8.43956 29.9127 8.43956C35.3817 8.43956 39.8144 13.081 39.8144 18.8058C39.8144 24.5305 35.3817 29.172 29.9127 29.172C24.4437 29.172 20.011 24.5305 20.011 18.8058ZM12.4277 18.8058C12.4277 30.5684 26.5372 46.6036 29.4073 49.742C29.6809 50.0413 30.1422 50.0413 30.4181 49.742C33.2859 46.5967 47.3977 30.5127 47.3977 18.8058C47.3977 8.69704 39.5686 0.501953 29.9127 0.501953C20.2568 0.501953 12.4277 8.69704 12.4277 18.8058Z",
    fill: "url(#paint246_radial_19952_150379)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0228 18.8054C20.0228 13.0807 24.4554 8.4392 29.9244 8.4392C35.3934 8.4392 39.8261 13.0807 39.8261 18.8054C39.8261 24.5301 35.3934 29.1716 29.9244 29.1716C24.4554 29.1716 20.0228 24.5301 20.0228 18.8054ZM12.4395 18.8054C12.4395 30.568 26.5489 46.6033 29.4167 49.744C29.6903 50.0432 30.1516 50.0432 30.4275 49.744C33.2953 46.5963 47.4071 30.5147 47.4071 18.8077C47.4071 8.69899 39.5803 0.503906 29.9244 0.503906C20.2685 0.503906 12.4395 8.69667 12.4395 18.8054Z",
    fill: "url(#paint247_radial_19952_150379)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0322 18.8058C20.0322 13.081 24.4648 8.43956 29.9338 8.43956C35.4028 8.43956 39.8355 13.081 39.8355 18.8058C39.8355 24.5305 35.4028 29.172 29.9338 29.172C24.4648 29.172 20.0322 24.5305 20.0322 18.8058ZM12.4512 18.8058C12.4512 30.5684 26.5606 46.606 29.4284 49.7444C29.702 50.0436 30.1633 50.0436 30.4392 49.7444C33.307 46.5967 47.4188 30.5127 47.4188 18.8058C47.4188 8.69704 39.5921 0.501953 29.9361 0.501953C20.2802 0.501953 12.4512 8.69704 12.4512 18.8058Z",
    fill: "url(#paint248_radial_19952_150379)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 18.8058C20.04 13.081 24.4727 8.43956 29.9416 8.43956C35.4106 8.43956 39.8433 13.081 39.8433 18.8058C39.8433 24.5305 35.4106 29.172 29.9416 29.172C24.4727 29.172 20.04 24.5305 20.04 18.8058ZM12.459 18.8058C12.459 30.5684 26.5684 46.6083 29.4362 49.7467C29.7098 50.0459 30.1712 50.0459 30.447 49.7467C33.3148 46.599 47.4243 30.5127 47.4243 18.8058C47.4243 8.69704 39.5976 0.501953 29.9416 0.501953C20.2857 0.501953 12.459 8.69704 12.459 18.8058Z",
    fill: "url(#paint249_radial_19952_150379)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0517 18.8058C20.0517 13.081 24.4844 8.43956 29.951 8.43956C35.4177 8.43956 39.8504 13.081 39.8504 18.8058C39.8504 24.5305 35.4177 29.172 29.951 29.172C24.4844 29.172 20.0517 24.5305 20.0517 18.8058ZM12.4707 18.8058C12.4707 30.5684 26.5778 46.6083 29.448 49.749C29.7215 50.0482 30.1829 50.0482 30.4588 49.749C33.3266 46.6013 47.436 30.5127 47.436 18.8058C47.436 8.69704 39.6093 0.501953 29.9534 0.501953C20.2974 0.501953 12.4707 8.69704 12.4707 18.8058Z",
    fill: "url(#paint250_radial_19952_150379)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0615 18.8054C20.0615 13.0807 24.4941 8.4392 29.9608 8.4392C35.4275 8.4392 39.8601 13.0807 39.8601 18.8054C39.8601 24.5301 35.4275 29.1716 29.9608 29.1716C24.4941 29.1716 20.0615 24.5301 20.0615 18.8054ZM12.4805 18.8054C12.4805 30.568 26.5876 46.6102 29.4554 49.751C29.729 50.0502 30.1926 50.0502 30.4662 49.751C33.334 46.6033 47.4435 30.5123 47.4435 18.8077C47.4435 8.69899 39.6167 0.503906 29.9608 0.503906C20.3049 0.503906 12.4805 8.69667 12.4805 18.8054Z",
    fill: "url(#paint251_radial_19952_150379)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0732 18.8058C20.0732 13.081 24.5059 8.43956 29.9725 8.43956C35.4392 8.43956 39.8719 13.081 39.8719 18.8058C39.8719 24.5305 35.4392 29.172 29.9725 29.172C24.5059 29.172 20.0732 24.5305 20.0732 18.8058ZM12.4922 18.8058C12.4922 30.5684 26.5993 46.6106 29.4671 49.7513C29.7407 50.0529 30.2044 50.0506 30.4779 49.7513C33.3457 46.6013 47.4552 30.5104 47.4552 18.8058C47.4552 8.69704 39.6284 0.501953 29.9748 0.501953C20.3212 0.501953 12.4922 8.69704 12.4922 18.8058Z",
    fill: "url(#paint252_radial_19952_150379)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0829 18.8058C20.0829 13.081 24.5156 8.43956 29.9823 8.43956C35.4489 8.43956 39.8816 13.081 39.8816 18.8058C39.8816 24.5305 35.4489 29.172 29.9823 29.172C24.5156 29.172 20.0829 24.5305 20.0829 18.8058ZM12.502 18.8058C12.502 30.5707 26.6091 46.6129 29.4769 49.7536C29.7505 50.0552 30.2141 50.0529 30.4877 49.7536C33.3555 46.6036 47.4626 30.5104 47.4626 18.8058C47.4626 8.69704 39.6359 0.501953 29.9823 0.501953C20.3287 0.501953 12.502 8.69704 12.502 18.8058Z",
    fill: "url(#paint253_radial_19952_150379)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0947 18.8058C20.0947 13.081 24.5273 8.43956 29.994 8.43956C35.4607 8.43956 39.8933 13.081 39.8933 18.8058C39.8933 24.5305 35.4607 29.172 29.994 29.172C24.525 29.172 20.0947 24.5305 20.0947 18.8058ZM12.5137 18.8058C12.5137 30.5707 26.6185 46.6129 29.4886 49.756C29.7622 50.0575 30.2258 50.0552 30.4994 49.756C33.3672 46.606 47.4743 30.5104 47.4743 18.8058C47.4743 8.69704 39.6476 0.501953 29.994 0.501953C20.3404 0.501953 12.5137 8.69704 12.5137 18.8058Z",
    fill: "url(#paint254_radial_19952_150379)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1025 18.8054C20.1025 13.0807 24.5352 8.4392 30.0018 8.4392C35.4685 8.4392 39.9012 13.0807 39.9012 18.8054C39.9012 24.5301 35.4685 29.1716 30.0018 29.1716C24.5352 29.1716 20.1025 24.5301 20.1025 18.8054ZM12.5215 18.8054C12.5215 30.5703 26.6263 46.6149 29.4964 49.7579C29.77 50.0595 30.2337 50.0571 30.5072 49.7579C33.375 46.6079 47.4822 30.51 47.4822 18.8077C47.4822 8.69899 39.6554 0.503906 30.0018 0.503906C20.3482 0.503906 12.5215 8.69667 12.5215 18.8054Z",
    fill: "url(#paint255_radial_19952_150379)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1142 18.8058C20.1142 13.081 24.5469 8.43956 30.0135 8.43956C35.4802 8.43956 39.9129 13.081 39.9129 18.8058C39.9129 24.5305 35.4802 29.172 30.0135 29.172C24.5446 29.172 20.1142 24.5305 20.1142 18.8058ZM12.5332 18.8058C12.5332 30.5707 26.638 46.6176 29.5058 49.7583C29.7794 50.0598 30.2431 50.0575 30.5166 49.7583C33.3844 46.6083 47.4916 30.5104 47.4916 18.8058C47.4916 8.69704 39.6648 0.501953 30.0135 0.501953C20.3623 0.501953 12.5332 8.69704 12.5332 18.8058Z",
    fill: "url(#paint256_radial_19952_150379)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M20.124 18.8058C20.124 13.081 24.5566 8.43956 30.0233 8.43956C35.49 8.43956 39.9226 13.081 39.9226 18.8058C39.9226 24.5305 35.49 29.172 30.0233 29.172C24.5566 29.172 20.124 24.5305 20.124 18.8058ZM12.543 18.8058C12.543 30.5707 26.6478 46.6176 29.5156 49.7606C29.7892 50.0621 30.2528 50.0598 30.5264 49.7606C33.3942 46.6083 47.499 30.5104 47.499 18.8058C47.499 8.69704 39.6746 0.501953 30.021 0.501953C20.3674 0.501953 12.543 8.69704 12.543 18.8058Z",
    fill: "url(#paint257_radial_19952_150379)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1357 18.8054C20.1357 13.0807 24.566 8.4392 30.0327 8.4392C35.4994 8.4392 39.9297 13.0807 39.9297 18.8054C39.9297 24.5301 35.4994 29.1716 30.0327 29.1716C24.566 29.1716 20.1357 24.5301 20.1357 18.8054ZM12.5547 18.8054C12.5547 30.5703 26.6572 46.6195 29.5273 49.7626C29.8009 50.0641 30.2645 50.0618 30.5381 49.7626C33.4059 46.6102 47.5107 30.51 47.5107 18.8077C47.5107 8.69899 39.6863 0.503906 30.0327 0.503906C20.3791 0.503906 12.5547 8.69667 12.5547 18.8054Z",
    fill: "url(#paint258_radial_19952_150379)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1451 18.8054C20.1451 13.0807 24.5754 8.4392 30.0421 8.4392C35.5088 8.4392 39.9391 13.0807 39.9391 18.8054C39.9391 24.5301 35.5088 29.1716 30.0421 29.1716C24.5754 29.1716 20.1451 24.5301 20.1451 18.8054ZM12.5664 18.8054C12.5664 30.5703 26.6689 46.6195 29.539 49.7649C29.8126 50.0664 30.2763 50.0641 30.5498 49.7649C33.4176 46.6126 47.5224 30.51 47.5224 18.8077C47.5224 8.69899 39.698 0.503906 30.0444 0.503906C20.3908 0.503906 12.5664 8.69667 12.5664 18.8054Z",
    fill: "url(#paint259_radial_19952_150379)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1549 18.8058C20.1549 13.081 24.5852 8.43956 30.0519 8.43956C35.5185 8.43956 39.9489 13.081 39.9489 18.8058C39.9489 24.5305 35.5185 29.172 30.0519 29.172C24.5875 29.172 20.1549 24.5305 20.1549 18.8058ZM12.5762 18.8058C12.5762 30.5707 26.6787 46.6222 29.5465 49.7652C29.82 50.0668 30.2837 50.0645 30.5573 49.7652C33.4251 46.6129 47.5299 30.5081 47.5299 18.8058C47.5299 8.69704 39.7055 0.501953 30.0519 0.501953C20.3983 0.501953 12.5762 8.69704 12.5762 18.8058Z",
    fill: "url(#paint260_radial_19952_150379)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 18.8058C20.1666 13.081 24.5969 8.43956 30.0636 8.43956C35.5303 8.43956 39.9606 13.081 39.9606 18.8058C39.9606 24.5305 35.5303 29.172 30.0636 29.172C24.5969 29.172 20.1666 24.5305 20.1666 18.8058ZM12.5879 18.8058C12.5879 30.5707 26.6904 46.6245 29.5582 49.7676C29.8318 50.0691 30.2954 50.0668 30.569 49.7676C33.4368 46.6152 47.5416 30.5081 47.5416 18.8058C47.5416 8.69704 39.7172 0.501953 30.0659 0.501953C20.4146 0.501953 12.5879 8.69704 12.5879 18.8058Z",
    fill: "url(#paint261_radial_19952_150379)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1744 18.8054C20.1744 13.0807 24.6047 8.4392 30.0714 8.4392C35.5381 8.4392 39.9684 13.0807 39.9684 18.8054C39.9684 24.5301 35.5381 29.1716 30.0714 29.1716C24.6071 29.1716 20.1744 24.5301 20.1744 18.8054ZM12.5957 18.8054C12.5957 30.5726 26.6959 46.6242 29.566 49.7695C29.8396 50.0711 30.3032 50.0687 30.5768 49.7695C33.4446 46.6172 47.5471 30.5077 47.5471 18.8077C47.5471 8.69899 39.7227 0.503906 30.0714 0.503906C20.4201 0.503906 12.5957 8.69667 12.5957 18.8054Z",
    fill: "url(#paint262_radial_19952_150379)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1861 18.8054C20.1861 13.0807 24.6165 8.4392 30.0831 8.4392C35.5498 8.4392 39.9801 13.0807 39.9801 18.8054C39.9801 24.5301 35.5498 29.1716 30.0831 29.1716C24.6165 29.1716 20.1861 24.5301 20.1861 18.8054ZM12.6074 18.8054C12.6074 30.5727 26.7076 46.6265 29.5777 49.7718C29.8513 50.0734 30.315 50.0734 30.5885 49.7718C33.4563 46.6172 47.5588 30.5077 47.5588 18.8077C47.5588 8.69899 39.7344 0.503906 30.0831 0.503906C20.4318 0.503906 12.6074 8.69667 12.6074 18.8054Z",
    fill: "url(#paint263_radial_19952_150379)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1959 18.8058C20.1959 13.081 24.6262 8.43956 30.0929 8.43956C35.5595 8.43956 39.9899 13.081 39.9899 18.8058C39.9899 24.5305 35.5595 29.172 30.0929 29.172C24.6262 29.172 20.1959 24.5305 20.1959 18.8058ZM12.6172 18.8058C12.6172 30.573 26.7174 46.6269 29.5852 49.7722C29.8587 50.0737 30.3224 50.0737 30.596 49.7722C33.4638 46.6176 47.5663 30.5058 47.5663 18.8058C47.5663 8.69704 39.7418 0.501953 30.0906 0.501953C20.4393 0.501953 12.6172 8.69704 12.6172 18.8058Z",
    fill: "url(#paint264_radial_19952_150379)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2076 18.8058C20.2076 13.081 24.6379 8.43956 30.1046 8.43956C35.5713 8.43956 40.0016 13.081 40.0016 18.8058C40.0016 24.5305 35.5713 29.172 30.1046 29.172C24.6379 29.172 20.2076 24.5305 20.2076 18.8058ZM12.6289 18.8058C12.6289 30.573 26.7291 46.6292 29.5969 49.7745C29.8705 50.0761 30.3341 50.0761 30.6077 49.7745C33.4755 46.6199 47.578 30.5081 47.578 18.8058C47.578 8.69704 39.7536 0.501953 30.1046 0.501953C20.4556 0.501953 12.6289 8.69704 12.6289 18.8058Z",
    fill: "url(#paint265_radial_19952_150379)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2173 18.8054C20.2173 13.0807 24.6477 8.4392 30.1121 8.4392C35.5764 8.4392 40.0068 13.0807 40.0068 18.8054C40.0068 24.5301 35.5764 29.1716 30.1121 29.1716C24.6477 29.1716 20.2173 24.5301 20.2173 18.8054ZM12.6387 18.8054C12.6387 30.5727 26.7365 46.6288 29.6067 49.7765C29.8802 50.078 30.3439 50.078 30.6175 49.7765C33.4852 46.6218 47.5854 30.5077 47.5854 18.8077C47.5854 8.69899 39.761 0.503906 30.1121 0.503906C20.4631 0.503906 12.6387 8.69667 12.6387 18.8054Z",
    fill: "url(#paint266_radial_19952_150379)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2291 18.8058C20.2291 13.081 24.6594 8.43956 30.1238 8.43956C35.5881 8.43956 40.0185 13.081 40.0185 18.8058C40.0185 24.5305 35.5881 29.172 30.1238 29.172C24.6594 29.172 20.2291 24.5305 20.2291 18.8058ZM12.6504 18.8058C12.6504 30.573 26.7483 46.6315 29.6184 49.7768C29.8919 50.0784 30.3556 50.0784 30.6292 49.7768C33.497 46.6222 47.5972 30.5058 47.5972 18.8058C47.5972 8.69704 39.775 0.501953 30.1238 0.501953C20.4725 0.501953 12.6504 8.69704 12.6504 18.8058Z",
    fill: "url(#paint267_radial_19952_150379)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2369 18.8058C20.2369 13.081 24.6672 8.43956 30.1316 8.43956C35.5959 8.43956 40.0263 13.081 40.0263 18.8058C40.0263 24.5305 35.5959 29.172 30.1316 29.172C24.6672 29.172 20.2369 24.5305 20.2369 18.8058ZM12.6582 18.8058C12.6582 30.573 26.7561 46.6338 29.6239 49.7792C29.8974 50.0807 30.3611 50.0807 30.6347 49.7792C33.5025 46.6222 47.6026 30.5058 47.6026 18.8058C47.6026 8.69704 39.7805 0.501953 30.1293 0.501953C20.478 0.501953 12.6582 8.69704 12.6582 18.8058Z",
    fill: "url(#paint268_radial_19952_150379)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2463 18.8058C20.2463 13.081 24.6766 8.43956 30.141 8.43956C35.6053 8.43956 40.0357 13.081 40.0357 18.8058C40.0357 24.5305 35.6053 29.172 30.141 29.172C24.6766 29.172 20.2463 24.5305 20.2463 18.8058ZM12.6699 18.8058C12.6699 30.573 26.7678 46.6338 29.6356 49.7815C29.9092 50.083 30.3728 50.083 30.6464 49.7815C33.5142 46.6245 47.6144 30.5057 47.6144 18.8058C47.6144 8.69704 39.7923 0.501953 30.141 0.501953C20.4897 0.501953 12.6699 8.69704 12.6699 18.8058Z",
    fill: "url(#paint269_radial_19952_150379)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M20.258 18.8058C20.258 13.081 24.6884 8.43956 30.1527 8.43956C35.617 8.43956 40.0474 13.081 40.0474 18.8058C40.0474 24.5305 35.617 29.172 30.1527 29.172C24.6884 29.172 20.258 24.5305 20.258 18.8058ZM12.6816 18.8058C12.6816 30.573 26.7772 46.6361 29.6473 49.7838C29.9209 50.0853 30.3845 50.0853 30.6581 49.7838C33.5236 46.6245 47.6238 30.5034 47.6238 18.8058C47.6238 8.69704 39.8017 0.501953 30.1527 0.501953C20.5037 0.501953 12.6816 8.69704 12.6816 18.8058Z",
    fill: "url(#paint270_radial_19952_150379)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2678 18.8058C20.2678 13.081 24.6981 8.43956 30.1625 8.43956C35.6268 8.43956 40.0572 13.081 40.0572 18.8058C40.0572 24.5305 35.6268 29.172 30.1625 29.172C24.6981 29.172 20.2678 24.5305 20.2678 18.8058ZM12.6914 18.8058C12.6914 30.573 26.787 46.6361 29.6571 49.7838C29.9306 50.0853 30.3943 50.0853 30.6679 49.7838C33.5357 46.6268 47.6335 30.5034 47.6335 18.8058C47.6335 8.69704 39.8114 0.501953 30.1625 0.501953C20.5135 0.501953 12.6914 8.69704 12.6914 18.8058Z",
    fill: "url(#paint271_radial_19952_150379)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2795 18.8058C20.2795 13.081 24.7098 8.43956 30.1742 8.43956C35.6385 8.43956 40.0689 13.081 40.0689 18.8058C40.0689 24.5305 35.6385 29.172 30.1742 29.172C24.7098 29.172 20.2795 24.5305 20.2795 18.8058ZM12.7031 18.8058C12.7031 30.5753 26.7987 46.6384 29.6688 49.7861C29.9424 50.0877 30.406 50.0877 30.6796 49.7861C33.5451 46.6268 47.6429 30.5034 47.6429 18.8058C47.6429 8.69704 39.8208 0.501953 30.1719 0.501953C20.5229 0.501953 12.7031 8.69704 12.7031 18.8058Z",
    fill: "url(#paint272_radial_19952_150379)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2892 18.8054C20.2892 13.0807 24.7196 8.4392 30.1839 8.4392C35.6483 8.4392 40.0787 13.0807 40.0787 18.8054C40.0787 24.5301 35.6483 29.1716 30.1839 29.1716C24.7196 29.1716 20.2892 24.5301 20.2892 18.8054ZM12.7129 18.8054C12.7129 30.575 26.8084 46.6381 29.6762 49.7881C29.9498 50.0896 30.4135 50.0896 30.687 49.7881C33.5548 46.6288 47.6527 30.5031 47.6527 18.8077C47.6527 8.69899 39.8306 0.503906 30.1816 0.503906C20.5327 0.503906 12.7129 8.69667 12.7129 18.8054Z",
    fill: "url(#paint273_radial_19952_150379)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M20.301 18.8054C20.301 13.0807 24.7313 8.4392 30.1934 8.4392C35.6577 8.4392 40.0857 13.0807 40.0857 18.8054C40.0857 24.5301 35.6554 29.1716 30.1934 29.1716C24.729 29.1716 20.301 24.5301 20.301 18.8054ZM12.7246 18.8054C12.7246 30.575 26.8178 46.6404 29.688 49.7904C29.9615 50.0919 30.4252 50.0919 30.6988 49.7904C33.5665 46.6311 47.6644 30.5031 47.6644 18.8077C47.6644 8.69899 39.8423 0.503906 30.1957 0.503906C20.549 0.503906 12.7246 8.69667 12.7246 18.8054Z",
    fill: "url(#paint274_radial_19952_150379)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3088 18.8058C20.3088 13.081 24.7391 8.43956 30.2012 8.43956C35.6632 8.43956 40.0935 13.081 40.0935 18.8058C40.0935 24.5305 35.6632 29.172 30.2012 29.172C24.7391 29.172 20.3088 24.5305 20.3088 18.8058ZM12.7324 18.8058C12.7324 30.5753 26.8257 46.6431 29.6958 49.7908C29.9693 50.0923 30.433 50.0923 30.7066 49.7908C33.5744 46.6315 47.6699 30.5034 47.6699 18.8058C47.6699 8.69704 39.8478 0.501953 30.2012 0.501953C20.5545 0.501953 12.7324 8.69704 12.7324 18.8058Z",
    fill: "url(#paint275_radial_19952_150379)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3205 18.8058C20.3205 13.081 24.7485 8.43956 30.2129 8.43956C35.6772 8.43956 40.1053 13.081 40.1053 18.8058C40.1053 24.5305 35.6772 29.172 30.2129 29.172C24.7485 29.172 20.3205 24.5305 20.3205 18.8058ZM12.7441 18.8058C12.7441 30.5753 26.8374 46.6431 29.7075 49.7931C29.981 50.0946 30.4447 50.0946 30.7183 49.7931C33.5861 46.6338 47.6816 30.5034 47.6816 18.8058C47.6816 8.69704 39.8595 0.501953 30.2129 0.501953C20.5662 0.501953 12.7441 8.69704 12.7441 18.8058Z",
    fill: "url(#paint276_radial_19952_150379)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3303 18.8054C20.3303 13.0807 24.7583 8.4392 30.2227 8.4392C35.687 8.4392 40.115 13.0807 40.115 18.8054C40.115 24.5301 35.687 29.1716 30.2227 29.1716C24.7583 29.1716 20.3303 24.5301 20.3303 18.8054ZM12.7539 18.8054C12.7539 30.575 26.8471 46.645 29.7149 49.795C29.9885 50.0966 30.4522 50.0966 30.7257 49.795C33.5935 46.6358 47.6891 30.5031 47.6891 18.8077C47.6891 8.69899 39.8693 0.503906 30.2203 0.503906C20.576 0.503906 12.7539 8.69667 12.7539 18.8054Z",
    fill: "url(#paint277_radial_19952_150379)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M20.342 18.8054C20.342 13.0807 24.77 8.4392 30.2344 8.4392C35.6987 8.4392 40.1268 13.0807 40.1268 18.8054C40.1268 24.5301 35.6987 29.1716 30.2344 29.1716C24.77 29.1716 20.342 24.5301 20.342 18.8054ZM12.7656 18.8054C12.7656 30.575 26.8565 46.645 29.7266 49.7973C30.0002 50.0989 30.4639 50.0989 30.7374 49.7973C33.6052 46.6358 47.7008 30.5031 47.7008 18.8077C47.7008 8.69899 39.881 0.503906 30.232 0.503906C20.5831 0.503906 12.7656 8.69667 12.7656 18.8054Z",
    fill: "url(#paint278_radial_19952_150379)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3517 18.8058C20.3517 13.081 24.7798 8.43956 30.2441 8.43956C35.7062 8.43956 40.1365 13.081 40.1365 18.8058C40.1365 24.5305 35.7085 29.172 30.2441 29.172C24.7798 29.172 20.3517 24.5305 20.3517 18.8058ZM12.7754 18.8058C12.7754 30.5753 26.8663 46.6477 29.7364 49.7977C30.01 50.0993 30.4737 50.0993 30.7472 49.7977C33.615 46.6361 47.7082 30.5011 47.7082 18.8058C47.7082 8.69704 39.8885 0.501953 30.2418 0.501953C20.5952 0.501953 12.7754 8.69704 12.7754 18.8058Z",
    fill: "url(#paint279_radial_19952_150379)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3611 18.8058C20.3611 13.081 24.7892 8.43956 30.2535 8.43956C35.7156 8.43956 40.1459 13.081 40.1459 18.8058C40.1459 24.5305 35.7179 29.172 30.2535 29.172C24.7915 29.172 20.3611 24.5305 20.3611 18.8058ZM12.7871 18.8058C12.7871 30.5753 26.878 46.6477 29.7481 49.8C30.0217 50.1016 30.4854 50.1016 30.7589 49.8C33.6267 46.6384 47.72 30.5011 47.72 18.8058C47.72 8.69704 39.9002 0.501953 30.2535 0.501953C20.6069 0.504273 12.7871 8.69704 12.7871 18.8058Z",
    fill: "url(#paint280_radial_19952_150379)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3729 18.8054C20.3729 13.0807 24.8009 8.4392 30.2653 8.4392C35.7296 8.4392 40.1576 13.0807 40.1576 18.8054C40.1576 24.5301 35.7296 29.1716 30.2653 29.1716C24.8009 29.1716 20.3729 24.5301 20.3729 18.8054ZM12.7988 18.8054C12.7988 30.575 26.8897 46.6497 29.7575 49.802C30.0311 50.1035 30.4948 50.1035 30.7683 49.802C33.6361 46.6404 47.7294 30.5007 47.7294 18.8077C47.7294 8.69899 39.9096 0.503906 30.2629 0.503906C20.6163 0.503906 12.7988 8.69667 12.7988 18.8054Z",
    fill: "url(#paint281_radial_19952_150379)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3807 18.8054C20.3807 13.0807 24.8087 8.4392 30.2707 8.4392C35.7328 8.4392 40.1608 13.0807 40.1608 18.8054C40.1608 24.5301 35.7328 29.1716 30.2707 29.1716C24.8087 29.1716 20.3807 24.5301 20.3807 18.8054ZM12.8066 18.8054C12.8066 30.5773 26.8952 46.652 29.7653 49.8043C30.0389 50.1059 30.5026 50.1059 30.7761 49.8043C33.6439 46.6427 47.7372 30.5007 47.7372 18.8077C47.7372 8.69899 39.9174 0.503906 30.2707 0.503906C20.6241 0.503906 12.8066 8.69667 12.8066 18.8054Z",
    fill: "url(#paint282_radial_19952_150379)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3924 18.8058C20.3924 13.081 24.8204 8.43956 30.2825 8.43956C35.7445 8.43956 40.1725 13.081 40.1725 18.8058C40.1725 24.5305 35.7445 29.172 30.2825 29.172C24.8204 29.172 20.3924 24.5305 20.3924 18.8058ZM12.8184 18.8058C12.8184 30.5777 26.907 46.6524 29.7771 49.8047C30.0506 50.1062 30.5143 50.1062 30.7879 49.8047C33.6557 46.6408 47.7466 30.4988 47.7466 18.8058C47.7466 8.69704 39.9268 0.501953 30.2825 0.501953C20.6381 0.501953 12.8184 8.69704 12.8184 18.8058Z",
    fill: "url(#paint283_radial_19952_150379)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4022 18.8058C20.4022 13.081 24.8302 8.43956 30.2922 8.43956C35.7543 8.43956 40.1823 13.081 40.1823 18.8058C40.1823 24.5305 35.7543 29.172 30.2922 29.172C24.8302 29.172 20.4022 24.5305 20.4022 18.8058ZM12.8281 18.8058C12.8281 30.5777 26.9167 46.6547 29.7868 49.807C30.0604 50.1085 30.5241 50.1085 30.7999 49.807C33.6677 46.6431 47.7587 30.5011 47.7587 18.8058C47.7587 8.69704 39.9389 0.501953 30.2945 0.501953C20.6502 0.501953 12.8281 8.69704 12.8281 18.8058Z",
    fill: "url(#paint284_radial_19952_150379)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4139 18.8054C20.4139 13.0807 24.8419 8.4392 30.304 8.4392C35.766 8.4392 40.194 13.0807 40.194 18.8054C40.194 24.5301 35.766 29.1716 30.304 29.1716C24.8419 29.1716 20.4139 24.5301 20.4139 18.8054ZM12.8398 18.8054C12.8398 30.5773 26.9284 46.6543 29.7962 49.809C30.0698 50.1105 30.5335 50.1105 30.8093 49.809C33.6771 46.645 47.7681 30.5007 47.7681 18.8077C47.7681 8.69899 39.9483 0.503906 30.304 0.503906C20.6596 0.503906 12.8398 8.69667 12.8398 18.8054Z",
    fill: "url(#paint285_radial_19952_150379)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4236 18.8061C20.4236 13.0814 24.8517 8.43993 30.3137 8.43993C35.7757 8.43993 40.2038 13.0814 40.2038 18.8061C40.2038 24.5309 35.7757 29.1724 30.3137 29.1724C24.8517 29.1724 20.4236 24.5309 20.4236 18.8061ZM12.8496 18.8061C12.8496 30.578 26.9359 46.6574 29.806 49.8097C30.0796 50.1112 30.5432 50.1112 30.8191 49.8074C33.6869 46.6435 47.7778 30.4968 47.7778 18.8038C47.7778 8.69508 39.958 0.5 30.3137 0.5C20.6694 0.5 12.8496 8.6974 12.8496 18.8061Z",
    fill: "url(#paint286_radial_19952_150379)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4354 18.8061C20.4354 13.0814 24.8634 8.43993 30.3254 8.43993C35.7875 8.43993 40.2155 13.0814 40.2155 18.8061C40.2155 24.5309 35.7875 29.1724 30.3254 29.1724C24.8634 29.1724 20.4354 24.5309 20.4354 18.8061ZM12.8613 18.8061C12.8613 30.578 26.9476 46.6574 29.8177 49.812C30.0913 50.1135 30.555 50.1135 30.8308 49.8097C33.6986 46.6458 47.7872 30.4968 47.7872 18.8038C47.7872 8.69508 39.9698 0.5 30.3231 0.5C20.6765 0.5 12.8613 8.6974 12.8613 18.8061Z",
    fill: "url(#paint287_radial_19952_150379)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4432 18.8058C20.4432 13.081 24.8712 8.43956 30.3332 8.43956C35.7953 8.43956 40.2233 13.081 40.2233 18.8058C40.2233 24.5305 35.7953 29.172 30.3332 29.172C24.8712 29.172 20.4432 24.5305 20.4432 18.8058ZM12.8691 18.8058C12.8691 30.5777 26.9554 46.6593 29.8255 49.814C30.0991 50.1155 30.5628 50.1155 30.8386 49.8116C33.7064 46.6454 47.795 30.4965 47.795 18.8058C47.795 8.69704 39.9776 0.501953 30.3332 0.501953C20.6889 0.501953 12.8691 8.69704 12.8691 18.8058Z",
    fill: "url(#paint288_radial_19952_150379)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4526 18.8058C20.4526 13.081 24.8806 8.43956 30.3426 8.43956C35.8047 8.43956 40.2327 13.081 40.2327 18.8058C40.2327 24.5305 35.8047 29.172 30.3426 29.172C24.8806 29.172 20.4526 24.5305 20.4526 18.8058ZM12.8809 18.8058C12.8809 30.5777 26.9671 46.6616 29.8349 49.8163C30.1085 50.1178 30.5722 50.1178 30.848 49.814C33.7158 46.6477 47.8044 30.4965 47.8044 18.8058C47.8044 8.69704 39.987 0.501953 30.3426 0.501953C20.6983 0.501953 12.8809 8.69704 12.8809 18.8058Z",
    fill: "url(#paint289_radial_19952_150379)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4647 18.8061C20.4647 13.0814 24.8927 8.43993 30.3524 8.43993C35.8144 8.43993 40.2402 13.0814 40.2402 18.8061C40.2402 24.5309 35.8121 29.1724 30.3524 29.1724C24.8927 29.1724 20.4647 24.5309 20.4647 18.8061ZM12.8906 18.8061C12.8906 30.578 26.9746 46.662 29.8447 49.8166C30.1183 50.1182 30.5819 50.1182 30.8578 49.8143C33.7256 46.6481 47.8142 30.4945 47.8142 18.8038C47.8142 8.69508 39.9967 0.5 30.3524 0.5C20.7081 0.5 12.8906 8.6974 12.8906 18.8061Z",
    fill: "url(#paint290_radial_19952_150379)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4741 18.8061C20.4741 13.0814 24.9021 8.43993 30.3618 8.43993C35.8215 8.43993 40.2496 13.0814 40.2496 18.8061C40.2496 24.5309 35.8215 29.1724 30.3618 29.1724C24.9021 29.1724 20.4741 24.5309 20.4741 18.8061ZM12.9023 18.8061C12.9023 30.5803 26.9863 46.6643 29.8564 49.819C30.13 50.1205 30.596 50.1205 30.8695 49.8166C33.7373 46.6504 47.8259 30.4945 47.8259 18.8038C47.8259 8.69508 40.0085 0.5 30.3641 0.5C20.7198 0.5 12.9023 8.6974 12.9023 18.8061Z",
    fill: "url(#paint291_radial_19952_150379)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4858 18.8058C20.4858 13.081 24.9138 8.43956 30.3735 8.43956C35.8332 8.43956 40.2613 13.081 40.2613 18.8058C40.2613 24.5305 35.8332 29.172 30.3735 29.172C24.9138 29.172 20.4858 24.5305 20.4858 18.8058ZM12.9141 18.8058C12.9141 30.58 26.998 46.664 29.8681 49.8209C30.1417 50.1225 30.6077 50.1225 30.8813 49.8186C33.749 46.6524 47.8353 30.4942 47.8353 18.8058C47.8353 8.69704 40.0179 0.501953 30.3759 0.501953C20.7338 0.501953 12.9141 8.69704 12.9141 18.8058Z",
    fill: "url(#paint292_radial_19952_150379)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4956 18.8058C20.4956 13.081 24.9236 8.43956 30.3833 8.43956C35.843 8.43956 40.2711 13.081 40.2711 18.8058C40.2711 24.5305 35.843 29.172 30.3833 29.172C24.9236 29.172 20.4956 24.5305 20.4956 18.8058ZM12.9238 18.8058C12.9238 30.58 27.0078 46.6663 29.8779 49.8232C30.1538 50.1248 30.6175 50.1248 30.891 49.8209C33.7588 46.6524 47.8451 30.4965 47.8451 18.8058C47.8451 8.69704 40.0276 0.501953 30.3856 0.501953C20.7436 0.501953 12.9238 8.69704 12.9238 18.8058Z",
    fill: "url(#paint293_radial_19952_150379)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5073 18.8061C20.5073 13.0814 24.933 8.43993 30.395 8.43993C35.8547 8.43993 40.2828 13.0814 40.2828 18.8061C40.2828 24.5309 35.857 29.1724 30.395 29.1724C24.933 29.1724 20.5073 24.5309 20.5073 18.8061ZM12.9355 18.8061C12.9355 30.5803 27.0172 46.669 29.8873 49.8236C30.1632 50.1251 30.6269 50.1251 30.9004 49.8213C33.7682 46.6527 47.8545 30.4945 47.8545 18.8038C47.8545 8.69508 40.037 0.5 30.395 0.5C20.753 0.5 12.9355 8.6974 12.9355 18.8061Z",
    fill: "url(#paint294_radial_19952_150379)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 18.8061C20.5151 13.0814 24.9408 8.43993 30.4028 8.43993C35.8649 8.43993 40.2906 13.0814 40.2906 18.8061C40.2906 24.5309 35.8649 29.1724 30.4028 29.1724C24.9408 29.1724 20.5151 24.5309 20.5151 18.8061ZM12.9434 18.8061C12.9434 30.5803 27.025 46.669 29.8951 49.8259C30.171 50.1275 30.6347 50.1275 30.9082 49.8236C33.776 46.655 47.8623 30.4945 47.8623 18.8038C47.8623 8.69508 40.0448 0.5 30.4028 0.5C20.7608 0.5 12.9434 8.6974 12.9434 18.8061Z",
    fill: "url(#paint295_radial_19952_150379)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5268 18.8058C20.5268 13.081 24.9525 8.43956 30.4145 8.43956C35.8766 8.43956 40.3023 13.081 40.3023 18.8058C40.3023 24.5305 35.8766 29.172 30.4145 29.172C24.9525 29.172 20.5268 24.5305 20.5268 18.8058ZM12.9551 18.8058C12.9551 30.58 27.0367 46.6709 29.9068 49.8279C30.1827 50.1294 30.6464 50.1294 30.9199 49.8255C33.7877 46.657 47.8717 30.4942 47.8717 18.8058C47.8717 8.69704 40.0542 0.501953 30.4122 0.501953C20.7702 0.501953 12.9551 8.69704 12.9551 18.8058Z",
    fill: "url(#paint296_radial_19952_150379)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5366 18.8058C20.5366 13.081 24.9623 8.43956 30.4243 8.43956C35.8863 8.43956 40.3121 13.081 40.3121 18.8058C40.3121 24.5305 35.8863 29.172 30.4243 29.172C24.9623 29.172 20.5366 24.5305 20.5366 18.8058ZM12.9648 18.8058C12.9648 30.58 27.0465 46.6709 29.9166 49.8302C30.1925 50.1317 30.6562 50.1317 30.9297 49.8279C33.7975 46.6593 47.8815 30.4942 47.8815 18.8058C47.8815 8.69704 40.0663 0.501953 30.4243 0.501953C20.7823 0.501953 12.9648 8.69704 12.9648 18.8058Z",
    fill: "url(#paint297_radial_19952_150379)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5483 18.8061C20.5483 13.0814 24.974 8.43993 30.4337 8.43993C35.8934 8.43993 40.3191 13.0814 40.3191 18.8061C40.3191 24.5309 35.8934 29.1724 30.4337 29.1724C24.974 29.1724 20.5483 24.5309 20.5483 18.8061ZM12.9766 18.8061C12.9766 30.5803 27.0559 46.6736 29.926 49.8306C30.2019 50.1321 30.6656 50.1321 30.9391 49.8282C33.8069 46.6574 47.8909 30.4922 47.8909 18.8038C47.8909 8.69508 40.0757 0.5 30.4337 0.5C20.7917 0.504639 12.9766 8.6974 12.9766 18.8061Z",
    fill: "url(#paint298_radial_19952_150379)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M20.558 18.8061C20.558 13.0814 24.9838 8.43993 30.4435 8.43993C35.9032 8.43993 40.3289 13.0814 40.3289 18.8061C40.3289 24.5309 35.9032 29.1724 30.4435 29.1724C24.9838 29.1724 20.558 24.5309 20.558 18.8061ZM12.9863 18.8061C12.9863 30.5803 27.0656 46.6736 29.9358 49.8329C30.2116 50.1344 30.6753 50.1344 30.9489 49.8306C33.8167 46.6597 47.9006 30.4922 47.9006 18.8038C47.9006 8.69508 40.0855 0.5 30.4435 0.5C20.8015 0.5 12.9863 8.6974 12.9863 18.8061Z",
    fill: "url(#paint299_radial_19952_150379)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5675 18.8058C20.5675 13.081 24.9932 8.43956 30.4529 8.43956C35.9126 8.43956 40.3383 13.081 40.3383 18.8058C40.3383 24.5305 35.9126 29.172 30.4529 29.172C24.9955 29.172 20.5675 24.5305 20.5675 18.8058ZM12.998 18.8058C12.998 30.58 27.0774 46.6756 29.9475 49.8348C30.2234 50.1364 30.687 50.1364 30.9606 49.8325C33.8284 46.6616 47.91 30.4918 47.91 18.8058C47.91 8.69704 40.0949 0.501953 30.4529 0.501953C20.8109 0.501953 12.998 8.69704 12.998 18.8058Z",
    fill: "url(#paint300_radial_19952_150379)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5776 18.8058C20.5776 13.081 25.0033 8.43956 30.463 8.43956C35.9227 8.43956 40.3484 13.081 40.3484 18.8058C40.3484 24.5305 35.9227 29.172 30.463 29.172C25.0033 29.172 20.5776 24.5305 20.5776 18.8058ZM13.0059 18.8058C13.0059 30.5823 27.0852 46.6779 29.9553 49.8371C30.2312 50.1387 30.6948 50.1387 30.9684 49.8348C33.8362 46.664 47.9178 30.4918 47.9178 18.8058C47.9178 8.69704 40.1027 0.501953 30.463 0.501953C20.8233 0.501953 13.0059 8.69704 13.0059 18.8058Z",
    fill: "url(#paint301_radial_19952_150379)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 18.8061C20.587 13.0814 25.0127 8.43993 30.4724 8.43993C35.9321 8.43993 40.3578 13.0814 40.3578 18.8061C40.3578 24.5309 35.9321 29.1724 30.4724 29.1724C25.0127 29.1724 20.587 24.5309 20.587 18.8061ZM13.0176 18.8061C13.0176 30.5827 27.0946 46.6782 29.9647 49.8375C30.2406 50.1391 30.7042 50.1391 30.9778 49.8352C33.8456 46.6643 47.9272 30.4922 47.9272 18.8038C47.9272 8.69508 40.1121 0.5 30.4724 0.5C20.8327 0.5 13.0176 8.6974 13.0176 18.8061Z",
    fill: "url(#paint302_radial_19952_150379)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5987 18.8058C20.5987 13.081 25.0244 8.43956 30.4841 8.43956C35.9438 8.43956 40.3696 13.081 40.3696 18.8058C40.3696 24.5305 35.9438 29.172 30.4841 29.172C25.0244 29.172 20.5987 24.5305 20.5987 18.8058ZM13.0293 18.8058C13.0293 30.5823 27.1063 46.6802 29.9764 49.8395C30.2523 50.141 30.716 50.141 30.9895 49.8371C33.8573 46.664 47.939 30.4918 47.939 18.8058C47.939 8.69704 40.1238 0.501953 30.4841 0.501953C20.8444 0.501953 13.0293 8.69704 13.0293 18.8058Z",
    fill: "url(#paint303_radial_19952_150379)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6085 18.8058C20.6085 13.081 25.0342 8.43956 30.4939 8.43956C35.9536 8.43956 40.3793 13.081 40.3793 18.8058C40.3793 24.5305 35.9536 29.172 30.4939 29.172C25.0342 29.172 20.6085 24.5305 20.6085 18.8058ZM13.0391 18.8058C13.0391 30.5823 27.1161 46.6802 29.9862 49.8418C30.2621 50.1433 30.7257 50.1433 30.9993 49.8395C33.8671 46.6663 47.9464 30.4918 47.9464 18.8058C47.9464 8.69704 40.1313 0.501953 30.4916 0.501953C20.8519 0.501953 13.0391 8.69704 13.0391 18.8058Z",
    fill: "url(#paint304_radial_19952_150379)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5037 29.1716C25.044 29.1716 20.6182 24.5301 20.6182 18.8054C20.6182 13.0807 25.044 8.4392 30.5037 8.4392C35.9634 8.4392 40.3891 13.0807 40.3891 18.8054C40.3891 24.5301 35.9634 29.1716 30.5037 29.1716ZM30.5037 0.503906C20.864 0.503906 13.0488 8.69899 13.0488 18.8077C13.0488 30.5842 27.1258 46.6845 29.9959 49.8437C30.2718 50.1453 30.7355 50.1453 31.0091 49.8414C33.8769 46.6682 47.9562 30.4915 47.9562 18.8054C47.9585 8.69667 40.1433 0.503906 30.5037 0.503906Z",
    fill: "url(#paint305_radial_19952_150379)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2832 18.8054C13.2832 30.4915 27.3648 46.6682 30.2303 49.8414C30.5039 50.1453 30.9699 50.1453 31.2434 49.8437C34.1136 46.6821 48.1906 30.5819 48.1906 18.8077C48.1906 8.69899 40.3754 0.503906 30.7357 0.503906C21.096 0.503906 13.2832 8.69667 13.2832 18.8054ZM20.8526 18.8054C20.8526 13.0807 25.2783 8.4392 30.738 8.4392C36.1977 8.4392 40.6235 13.0807 40.6235 18.8054C40.6235 24.5301 36.1977 29.1716 30.738 29.1716C25.2783 29.1716 20.8526 24.5301 20.8526 18.8054Z",
    fill: "url(#paint306_radial_19952_150379)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.012346,
    d: "M30.618 29.1716C25.1235 29.1716 20.6676 24.5301 20.6676 18.8054C20.6676 13.0807 25.1235 8.4392 30.618 8.4392C36.1125 8.4392 40.5683 13.0807 40.5683 18.8054C40.5683 24.5301 36.1125 29.1716 30.618 29.1716ZM30.618 0.503906C20.9134 0.503906 13.0449 8.69899 13.0449 18.8077C13.0449 30.6005 27.2123 46.6845 30.1033 49.8414C30.3792 50.143 30.8475 50.143 31.1234 49.8391C34.0097 46.6659 48.1887 30.4915 48.1887 18.8054C48.1887 8.69667 40.3226 0.503906 30.618 0.503906Z",
    fill: "url(#paint307_radial_19952_150379)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.024691,
    d: "M30.627 29.1716C25.1349 29.1716 20.6813 24.5301 20.6813 18.8054C20.6813 13.0807 25.1349 8.4392 30.627 8.4392C36.1192 8.4392 40.5727 13.0807 40.5727 18.8054C40.5727 24.5301 36.1192 29.1716 30.627 29.1716ZM30.627 0.503906C20.9271 0.503906 13.0586 8.69899 13.0586 18.8077C13.0586 30.6167 27.2191 46.6845 30.1077 49.8391C30.3836 50.1406 30.8519 50.1406 31.1278 49.8368C34.0141 46.6659 48.1885 30.4938 48.1885 18.8077C48.1885 8.69667 40.3247 0.503906 30.627 0.503906Z",
    fill: "url(#paint308_radial_19952_150379)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.037037,
    d: "M30.6341 29.1716C25.1443 29.1716 20.693 24.5301 20.693 18.8054C20.693 13.0807 25.1443 8.4392 30.6341 8.4392C36.124 8.4392 40.5752 13.0807 40.5752 18.8054C40.5752 24.5301 36.124 29.1716 30.6341 29.1716ZM30.6341 0.503906C20.9388 0.503906 13.0703 8.69899 13.0703 18.8077C13.0726 30.6353 27.2238 46.6845 30.1102 49.8368C30.386 50.1383 30.8544 50.1383 31.1302 49.8345C34.0143 46.6636 48.1863 30.4938 48.1863 18.8077C48.1886 8.69667 40.3294 0.503906 30.6341 0.503906Z",
    fill: "url(#paint309_radial_19952_150379)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.049383,
    d: "M30.6428 29.1716C25.1553 29.1716 20.7063 24.5301 20.7063 18.8054C20.7063 13.0807 25.1553 8.4392 30.6428 8.4392C36.1303 8.4392 40.5792 13.0807 40.5792 18.8054C40.5792 24.5301 36.1303 29.1716 30.6428 29.1716ZM30.6428 0.503906C20.9521 0.503906 13.0836 8.69899 13.0859 18.8077C13.0883 30.6515 27.2302 46.6845 30.1165 49.8321C30.3924 50.1337 30.8607 50.1337 31.1366 49.8298C34.0206 46.6589 48.188 30.4938 48.188 18.8077C48.188 8.69667 40.3312 0.503906 30.6428 0.503906Z",
    fill: "url(#paint310_radial_19952_150379)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.061728,
    d: "M30.6499 29.1716C25.1647 29.1716 20.7181 24.5301 20.7181 18.8054C20.7181 13.0807 25.1647 8.4392 30.6499 8.4392C36.1351 8.4392 40.5817 13.0807 40.5817 18.8054C40.5817 24.5301 36.1351 29.1716 30.6499 29.1716ZM30.6499 0.503906C20.9638 0.503906 13.0953 8.69899 13.0977 18.8077C13.1 30.6678 27.2349 46.6845 30.1213 49.8298C30.3972 50.1314 30.8655 50.1314 31.1414 49.8275C34.0254 46.659 48.1882 30.4938 48.1882 18.8077C48.1882 8.69667 40.3359 0.503906 30.6499 0.503906Z",
    fill: "url(#paint311_radial_19952_150379)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.074074,
    d: "M30.6608 29.1716C25.178 29.1716 20.7337 24.5301 20.7337 18.8054C20.7337 13.0807 25.178 8.4392 30.6608 8.4392C36.1437 8.4392 40.588 13.0807 40.588 18.8054C40.588 24.5301 36.1437 29.1716 30.6608 29.1716ZM30.6608 0.503906C20.9794 0.503906 13.111 8.69899 13.1133 18.8077C13.1156 30.684 27.2413 46.6845 30.1276 49.8275C30.4035 50.129 30.8718 50.129 31.1477 49.8252C34.0294 46.6566 48.1922 30.4938 48.1922 18.8077C48.1899 8.69667 40.3423 0.503906 30.6608 0.503906Z",
    fill: "url(#paint312_radial_19952_150379)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08642,
    d: "M30.666 29.1716C25.1854 29.1716 20.7435 24.5301 20.7435 18.8054C20.7435 13.0807 25.1854 8.4392 30.666 8.4392C36.1465 8.4392 40.5885 13.0807 40.5885 18.8054C40.5885 24.5301 36.1465 29.1716 30.666 29.1716ZM30.666 0.503906C20.9892 0.503906 13.1207 8.69899 13.123 18.8077C13.1254 30.7002 27.2441 46.6845 30.1281 49.8252C30.404 50.1267 30.8723 50.1244 31.1459 49.8229C34.0276 46.6566 48.1857 30.4961 48.1857 18.81C48.188 8.69667 40.3428 0.503906 30.666 0.503906Z",
    fill: "url(#paint313_radial_19952_150379)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098765,
    d: "M30.677 29.1716C25.1987 29.1716 20.7591 24.5301 20.7591 18.8054C20.7591 13.0807 25.1987 8.4392 30.677 8.4392C36.1552 8.4392 40.5949 13.0807 40.5949 18.8054C40.5949 24.5301 36.1552 29.1716 30.677 29.1716ZM30.677 0.503906C21.0048 0.503906 13.1364 8.69899 13.1387 18.8077C13.1433 30.7188 27.2528 46.6845 30.1345 49.8205C30.4104 50.1221 30.8787 50.1198 31.1522 49.8182C34.0316 46.652 48.1874 30.4938 48.1874 18.8077C48.1898 8.69667 40.3491 0.503906 30.677 0.503906Z",
    fill: "url(#paint314_radial_19952_150379)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1111,
    d: "M30.686 29.1716C25.2124 29.1716 20.7727 24.5301 20.7727 18.8054C20.7727 13.0807 25.2101 8.4392 30.686 8.4392C36.1596 8.4392 40.5993 13.0807 40.5993 18.8054C40.5993 24.5301 36.1596 29.1716 30.686 29.1716ZM30.686 0.503906C21.0185 0.503906 13.15 8.69899 13.1523 18.8077C13.157 30.735 27.2572 46.6845 30.1389 49.8182C30.4148 50.1198 30.8807 50.1175 31.1566 49.8159C34.036 46.6497 48.1872 30.4961 48.1872 18.8077C48.1895 8.69667 40.3512 0.503906 30.686 0.503906Z",
    fill: "url(#paint315_radial_19952_150379)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1235,
    d: "M30.6927 29.1716C25.2214 29.1716 20.7841 24.5301 20.7841 18.8054C20.7841 13.0807 25.2191 8.4392 30.6927 8.4392C36.164 8.4392 40.6013 13.0807 40.6013 18.8054C40.6013 24.5301 36.164 29.1716 30.6927 29.1716ZM30.6927 0.503906C21.0299 0.503906 13.1614 8.69899 13.166 18.8077C13.1707 30.7513 27.2639 46.6845 30.1456 49.8159C30.4215 50.1175 30.8875 50.1151 31.1633 49.8136C34.0404 46.6497 48.1893 30.4961 48.1893 18.81C48.1893 8.69667 40.3556 0.503906 30.6927 0.503906Z",
    fill: "url(#paint316_radial_19952_150379)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1358,
    d: "M30.7018 29.1716C25.2328 29.1716 20.7978 24.5301 20.7978 18.8054C20.7978 13.0807 25.2328 8.4392 30.7018 8.4392C36.1707 8.4392 40.6057 13.0807 40.6057 18.8054C40.6057 24.5301 36.1707 29.1716 30.7018 29.1716ZM30.7018 0.503906C21.0435 0.503906 13.1751 8.69899 13.1797 18.8077C13.1843 30.7675 27.2683 46.6845 30.15 49.8113C30.4259 50.1128 30.8919 50.1105 31.1677 49.809C34.0448 46.645 48.189 30.4938 48.189 18.8077C48.189 8.69667 40.36 0.503906 30.7018 0.503906Z",
    fill: "url(#paint317_radial_19952_150379)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1481,
    d: "M30.7088 29.1716C25.2422 29.1716 20.8095 24.5301 20.8095 18.8054C20.8095 13.0807 25.2422 8.4392 30.7088 8.4392C36.1755 8.4392 40.6082 13.0807 40.6082 18.8054C40.6082 24.5301 36.1755 29.1716 30.7088 29.1716ZM30.7088 0.503906C21.0552 0.503906 13.1868 8.69899 13.1914 18.8077C13.196 30.7837 27.2731 46.6845 30.1524 49.8089C30.4283 50.1105 30.8943 50.1082 31.1702 49.8043C34.0473 46.6404 48.1892 30.4938 48.1892 18.8054C48.1892 8.69667 40.3624 0.503906 30.7088 0.503906Z",
    fill: "url(#paint318_radial_19952_150379)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1605,
    d: "M30.7179 29.1716C25.2535 29.1716 20.8232 24.5301 20.8232 18.8054C20.8232 13.0807 25.2535 8.4392 30.7179 8.4392C36.1822 8.4392 40.6126 13.0807 40.6126 18.8054C40.6126 24.5301 36.1822 29.1716 30.7179 29.1716ZM30.7179 0.503906C21.0689 0.503906 13.2004 8.69899 13.2051 18.8077C13.212 30.8023 27.2798 46.6821 30.1568 49.8066C30.4327 50.1082 30.8987 50.1059 31.1746 49.802C34.0493 46.6404 48.1889 30.4938 48.1889 18.8077C48.1889 8.69667 40.3668 0.503906 30.7179 0.503906Z",
    fill: "url(#paint319_radial_19952_150379)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1728,
    d: "M30.725 29.1716C25.2629 29.1716 20.8349 24.5301 20.8349 18.8054C20.8349 13.0807 25.2629 8.4392 30.725 8.4392C36.187 8.4392 40.615 13.0807 40.615 18.8054C40.615 24.5301 36.187 29.1716 30.725 29.1716ZM30.725 0.503906C21.0806 0.503906 13.2122 8.69899 13.2168 18.8077C13.2238 30.8185 27.2822 46.6822 30.1593 49.8043C30.4352 50.1035 30.9011 50.1035 31.177 49.7997C34.0518 46.6381 48.1867 30.4961 48.1867 18.8077C48.1891 8.69667 40.3693 0.503906 30.725 0.503906Z",
    fill: "url(#paint320_radial_19952_150379)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1852,
    d: "M30.7336 29.1716C25.2739 29.1716 20.8482 24.5301 20.8482 18.8054C20.8482 13.0807 25.2739 8.4392 30.7336 8.4392C36.1933 8.4392 40.6191 13.0807 40.6191 18.8054C40.6191 24.5301 36.1933 29.1716 30.7336 29.1716ZM30.7336 0.503906C21.0939 0.503906 13.2255 8.69899 13.2324 18.8077C13.2394 30.8348 27.2909 46.6821 30.1656 49.7997C30.4415 50.0989 30.9075 50.0989 31.1834 49.795C34.0558 46.6334 48.1885 30.4938 48.1885 18.8054C48.1885 8.69667 40.3733 0.503906 30.7336 0.503906Z",
    fill: "url(#paint321_radial_19952_150379)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1975,
    d: "M30.7427 29.1716C25.2853 29.1716 20.8619 24.5301 20.8619 18.8054C20.8619 13.0807 25.2853 8.4392 30.7427 8.4392C36.2001 8.4392 40.6235 13.0807 40.6235 18.8054C40.6235 24.5301 36.1977 29.1716 30.7427 29.1716ZM30.7427 0.503906C21.1076 0.503906 13.2391 8.69899 13.2461 18.8077C13.2531 30.851 27.2976 46.6822 30.1723 49.7973C30.4482 50.0966 30.9142 50.0943 31.1878 49.7927C34.0602 46.6334 48.1882 30.4961 48.1882 18.8077C48.1882 8.69667 40.3777 0.503906 30.7427 0.503906Z",
    fill: "url(#paint322_radial_19952_150379)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2099,
    d: "M30.7497 29.1716C25.2947 29.1716 20.8736 24.5301 20.8736 18.8054C20.8736 13.0807 25.2947 8.4392 30.7497 8.4392C36.2048 8.4392 40.6259 13.0807 40.6259 18.8054C40.6259 24.5301 36.2048 29.1716 30.7497 29.1716ZM30.7497 0.503906C21.1193 0.503906 13.2509 8.69899 13.2578 18.8077C13.2648 30.8696 27.3 46.6821 30.1748 49.795C30.4507 50.0943 30.9167 50.0919 31.1902 49.7904C34.0627 46.6311 48.1884 30.4961 48.1884 18.8077C48.1884 8.69667 40.3802 0.503906 30.7497 0.503906Z",
    fill: "url(#paint323_radial_19952_150379)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2222,
    d: "M30.7588 29.1716C25.3083 29.1716 20.8873 24.5301 20.8873 18.8054C20.8873 13.0807 25.306 8.4392 30.7588 8.4392C36.2115 8.4392 40.6303 13.0807 40.6303 18.8054C40.6303 24.5301 36.2092 29.1716 30.7588 29.1716ZM30.7588 0.503906C21.133 0.503906 13.2645 8.69899 13.2715 18.8077C13.2784 30.8858 27.3068 46.6821 30.1792 49.7904C30.4551 50.0896 30.9211 50.0873 31.1946 49.7858C34.0647 46.6265 48.1881 30.4938 48.1881 18.8077C48.1881 8.69667 40.3846 0.503906 30.7588 0.503906Z",
    fill: "url(#paint324_radial_19952_150379)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2346,
    d: "M30.7659 29.1716C25.3177 29.1716 20.899 24.5301 20.899 18.8054C20.899 13.0807 25.3154 8.4392 30.7659 8.4392C36.2163 8.4392 40.6327 13.0807 40.6327 18.8054C40.6327 24.5301 36.2163 29.1716 30.7659 29.1716ZM30.7659 0.503906C21.1447 0.503906 13.2786 8.69899 13.2832 18.8077C13.2925 30.902 27.3092 46.6821 30.1816 49.7881C30.4575 50.0873 30.9235 50.085 31.1971 49.7834C34.0672 46.6265 48.1859 30.4961 48.1859 18.8077C48.1882 8.69667 40.387 0.503906 30.7659 0.503906Z",
    fill: "url(#paint325_radial_19952_150379)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2469,
    d: "M30.7765 29.1716C25.3307 29.1716 20.9142 24.5301 20.9142 18.8054C20.9142 13.0807 25.3284 8.4392 30.7765 8.4392C36.2246 8.4392 40.6387 13.0807 40.6387 18.8054C40.6387 24.5301 36.2223 29.1716 30.7765 29.1716ZM30.7765 0.503906C21.16 0.503906 13.2938 8.69899 13.3008 18.8077C13.3101 30.9183 27.3198 46.6822 30.1899 49.7858C30.4658 50.085 30.9318 50.0827 31.2054 49.7811C34.0732 46.6242 48.1896 30.4961 48.1896 18.8077C48.1896 8.69667 40.393 0.503906 30.7765 0.503906Z",
    fill: "url(#paint326_radial_19952_150379)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2593,
    d: "M30.7836 29.1716C25.3401 29.1716 20.9283 24.5301 20.9283 18.8054C20.9283 13.0807 25.3401 8.4392 30.7836 8.4392C36.227 8.4392 40.6389 13.0807 40.6389 18.8054C40.6389 24.5301 36.227 29.1716 30.7836 29.1716ZM30.7836 0.503906C21.1717 0.503906 13.3055 8.69899 13.3125 18.8077C13.3218 30.9345 27.3246 46.6822 30.1924 49.7834C30.4683 50.0827 30.9343 50.0803 31.2078 49.7788C34.0756 46.6218 48.1874 30.4984 48.1874 18.8101C48.1897 8.69667 40.3978 0.503906 30.7836 0.503906Z",
    fill: "url(#paint327_radial_19952_150379)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2716,
    d: "M30.7926 29.1716C25.3514 29.1716 20.9419 24.5301 20.9419 18.8054C20.9419 13.0807 25.3538 8.4392 30.7926 8.4392C36.2338 8.4392 40.6433 13.0807 40.6433 18.8054C40.6433 24.5301 36.2338 29.1716 30.7926 29.1716ZM30.7926 0.503906C21.1854 0.503906 13.3192 8.69899 13.3262 18.8077C13.3354 30.9531 27.329 46.6821 30.1991 49.7788C30.475 50.078 30.941 50.0757 31.2145 49.7742C34.0823 46.6195 48.1895 30.4961 48.1895 18.8077C48.1895 8.69667 40.3998 0.503906 30.7926 0.503906Z",
    fill: "url(#paint328_radial_19952_150379)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.284,
    d: "M30.8016 29.1716C25.3628 29.1716 20.9556 24.5301 20.9556 18.8054C20.9556 13.0807 25.3651 8.4392 30.8016 8.4392C36.2382 8.4392 40.6477 13.0807 40.6477 18.8054C40.6477 24.5301 36.2382 29.1716 30.8016 29.1716ZM30.8016 0.503906C21.199 0.503906 13.3329 8.69899 13.3398 18.8077C13.3491 30.9693 27.3357 46.6821 30.2035 49.7765C30.4794 50.0757 30.9431 50.0734 31.2189 49.7718C34.0844 46.6172 48.1916 30.4961 48.1916 18.8077C48.1892 8.69667 40.4042 0.503906 30.8016 0.503906Z",
    fill: "url(#paint329_radial_19952_150379)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2963,
    d: "M30.8087 29.1716C25.3722 29.1716 20.9673 24.5301 20.9673 18.8054C20.9673 13.0807 25.3745 8.4392 30.8087 8.4392C36.2452 8.4392 40.6501 13.0807 40.6501 18.8054C40.6501 24.5301 36.2452 29.1716 30.8087 29.1716ZM30.8087 0.503906C21.2108 0.503906 13.3446 8.69899 13.3516 18.8077C13.3632 30.9855 27.3382 46.6821 30.206 49.7742C30.4818 50.0734 30.9455 50.0711 31.2214 49.7695C34.0869 46.6149 48.1894 30.4984 48.1894 18.81C48.1894 8.69667 40.4067 0.503906 30.8087 0.503906Z",
    fill: "url(#paint330_radial_19952_150379)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3086,
    d: "M30.8178 29.1716C25.3835 29.1716 20.981 24.5301 20.981 18.8054C20.981 13.0807 25.3859 8.4392 30.8178 8.4392C36.252 8.4392 40.6545 13.0807 40.6545 18.8054C40.6545 24.5301 36.2496 29.1716 30.8178 29.1716ZM30.8178 0.503906C21.2244 0.503906 13.3583 8.69899 13.3652 18.8077C13.3768 31.0018 27.3449 46.6822 30.2104 49.7695C30.4862 50.0687 30.9499 50.0641 31.2235 49.7626C34.0866 46.6102 48.1868 30.4938 48.1868 18.8054C48.1891 8.69667 40.4111 0.503906 30.8178 0.503906Z",
    fill: "url(#paint331_radial_19952_150379)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.321,
    d: "M30.8245 29.1716C25.3949 29.1716 20.9924 24.5301 20.9924 18.8054C20.9924 13.0807 25.3949 8.4392 30.8245 8.4392C36.254 8.4392 40.6566 13.0807 40.6566 18.8054C40.6566 24.5301 36.2564 29.1716 30.8245 29.1716ZM30.8245 0.503906C21.2358 0.503906 13.3696 8.69899 13.3789 18.8077C13.3905 31.018 27.3516 46.6822 30.2147 49.7672C30.4906 50.0664 30.9543 50.0618 31.2279 49.7602C34.091 46.6079 48.1866 30.4961 48.1866 18.8054C48.1889 8.69667 40.4155 0.503906 30.8245 0.503906Z",
    fill: "url(#paint332_radial_19952_150379)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M30.8335 29.1716C25.4063 29.1716 21.006 24.5301 21.006 18.8054C21.006 13.0807 25.4063 8.4392 30.8335 8.4392C36.2608 8.4392 40.661 13.0807 40.661 18.8054C40.661 24.5301 36.2608 29.1716 30.8335 29.1716ZM30.8335 0.503906C21.2495 0.503906 13.3833 8.69899 13.3926 18.8077C13.4042 31.0366 27.356 46.6821 30.2192 49.7649C30.495 50.0618 30.9587 50.0595 31.2323 49.7579C34.0954 46.6056 48.1863 30.4961 48.1863 18.8077C48.1887 8.69667 40.4176 0.503906 30.8335 0.503906Z",
    fill: "url(#paint333_radial_19952_150379)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3457,
    d: "M30.8406 29.1716C25.4157 29.1716 21.0178 24.5301 21.0178 18.8054C21.0178 13.0807 25.4157 8.4392 30.8406 8.4392C36.2655 8.4392 40.6634 13.0807 40.6634 18.8054C40.6634 24.5301 36.2678 29.1716 30.8406 29.1716ZM30.8406 0.503906C21.2612 0.503906 13.395 8.69899 13.4043 18.8077C13.4159 31.0528 27.3608 46.6822 30.2239 49.7626C30.4998 50.0595 30.9635 50.0571 31.237 49.7556C34.0979 46.6056 48.1888 30.4984 48.1888 18.8077C48.1888 8.69667 40.4223 0.503906 30.8406 0.503906Z",
    fill: "url(#paint334_radial_19952_150379)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.358,
    d: "M30.8496 29.1716C25.427 29.1716 21.0314 24.5301 21.0314 18.8054C21.0314 13.0807 25.427 8.4392 30.8496 8.4392C36.2722 8.4392 40.6678 13.0807 40.6678 18.8054C40.6678 24.5301 36.2722 29.1716 30.8496 29.1716ZM30.8496 0.503906C21.2749 0.503906 13.4087 8.69899 13.418 18.8077C13.4319 31.069 27.3651 46.6822 30.2283 49.7579C30.5042 50.0548 30.9679 50.0525 31.2414 49.751C34.1023 46.601 48.1885 30.4961 48.1885 18.8077C48.1885 8.69667 40.4244 0.503906 30.8496 0.503906Z",
    fill: "url(#paint335_radial_19952_150379)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3704,
    d: "M30.8587 29.1716C25.4384 29.1716 21.0451 24.5301 21.0451 18.8054C21.0451 13.0807 25.4384 8.4392 30.8587 8.4392C36.279 8.4392 40.6722 13.0807 40.6722 18.8054C40.6722 24.5301 36.279 29.1716 30.8587 29.1716ZM30.8587 0.503906C21.2885 0.503906 13.4224 8.69899 13.4316 18.8077C13.4456 31.0853 27.3719 46.6822 30.2327 49.7556C30.5086 50.0525 30.9723 50.0502 31.2458 49.7486C34.1044 46.601 48.1883 30.4961 48.1883 18.8077C48.1883 8.69667 40.4288 0.503906 30.8587 0.503906Z",
    fill: "url(#paint336_radial_19952_150379)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3827,
    d: "M30.8654 29.1716C25.4474 29.1716 21.0565 24.5301 21.0565 18.8054C21.0565 13.0807 25.4474 8.4392 30.8654 8.4392C36.2834 8.4392 40.6743 13.0807 40.6743 18.8054C40.6743 24.5301 36.2834 29.1716 30.8654 29.1716ZM30.8654 0.503906C21.2999 0.503906 13.4337 8.69899 13.4453 18.8077C13.4592 31.1015 27.3786 46.6822 30.2371 49.7533C30.513 50.0502 30.9767 50.0479 31.2502 49.7463C34.1088 46.5987 48.1881 30.4984 48.1881 18.8077C48.1881 8.69667 40.4332 0.503906 30.8654 0.503906Z",
    fill: "url(#paint337_radial_19952_150379)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3951,
    d: "M30.8764 29.1716C25.4607 29.1716 21.0721 24.5301 21.0721 18.8054C21.0721 13.0807 25.463 8.4392 30.8764 8.4392C36.2897 8.4392 40.6807 13.0807 40.6807 18.8054C40.6807 24.5301 36.2897 29.1716 30.8764 29.1716ZM30.8764 0.503906C21.3155 0.503906 13.4494 8.69899 13.461 18.8077C13.4749 31.1201 27.3849 46.6821 30.2435 49.7486C30.5193 50.0455 30.983 50.0432 31.2566 49.7417C34.1151 46.594 48.1898 30.4961 48.1898 18.8077C48.1898 8.69667 40.4372 0.503906 30.8764 0.503906Z",
    fill: "url(#paint338_radial_19952_150379)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4074,
    d: "M30.8835 29.1716C25.4701 29.1716 21.0838 24.5301 21.0838 18.8054C21.0838 13.0807 25.4724 8.4392 30.8835 8.4392C36.2968 8.4392 40.6831 13.0807 40.6831 18.8054C40.6831 24.5301 36.2968 29.1716 30.8835 29.1716ZM30.8835 0.503906C21.3272 0.503906 13.4611 8.69899 13.4727 18.8077C13.4866 31.1363 27.3897 46.6822 30.2459 49.7463C30.5218 50.0432 30.9855 50.0409 31.259 49.7394C34.1152 46.594 48.1899 30.4984 48.1899 18.8077C48.1899 8.69667 40.442 0.503906 30.8835 0.503906Z",
    fill: "url(#paint339_radial_19952_150379)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4198,
    d: "M30.8925 29.1716C25.4815 29.1716 21.0975 24.5301 21.0975 18.8054C21.0975 13.0807 25.4838 8.4392 30.8925 8.4392C36.3035 8.4392 40.6875 13.0807 40.6875 18.8054C40.6875 24.5301 36.3012 29.1716 30.8925 29.1716ZM30.8925 0.503906C21.3386 0.503906 13.4747 8.69899 13.4863 18.8077C13.5026 31.1525 27.3941 46.6821 30.2526 49.744C30.5308 50.0409 30.9922 50.0363 31.2634 49.737C34.1196 46.5917 48.1897 30.4984 48.1897 18.8077C48.1897 8.69667 40.4441 0.503906 30.8925 0.503906Z",
    fill: "url(#paint340_radial_19952_150379)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4321,
    d: "M30.8996 29.1716C25.4932 29.1716 21.1092 24.5301 21.1092 18.8054C21.1092 13.0807 25.4932 8.4392 30.8996 8.4392C36.306 8.4392 40.69 13.0807 40.69 18.8054C40.69 24.5301 36.3083 29.1716 30.8996 29.1716ZM30.8996 0.503906C21.3503 0.503906 13.4865 8.69899 13.4981 18.8077C13.5143 31.1688 27.3989 46.6821 30.2551 49.7417C30.5333 50.0386 30.9946 50.0339 31.2659 49.7347C34.1198 46.5894 48.1875 30.4984 48.1875 18.81C48.1898 8.69667 40.4488 0.503906 30.8996 0.503906Z",
    fill: "url(#paint341_radial_19952_150379)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4444,
    d: "M30.9082 29.1716C25.5042 29.1716 21.1225 24.5301 21.1225 18.8054C21.1225 13.0807 25.5042 8.4392 30.9082 8.4392C36.3123 8.4392 40.694 13.0807 40.694 18.8054C40.694 24.5301 36.3123 29.1716 30.9082 29.1716ZM30.9082 0.503906C21.3636 0.503906 13.4998 8.69899 13.5137 18.8077C13.5299 31.1873 27.4075 46.6822 30.2614 49.737C30.5396 50.0339 30.9987 50.0293 31.2722 49.7301C34.1261 46.587 48.1892 30.4984 48.1892 18.8077C48.1892 8.69667 40.4529 0.503906 30.9082 0.503906Z",
    fill: "url(#paint342_radial_19952_150379)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4568,
    d: "M30.9173 29.1716C25.5155 29.1716 21.1362 24.5301 21.1362 18.8054C21.1362 13.0807 25.5155 8.4392 30.9173 8.4392C36.319 8.4392 40.6984 13.0807 40.6984 18.8054C40.6984 24.5301 36.319 29.1716 30.9173 29.1716ZM30.9173 0.503906C21.3773 0.503906 13.5135 8.69899 13.5274 18.8077C13.5436 31.2036 27.4119 46.6822 30.2658 49.7347C30.544 50.0316 31.0031 50.027 31.2766 49.7278C34.1282 46.5847 48.189 30.4984 48.189 18.8077C48.189 8.69667 40.455 0.503906 30.9173 0.503906Z",
    fill: "url(#paint343_radial_19952_150379)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4691,
    d: "M30.9244 29.1716C25.5249 29.1716 21.1479 24.5301 21.1479 18.8054C21.1479 13.0807 25.5249 8.4392 30.9244 8.4392C36.3238 8.4392 40.7008 13.0807 40.7008 18.8054C40.7008 24.5301 36.3238 29.1716 30.9244 29.1716ZM30.9244 0.503906C21.389 0.503906 13.5252 8.69899 13.5391 18.8077C13.5553 31.2198 27.4167 46.6822 30.2683 49.7324C30.5465 50.0293 31.0055 50.0247 31.2791 49.7231C34.1306 46.5801 48.1868 30.4984 48.1868 18.8077C48.1891 8.69667 40.4597 0.503906 30.9244 0.503906Z",
    fill: "url(#paint344_radial_19952_150379)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4815,
    d: "M30.9334 29.1716C25.5363 29.1716 21.1616 24.5301 21.1616 18.8054C21.1616 13.0807 25.5363 8.4392 30.9334 8.4392C36.3305 8.4392 40.7052 13.0807 40.7052 18.8054C40.7052 24.5301 36.3305 29.1716 30.9334 29.1716ZM30.9334 0.503906C21.4027 0.503906 13.5388 8.69899 13.5528 18.8077C13.5713 31.2361 27.4211 46.6822 30.2727 49.7278C30.5509 50.0247 31.0099 50.02 31.2835 49.7185C34.135 46.5778 48.1889 30.4961 48.1889 18.8054C48.1889 8.69667 40.4618 0.503906 30.9334 0.503906Z",
    fill: "url(#paint345_radial_19952_150379)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4938,
    d: "M30.9405 29.1716C25.5457 29.1716 21.1733 24.5301 21.1733 18.8054C21.1733 13.0807 25.5457 8.4392 30.9405 8.4392C36.3353 8.4392 40.7077 13.0807 40.7077 18.8054C40.7077 24.5301 36.3353 29.1716 30.9405 29.1716ZM30.9405 0.503906C21.4144 0.503906 13.5506 8.69899 13.5645 18.8077C13.583 31.2523 27.4259 46.6822 30.2774 49.7254C30.5556 50.0224 31.0147 50.0177 31.2882 49.7162C34.1375 46.5755 48.189 30.4984 48.189 18.8054C48.189 8.69667 40.4666 0.503906 30.9405 0.503906Z",
    fill: "url(#paint346_radial_19952_150379)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5062,
    d: "M30.9495 29.1716C25.557 29.1716 21.187 24.5301 21.187 18.8054C21.187 13.0807 25.557 8.4392 30.9495 8.4392C36.342 8.4392 40.7121 13.0807 40.7121 18.8054C40.7121 24.5301 36.342 29.1716 30.9495 29.1716ZM30.9495 0.503906C21.4281 0.503906 13.5642 8.69899 13.5781 18.8077C13.5967 31.2708 27.4326 46.6822 30.2818 49.7231C30.56 50.0177 31.0191 50.0154 31.2926 49.7138C34.1419 46.5731 48.1888 30.4984 48.1888 18.8077C48.1888 8.69667 40.471 0.503906 30.9495 0.503906Z",
    fill: "url(#paint347_radial_19952_150379)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5185,
    d: "M30.9562 29.1716C25.5661 29.1716 21.1983 24.5301 21.1983 18.8054C21.1983 13.0807 25.5661 8.4392 30.9562 8.4392C36.3464 8.4392 40.7142 13.0807 40.7142 18.8054C40.7142 24.5301 36.3464 29.1716 30.9562 29.1716ZM30.9562 0.503906C21.4394 0.503906 13.5756 8.69899 13.5918 18.8077C13.6104 31.2871 27.437 46.6821 30.2862 49.7208C30.5644 50.0154 31.0235 50.0131 31.297 49.7115C34.144 46.5731 48.1885 30.4984 48.1885 18.8077C48.1885 8.69667 40.4731 0.503906 30.9562 0.503906Z",
    fill: "url(#paint348_radial_19952_150379)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5309,
    d: "M30.9653 29.1716C25.5798 29.1716 21.212 24.5301 21.212 18.8054C21.212 13.0807 25.5798 8.4392 30.9653 8.4392C36.3508 8.4392 40.7186 13.0807 40.7186 18.8054C40.7186 24.5301 36.3508 29.1716 30.9653 29.1716ZM30.9653 0.503906C21.4531 0.503906 13.5893 8.69899 13.6055 18.8077C13.624 31.3033 27.4437 46.6822 30.2906 49.7162C30.5688 50.0107 31.0279 50.0061 31.2991 49.7069C34.1461 46.5685 48.186 30.4984 48.186 18.8077C48.1883 8.69667 40.4775 0.503906 30.9653 0.503906Z",
    fill: "url(#paint349_radial_19952_150379)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5432,
    d: "M30.9743 29.1716C25.5911 29.1716 21.2257 24.5301 21.2257 18.8054C21.2257 13.0807 25.5911 8.4392 30.9743 8.4392C36.3575 8.4392 40.723 13.0807 40.723 18.8054C40.723 24.5301 36.3575 29.1716 30.9743 29.1716ZM30.9743 0.503906C21.4668 0.503906 13.6052 8.69899 13.6192 18.8077C13.64 31.3196 27.4481 46.6821 30.295 49.7138C30.5732 50.0084 31.0323 50.0038 31.3035 49.7046C34.1504 46.5662 48.188 30.4984 48.188 18.8077C48.188 8.69667 40.4795 0.503906 30.9743 0.503906Z",
    fill: "url(#paint350_radial_19952_150379)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5556,
    d: "M30.9814 29.1716C25.6005 29.1716 21.2374 24.5301 21.2374 18.8054C21.2374 13.0807 25.6005 8.4392 30.9814 8.4392C36.3623 8.4392 40.7254 13.0807 40.7254 18.8054C40.7254 24.5301 36.3623 29.1716 30.9814 29.1716ZM30.9814 0.503906C21.4785 0.503906 13.617 8.69899 13.6309 18.8077C13.6517 31.3358 27.4529 46.6822 30.2975 49.7115C30.5757 50.0061 31.0347 50.0015 31.306 49.7022C34.1506 46.5662 48.1858 30.5007 48.1858 18.8077C48.1882 8.69667 40.4843 0.503906 30.9814 0.503906Z",
    fill: "url(#paint351_radial_19952_150379)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5679,
    d: "M30.9924 29.1716C25.6138 29.1716 21.253 24.5301 21.253 18.8054C21.253 13.0807 25.6138 8.4392 30.9924 8.4392C36.3709 8.4392 40.7317 13.0807 40.7317 18.8054C40.7317 24.5301 36.3709 29.1716 30.9924 29.1716ZM30.9924 0.503906C21.4941 0.503906 13.6326 8.69899 13.6465 18.8077C13.6674 31.3544 27.4615 46.6821 30.3061 49.7092C30.5843 50.0038 31.0434 49.9992 31.3146 49.6999C34.1592 46.5639 48.1899 30.5007 48.1899 18.81C48.1899 8.69667 40.4906 0.503906 30.9924 0.503906Z",
    fill: "url(#paint352_radial_19952_150379)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5802,
    d: "M30.9991 29.1716C25.6229 29.1716 21.2644 24.5301 21.2644 18.8054C21.2644 13.0807 25.6229 8.4392 30.9991 8.4392C36.3754 8.4392 40.7338 13.0807 40.7338 18.8054C40.7338 24.5301 36.3754 29.1716 30.9991 29.1716ZM30.9991 0.503906C21.5055 0.503906 13.644 8.69899 13.6602 18.8077C13.681 31.3706 27.4659 46.6822 30.3106 49.7046C30.5888 49.9992 31.0478 49.9945 31.319 49.6953C34.1613 46.5592 48.1896 30.4984 48.1896 18.8077C48.1896 8.69667 40.4927 0.503906 30.9991 0.503906Z",
    fill: "url(#paint353_radial_19952_150379)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5926,
    d: "M31.0081 29.1716C25.6342 29.1716 21.278 24.5301 21.278 18.8054C21.278 13.0807 25.6342 8.4392 31.0081 8.4392C36.3821 8.4392 40.7382 13.0807 40.7382 18.8054C40.7382 24.5301 36.3821 29.1716 31.0081 29.1716ZM31.0081 0.503906C21.5191 0.503906 13.6576 8.69899 13.6739 18.8077C13.6947 31.3868 27.4727 46.6821 30.315 49.7022C30.5932 49.9968 31.0522 49.9922 31.3234 49.693C34.1657 46.5592 48.1894 30.5007 48.1894 18.8077C48.1894 8.69667 40.4971 0.503906 31.0081 0.503906Z",
    fill: "url(#paint354_radial_19952_150379)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6049,
    d: "M31.0152 29.1716C25.6436 29.1716 21.2897 24.5301 21.2897 18.8054C21.2897 13.0807 25.6436 8.4392 31.0152 8.4392C36.3868 8.4392 40.7407 13.0807 40.7407 18.8054C40.7407 24.5301 36.3868 29.1716 31.0152 29.1716ZM31.0152 0.503906C21.5309 0.503906 13.6693 8.69899 13.6856 18.8077C13.7064 31.4031 27.4751 46.6822 30.3174 49.6999C30.5956 49.9945 31.0546 49.9899 31.3259 49.6907C34.1682 46.5569 48.1872 30.5007 48.1872 18.8101C48.1895 8.69667 40.4996 0.503906 31.0152 0.503906Z",
    fill: "url(#paint355_radial_19952_150379)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6173,
    d: "M31.0243 29.1716C25.655 29.1716 21.3034 24.5301 21.3034 18.8054C21.3034 13.0807 25.655 8.4392 31.0243 8.4392C36.3935 8.4392 40.7451 13.0807 40.7451 18.8054C40.7451 24.5301 36.3935 29.1716 31.0243 29.1716ZM31.0243 0.503906C21.5445 0.503906 13.683 8.69899 13.6992 18.8077C13.7224 31.4193 27.4818 46.6798 30.3218 49.6953C30.6 49.9899 31.0567 49.9852 31.3303 49.686C34.1702 46.5523 48.1893 30.5007 48.1893 18.8077C48.1893 8.69667 40.504 0.503906 31.0243 0.503906Z",
    fill: "url(#paint356_radial_19952_150379)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6296,
    d: "M31.0313 29.1716C25.6644 29.1716 21.3151 24.5301 21.3151 18.8054C21.3151 13.0807 25.6644 8.4392 31.0313 8.4392C36.3983 8.4392 40.7475 13.0807 40.7475 18.8054C40.7475 24.5301 36.3983 29.1716 31.0313 29.1716ZM31.0313 0.503906C21.5563 0.503906 13.6947 8.69899 13.711 18.8077C13.7341 31.4379 27.4866 46.6798 30.3242 49.693C30.6024 49.9876 31.0592 49.9829 31.3327 49.6814C34.1727 46.5499 48.1871 30.4984 48.1871 18.8054C48.1894 8.69667 40.5087 0.503906 31.0313 0.503906Z",
    fill: "url(#paint357_radial_19952_150379)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.642,
    d: "M31.04 29.1716C25.6777 29.1716 21.3285 24.5301 21.3285 18.8054C21.3285 13.0807 25.6753 8.4392 31.04 8.4392C36.4023 8.4392 40.7516 13.0807 40.7516 18.8054C40.7516 24.5301 36.4023 29.1716 31.04 29.1716ZM31.04 0.503906C21.5696 0.503906 13.708 8.69899 13.7266 18.8077C13.7498 31.4541 27.4929 46.6798 30.3329 49.6906C30.6111 49.9852 31.0678 49.9806 31.3391 49.679C34.1767 46.5476 48.1888 30.5007 48.1888 18.8077C48.1888 8.69667 40.5105 0.503906 31.04 0.503906Z",
    fill: "url(#paint358_radial_19952_150379)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6543,
    d: "M31.049 29.1716C25.689 29.1716 21.3421 24.5301 21.3421 18.8054C21.3421 13.0807 25.689 8.4392 31.049 8.4392C36.4091 8.4392 40.756 13.0807 40.756 18.8054C40.756 24.5301 36.4091 29.1716 31.049 29.1716ZM31.049 0.503906C21.5832 0.503906 13.7217 8.69899 13.7403 18.8077C13.7635 31.4703 27.4997 46.6798 30.3373 49.6883C30.6155 49.9829 31.0722 49.976 31.3435 49.6767C34.1811 46.5476 48.1886 30.5007 48.1886 18.8077C48.1886 8.69667 40.5149 0.503906 31.049 0.503906Z",
    fill: "url(#paint359_radial_19952_150379)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M31.0561 29.1716C25.6984 29.1716 21.3538 24.5301 21.3538 18.8054C21.3538 13.0807 25.6984 8.4392 31.0561 8.4392C36.4138 8.4392 40.7584 13.0807 40.7584 18.8054C40.7584 24.5301 36.4138 29.1716 31.0561 29.1716ZM31.0561 0.503906C21.595 0.503906 13.7334 8.69899 13.752 18.8077C13.7752 31.4866 27.5044 46.6798 30.3398 49.6837C30.618 49.976 31.0747 49.9713 31.3459 49.6721C34.1836 46.543 48.1864 30.4984 48.1864 18.8054C48.1887 8.69667 40.5173 0.503906 31.0561 0.503906Z",
    fill: "url(#paint360_radial_19952_150379)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.679,
    d: "M31.0652 29.1716C25.7098 29.1716 21.3675 24.5301 21.3675 18.8054C21.3675 13.0807 25.7098 8.44152 31.0652 8.44152C36.4205 8.44152 40.7628 13.083 40.7628 18.8077C40.7628 24.5325 36.4205 29.1716 31.0652 29.1716ZM31.0652 0.503906C21.6086 0.503906 13.7471 8.69899 13.7657 18.8077C13.7912 31.5028 27.5088 46.6798 30.3442 49.6814C30.6224 49.9736 31.0791 49.969 31.3503 49.6698C34.1857 46.5407 48.1885 30.5007 48.1885 18.8077C48.1885 8.69667 40.5217 0.503906 31.0652 0.503906Z",
    fill: "url(#paint361_radial_19952_150379)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6914,
    d: "M31.0722 29.1716C25.7192 29.1716 21.3792 24.5301 21.3792 18.8054C21.3792 13.0807 25.7192 8.4392 31.0722 8.4392C36.4253 8.4392 40.7653 13.0807 40.7653 18.8054C40.7653 24.5301 36.4253 29.1716 31.0722 29.1716ZM31.0722 0.503906C21.6203 0.503906 13.7588 8.69899 13.7774 18.8077C13.8029 31.5214 27.5136 46.6798 30.3466 49.679C30.6248 49.9713 31.0815 49.9667 31.3528 49.6674C34.1881 46.5406 48.1863 30.5007 48.1863 18.8077C48.1886 8.69667 40.5241 0.503906 31.0722 0.503906Z",
    fill: "url(#paint362_radial_19952_150379)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7037,
    d: "M31.0809 29.1716C25.7302 29.1716 21.3926 24.5301 21.3926 18.8054C21.3926 13.0807 25.7302 8.4392 31.0809 8.4392C36.4317 8.4392 40.7693 13.0807 40.7693 18.8054C40.7693 24.5301 36.4317 29.1716 31.0809 29.1716ZM31.0809 0.503906C21.6337 0.503906 13.7721 8.69899 13.793 18.8077C13.8185 31.5376 27.5199 46.6798 30.353 49.6744C30.6312 49.9667 31.0879 49.962 31.3591 49.6628C34.1921 46.536 48.188 30.5007 48.188 18.8077C48.188 8.69667 40.5282 0.503906 31.0809 0.503906Z",
    fill: "url(#paint363_radial_19952_150379)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.716,
    d: "M31.088 29.1716C25.7396 29.1716 21.4043 24.5301 21.4043 18.8054C21.4043 13.0807 25.7396 8.4392 31.088 8.4392C36.4364 8.4392 40.7717 13.0807 40.7717 18.8054C40.7717 24.5301 36.4364 29.1716 31.088 29.1716ZM31.088 0.503906C21.6454 0.503906 13.7839 8.69899 13.8047 18.8077C13.8302 31.5538 27.5247 46.6798 30.3577 49.6721C30.6359 49.9644 31.0926 49.9597 31.3639 49.6605C34.1969 46.5337 48.1881 30.5007 48.1881 18.8077C48.1881 8.69667 40.533 0.503906 31.088 0.503906Z",
    fill: "url(#paint364_radial_19952_150379)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7284,
    d: "M31.099 29.1716C25.7529 29.1716 21.4199 24.5301 21.4199 18.8054C21.4199 13.0807 25.7529 8.4392 31.099 8.4392C36.4451 8.4392 40.7781 13.0807 40.7781 18.8054C40.7781 24.5301 36.4451 29.1716 31.099 29.1716ZM31.099 0.503906C21.661 0.503906 13.7995 8.69899 13.8204 18.8077C13.8459 31.5701 27.5334 46.6798 30.3641 49.6698C30.6423 49.962 31.099 49.9574 31.3702 49.6582C34.2009 46.5337 48.1898 30.5007 48.1898 18.8077C48.1898 8.69667 40.537 0.503906 31.099 0.503906Z",
    fill: "url(#paint365_radial_19952_150379)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7407,
    d: "M31.108 29.1716C25.7666 29.1716 21.4336 24.5301 21.4336 18.8054C21.4336 13.0807 25.7642 8.4392 31.108 8.4392C36.4518 8.4392 40.7825 13.0807 40.7825 18.8054C40.7825 24.5301 36.4495 29.1716 31.108 29.1716ZM31.108 0.503906C21.6747 0.503906 13.8132 8.69899 13.834 18.8077C13.8618 31.5886 27.5378 46.6798 30.3685 49.6674C30.6467 49.9597 31.1034 49.9551 31.3746 49.6559C34.2053 46.5314 48.1896 30.5031 48.1896 18.81C48.1896 8.69667 40.5414 0.503906 31.108 0.503906Z",
    fill: "url(#paint366_radial_19952_150379)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7531,
    d: "M31.1151 29.1716C25.776 29.1716 21.4453 24.5301 21.4453 18.8054C21.4453 13.0807 25.7736 8.4392 31.1151 8.4392C36.4566 8.4392 40.7849 13.0807 40.7849 18.8054C40.7849 24.5301 36.4566 29.1716 31.1151 29.1716ZM31.1151 0.503906C21.6864 0.503906 13.8249 8.69899 13.8457 18.8077C13.8736 31.6049 27.5425 46.6798 30.3709 49.6628C30.6491 49.9551 31.1058 49.9504 31.3748 49.6512C34.2055 46.5267 48.1874 30.5007 48.1874 18.8077C48.1897 8.69667 40.5438 0.503906 31.1151 0.503906Z",
    fill: "url(#paint367_radial_19952_150379)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7654,
    d: "M31.1241 29.1716C25.7873 29.1716 21.459 24.5301 21.459 18.8054C21.459 13.0807 25.785 8.4392 31.1241 8.4392C36.461 8.4392 40.7893 13.0807 40.7893 18.8054C40.7893 24.5301 36.461 29.1716 31.1241 29.1716ZM31.1241 0.503906C21.7001 0.503906 13.8386 8.69899 13.8594 18.8077C13.8872 31.6211 27.5469 46.6798 30.3753 49.6605C30.6535 49.9528 31.1102 49.9458 31.3792 49.6489C34.2075 46.5267 48.1872 30.5031 48.1872 18.8077C48.1895 8.69667 40.5482 0.503906 31.1241 0.503906Z",
    fill: "url(#paint368_radial_19952_150379)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7778,
    d: "M31.1309 29.1716C25.7964 29.1716 21.4703 24.5301 21.4703 18.8054C21.4703 13.0807 25.794 8.4392 31.1309 8.4392C36.4654 8.4392 40.7914 13.0807 40.7914 18.8054C40.7914 24.5301 36.4654 29.1716 31.1309 29.1716ZM31.1309 0.503906C21.7114 0.503906 13.8499 8.69899 13.8731 18.8077C13.9009 31.6373 27.5537 46.6798 30.3797 49.6582C30.6579 49.9504 31.1146 49.9435 31.3836 49.6466C34.212 46.5244 48.187 30.5031 48.187 18.81C48.1893 8.69667 40.5526 0.503906 31.1309 0.503906Z",
    fill: "url(#paint369_radial_19952_150379)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7901,
    d: "M31.1399 29.1716C25.8077 29.1716 21.484 24.5301 21.484 18.8054C21.484 13.0807 25.8077 8.4392 31.1399 8.4392C36.4721 8.4392 40.7958 13.0807 40.7958 18.8054C40.7958 24.5301 36.4721 29.1716 31.1399 29.1716ZM31.1399 0.503906C21.7251 0.503906 13.8636 8.69899 13.8868 18.8077C13.9146 31.6536 27.5604 46.6798 30.3864 49.6535C30.6646 49.9458 31.119 49.9388 31.3903 49.6396C34.2164 46.5175 48.189 30.5007 48.189 18.8054C48.189 8.69667 40.5547 0.503906 31.1399 0.503906Z",
    fill: "url(#paint370_radial_19952_150379)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8025,
    d: "M31.147 29.1716C25.8171 29.1716 21.4957 24.5301 21.4957 18.8054C21.4957 13.0807 25.8171 8.4392 31.147 8.4392C36.4769 8.4392 40.7983 13.0807 40.7983 18.8054C40.7983 24.5301 36.4769 29.1716 31.147 29.1716ZM31.147 0.503906C21.7368 0.503906 13.8753 8.69899 13.8985 18.8077C13.9286 31.6721 27.5628 46.6798 30.3889 49.6512C30.6671 49.9435 31.1215 49.9365 31.3927 49.6373C34.2188 46.5175 48.1868 30.5007 48.1868 18.8054C48.1892 8.69667 40.5595 0.503906 31.147 0.503906Z",
    fill: "url(#paint371_radial_19952_150379)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8148,
    d: "M31.156 29.1716C25.8285 29.1716 21.5094 24.5301 21.5094 18.8054C21.5094 13.0807 25.8285 8.4392 31.156 8.4392C36.4836 8.4392 40.8027 13.0807 40.8027 18.8054C40.8027 24.5301 36.4836 29.1716 31.156 29.1716ZM31.156 0.503906C21.7505 0.503906 13.889 8.69899 13.9122 18.8077C13.9423 31.6884 27.5695 46.6798 30.3933 49.6489C30.6715 49.9412 31.1259 49.9342 31.3971 49.635C34.2232 46.5151 48.1889 30.5007 48.1889 18.8077C48.1889 8.69667 40.5616 0.503906 31.156 0.503906Z",
    fill: "url(#paint372_radial_19952_150379)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8272,
    d: "M31.1651 29.1716C25.8398 29.1716 21.5231 24.5301 21.5231 18.8054C21.5231 13.0807 25.8398 8.4392 31.1651 8.4392C36.4903 8.4392 40.8071 13.0807 40.8071 18.8054C40.8071 24.5301 36.488 29.1716 31.1651 29.1716ZM31.1651 0.503906C21.7642 0.503906 13.9026 8.69899 13.9258 18.8077C13.956 31.7046 27.5739 46.6798 30.3977 49.6466C30.6759 49.9388 31.1303 49.9319 31.4015 49.6327C34.2253 46.5128 48.1887 30.5031 48.1887 18.8077C48.1887 8.69667 40.566 0.503906 31.1651 0.503906Z",
    fill: "url(#paint373_radial_19952_150379)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8395,
    d: "M31.1718 29.1716C25.8489 29.1716 21.5367 24.5301 21.5367 18.8054C21.5367 13.0807 25.8512 8.4392 31.1718 8.4392C36.4947 8.4392 40.8068 13.0807 40.8068 18.8054C40.8068 24.5301 36.4947 29.1716 31.1718 29.1716ZM31.1718 0.503906C21.7732 0.503906 13.914 8.69899 13.9395 18.8077C13.9697 31.7208 27.5807 46.6798 30.4021 49.6419C30.6803 49.9319 31.1347 49.9272 31.4059 49.628C34.2297 46.5105 48.1885 30.5007 48.1885 18.8077C48.1885 8.69667 40.5704 0.503906 31.1718 0.503906Z",
    fill: "url(#paint374_radial_19952_150379)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8519,
    d: "M31.1808 29.1716C25.8625 29.1716 21.5504 24.5301 21.5504 18.8054C21.5504 13.0807 25.8625 8.4392 31.1808 8.4392C36.4991 8.4392 40.8112 13.0807 40.8112 18.8054C40.8112 24.5301 36.4991 29.1716 31.1808 29.1716ZM31.1808 0.503906C21.7869 0.503906 13.9277 8.69899 13.9532 18.8077C13.9833 31.7371 27.5874 46.6798 30.4088 49.6396C30.687 49.9296 31.1414 49.9249 31.4127 49.6257C34.2341 46.5082 48.1905 30.5031 48.1905 18.8077C48.1882 8.69667 40.5725 0.503906 31.1808 0.503906Z",
    fill: "url(#paint375_radial_19952_150379)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8642,
    d: "M31.1879 29.1716C25.8719 29.1716 21.5621 24.5301 21.5621 18.8054C21.5621 13.0807 25.8719 8.4392 31.1879 8.4392C36.5039 8.4392 40.8137 13.0807 40.8137 18.8054C40.8137 24.5301 36.5062 29.1716 31.1879 29.1716ZM31.1879 0.503906C21.7986 0.503906 13.9417 8.69899 13.9649 18.8077C13.9974 31.7556 27.5898 46.6798 30.4113 49.6373C30.6895 49.9272 31.1438 49.9226 31.4128 49.6234C34.2342 46.5059 48.186 30.5031 48.186 18.8077C48.1883 8.69667 40.5772 0.503906 31.1879 0.503906Z",
    fill: "url(#paint376_radial_19952_150379)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8765,
    d: "M31.1969 29.1716C25.8833 29.1716 21.5758 24.5301 21.5758 18.8054C21.5758 13.0807 25.8833 8.4392 31.1969 8.4392C36.5106 8.4392 40.8181 13.0807 40.8181 18.8054C40.8181 24.5301 36.5106 29.1716 31.1969 29.1716ZM31.1969 0.503906C21.8123 0.503906 13.9554 8.69899 13.9786 18.8077C14.011 31.7719 27.5965 46.6798 30.4156 49.6327C30.6938 49.9226 31.1482 49.9157 31.4172 49.6187C34.2386 46.5035 48.1881 30.5007 48.1881 18.8077C48.1881 8.69667 40.5793 0.503906 31.1969 0.503906Z",
    fill: "url(#paint377_radial_19952_150379)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8889,
    d: "M31.204 29.1716C25.8927 29.1716 21.5875 24.5301 21.5875 18.8054C21.5875 13.0807 25.8927 8.4392 31.204 8.4392C36.5153 8.4392 40.8205 13.0807 40.8205 18.8054C40.8205 24.5301 36.5177 29.1716 31.204 29.1716ZM31.204 0.503906C21.824 0.503906 13.9671 8.69899 13.9903 18.8077C14.0227 31.7881 27.599 46.6798 30.4181 49.6303C30.6963 49.9203 31.1507 49.9133 31.4196 49.6164C34.2387 46.5012 48.1859 30.5031 48.1859 18.8077C48.1882 8.69667 40.584 0.503906 31.204 0.503906Z",
    fill: "url(#paint378_radial_19952_150379)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9012,
    d: "M31.2146 29.1716C25.9056 29.1716 21.6028 24.5301 21.6028 18.8054C21.6028 13.0807 25.9056 8.4392 31.2146 8.4392C36.5237 8.4392 40.8265 13.0807 40.8265 18.8054C40.8265 24.5301 36.5237 29.1716 31.2146 29.1716ZM31.2146 0.503906C21.8392 0.503906 13.9824 8.69899 14.0079 18.8077C14.0403 31.8044 27.6096 46.6798 30.4264 49.628C30.7046 49.918 31.159 49.911 31.4279 49.6141C34.247 46.4989 48.1896 30.5031 48.1896 18.8077C48.1896 8.69667 40.59 0.503906 31.2146 0.503906Z",
    fill: "url(#paint379_radial_19952_150379)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9136,
    d: "M31.2237 29.1716C25.917 29.1716 21.6164 24.5301 21.6164 18.8054C21.6164 13.0807 25.917 8.4392 31.2237 8.4392C36.5304 8.4392 40.8309 13.0807 40.8309 18.8054C40.8309 24.5301 36.5281 29.1716 31.2237 29.1716ZM31.2237 0.503906C21.8529 0.503906 13.996 8.69899 14.0215 18.8077C14.054 31.8206 27.6163 46.6798 30.4308 49.6257C30.709 49.9156 31.1634 49.9087 31.4323 49.6118C34.2491 46.4989 48.1893 30.5054 48.1893 18.81C48.1893 8.69667 40.5921 0.503906 31.2237 0.503906Z",
    fill: "url(#paint380_radial_19952_150379)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9259,
    d: "M31.2308 29.1716C25.9264 29.1716 21.6282 24.5301 21.6282 18.8054C21.6282 13.0807 25.9287 8.4392 31.2308 8.4392C36.5328 8.4392 40.8334 13.0807 40.8334 18.8054C40.8334 24.5301 36.5351 29.1716 31.2308 29.1716ZM31.2308 0.503906C21.8646 0.503906 14.0078 8.69899 14.0333 18.8077C14.068 31.8391 27.6188 46.6798 30.4356 49.6211C30.7138 49.911 31.1682 49.9041 31.4371 49.6071C34.2539 46.4943 48.1895 30.5031 48.1895 18.8077C48.1895 8.69667 40.5969 0.503906 31.2308 0.503906Z",
    fill: "url(#paint381_radial_19952_150379)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9383,
    d: "M31.2398 29.1716C25.9377 29.1716 21.6418 24.5301 21.6418 18.8054C21.6418 13.0807 25.9401 8.4392 31.2398 8.4392C36.5419 8.4392 40.8378 13.0807 40.8378 18.8054C40.8378 24.5301 36.5395 29.1716 31.2398 29.1716ZM31.2398 0.503906C21.8783 0.503906 14.0214 8.69899 14.0469 18.8077C14.0817 31.8554 27.6255 46.6798 30.44 49.6187C30.7182 49.9087 31.1726 49.9017 31.4415 49.6048C34.2583 46.4943 48.1892 30.5054 48.1892 18.8077C48.1892 8.69667 40.599 0.503906 31.2398 0.503906Z",
    fill: "url(#paint382_radial_19952_150379)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9506,
    d: "M31.2469 29.1716C25.9471 29.1716 21.6536 24.5301 21.6536 18.8054C21.6536 13.0807 25.9495 8.4392 31.2469 8.4392C36.5466 8.4392 40.8402 13.0807 40.8402 18.8054C40.8402 24.5301 36.5466 29.1716 31.2469 29.1716ZM31.2469 0.503906C21.89 0.503906 14.0332 8.69899 14.0587 18.8077C14.0934 31.8716 27.6279 46.6798 30.4424 49.6164C30.7206 49.9064 31.1727 49.8994 31.4439 49.6002C34.2584 46.4896 48.1894 30.5031 48.1894 18.8077C48.1894 8.69667 40.6037 0.503906 31.2469 0.503906Z",
    fill: "url(#paint383_radial_19952_150379)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M31.2559 29.1716C25.9608 29.1716 21.6672 24.5301 21.6672 18.8054C21.6672 13.0807 25.9608 8.4392 31.2559 8.4392C36.551 8.4392 40.8446 13.0807 40.8446 18.8054C40.8446 24.5301 36.551 29.1716 31.2559 29.1716ZM31.2559 0.503906C21.9037 0.503906 14.0468 8.69899 14.0723 18.8077C14.1071 31.8879 27.6347 46.6798 30.4468 49.6118C30.725 49.9017 31.1771 49.8948 31.4483 49.5956C34.2628 46.485 48.1891 30.5007 48.1891 18.8054C48.1891 8.69667 40.6081 0.503906 31.2559 0.503906Z",
    fill: "url(#paint384_radial_19952_150379)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9753,
    d: "M31.2626 29.1716C25.9699 29.1716 21.6786 24.5301 21.6786 18.8054C21.6786 13.0807 25.9699 8.4392 31.2626 8.4392C36.5554 8.4392 40.8467 13.0807 40.8467 18.8054C40.8467 24.5301 36.5577 29.1716 31.2626 29.1716ZM31.2626 0.503906C21.9151 0.503906 14.0582 8.69899 14.086 18.8077C14.1208 31.9064 27.6414 46.6798 30.4512 49.6095C30.7294 49.8994 31.1815 49.8925 31.4504 49.5932C34.2626 46.485 48.1866 30.5031 48.1866 18.8054C48.1889 8.69667 40.6102 0.503906 31.2626 0.503906Z",
    fill: "url(#paint385_radial_19952_150379)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9877,
    d: "M31.2717 29.1716C25.9812 29.1716 21.6923 24.5301 21.6923 18.8054C21.6923 13.0807 25.9812 8.4392 31.2717 8.4392C36.5621 8.4392 40.8511 13.0807 40.8511 18.8054C40.8511 24.5301 36.5621 29.1716 31.2717 29.1716ZM31.2717 0.503906C21.9287 0.503906 14.0719 8.69899 14.0997 18.8077C14.1368 31.9227 27.6458 46.6798 30.4556 49.6071C30.7338 49.8971 31.1859 49.8878 31.4548 49.5909C34.267 46.4827 48.1863 30.5031 48.1863 18.8077C48.1887 8.69667 40.6146 0.503906 31.2717 0.503906Z",
    fill: "url(#paint386_radial_19952_150379)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2807 29.1716C25.9926 29.1716 21.7059 24.5301 21.7059 18.8054C21.7059 13.0807 25.9926 8.4392 31.2807 8.4392C36.5689 8.4392 40.8555 13.0807 40.8555 18.8054C40.8555 24.5301 36.5689 29.1716 31.2807 29.1716ZM31.2807 0.503906C21.9424 0.503906 14.0855 8.69899 14.1134 18.8077C14.1504 31.9389 27.6525 46.6798 30.4623 49.6048C30.7405 49.8948 31.1926 49.8855 31.4615 49.5886C34.2714 46.4803 48.1884 30.5054 48.1884 18.8077C48.1884 8.69667 40.6167 0.503906 31.2807 0.503906Z",
    fill: "url(#paint387_radial_19952_150379)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19952_150379",
    x1: 52.2552,
    y1: 55.9179,
    x2: 38.6646,
    y2: 66.7432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8972,
    stopColor: "#A4BCF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19952_150379",
    x1: 44.6971,
    y1: 52.0626,
    x2: 27.9347,
    y2: 65.4143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85A6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19952_150379",
    x1: 21.9541,
    y1: 49.0193,
    x2: -2.26274,
    y2: 68.3087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85A6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19952_150379",
    x1: 31.1142,
    y1: 52.2591,
    x2: 13.275,
    y2: 66.4685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0312771,
    stopColor: "#C2D3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4457 2.97434) scale(48.8561 48.8822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4872 2.97862) scale(48.8597 48.8857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.529 2.98249) scale(48.8634 48.8894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5704 2.98603) scale(48.867 48.893)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6102 2.98995) scale(48.8706 48.8967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6516 2.99418) scale(48.8743 48.9004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.693 2.9981) scale(48.8784 48.9044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7348 3.00165) scale(48.8821 48.9081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7762 3.00593) scale(48.8858 48.9118)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.818 3.00979) scale(48.8896 48.9156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8594 3.01371) scale(48.8934 48.9194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8992 3.01726) scale(48.8972 48.9232)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9406 3.02149) scale(48.9014 48.9274)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9824 3.02541) scale(48.9052 48.9313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0238 3.02896) scale(48.9091 48.9351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0655 3.03288) scale(48.913 48.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1069 3.03711) scale(48.9169 48.943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E71C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1483 3.04103) scale(48.9208 48.9469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1881 3.04458) scale(48.9251 48.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2295 3.04882) scale(48.9292 48.9552)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2713 3.0531) scale(48.9332 48.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3127 3.05702) scale(48.9372 48.9633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3544 3.06057) scale(48.9412 48.9673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3958 3.06444) scale(48.9453 48.9714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4356 3.06836) scale(48.9498 48.9758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.477 3.07264) scale(48.9539 48.9799)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5187 3.07615) scale(48.958 48.9841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5601 3.08007) scale(48.9622 48.9883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6015 3.08435) scale(48.9664 48.9925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6432 3.08791) scale(48.9709 48.997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6846 3.09178) scale(48.9752 49.0013)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7244 3.09607) scale(48.9794 49.0055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7657 3.09999) scale(48.9837 49.0098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8075 3.1035) scale(48.988 49.0141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8488 3.10742) scale(48.9923 49.0184)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8906 3.11171) scale(48.997 49.0231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9319 3.11558) scale(49.0014 49.0275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9717 3.11914) scale(49.0057 49.0319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.013 3.12306) scale(49.0101 49.0363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0544 3.12735) scale(49.0146 49.0407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0961 3.13123) scale(49.0191 49.0452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1374 3.13478) scale(49.0238 49.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1791 3.13871) scale(49.0283 49.0545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2205 3.14295) scale(49.0329 49.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2603 3.14651) scale(49.0374 49.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3016 3.15043) scale(49.042 49.0681)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3433 3.15436) scale(49.0466 49.0727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3846 3.1586) scale(49.0515 49.0777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4263 3.16216) scale(49.0561 49.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4677 3.16609) scale(49.0608 49.0869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.509 3.17033) scale(49.0655 49.0916)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#638CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F72C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5488 3.17426) scale(49.0702 49.0963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F73C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5901 3.17782) scale(49.0749 49.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F73C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6318 3.18174) scale(49.08 49.1061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F73C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6731 3.18599) scale(49.0848 49.1109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7148 3.18992) scale(49.0895 49.1157)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7561 3.19348) scale(49.0943 49.1205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7959 3.19736) scale(49.0992 49.1254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8372 3.20165) scale(49.1041 49.1302)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8785 3.20522) scale(49.1093 49.1354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9202 3.20914) scale(49.1141 49.1403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9615 3.21302) scale(49.1191 49.1453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0032 3.21732) scale(49.124 49.1502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0445 3.22088) scale(49.129 49.1552)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0842 3.22476) scale(49.134 49.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1255 3.22869) scale(49.1394 49.1655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1672 3.23299) scale(49.1444 49.1706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2085 3.23656) scale(49.1494 49.1756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2501 3.24044) scale(49.1545 49.1807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2914 3.24474) scale(49.1596 49.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3327 3.24867) scale(49.1647 49.1909)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3724 3.25218) scale(49.1703 49.1965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4137 3.25612) scale(49.1754 49.2016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4554 3.26042) scale(49.1806 49.2068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4966 3.26398) scale(49.1858 49.212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5383 3.26787) scale(49.1911 49.2173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6790EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5073CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5796 3.2718) scale(49.1963 49.2225)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6193 3.2761) scale(49.2019 49.2281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6606 3.27962) scale(49.2073 49.2335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7022 3.28355) scale(49.2126 49.2388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7435 3.28749) scale(49.2179 49.2441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7848 3.29174) scale(49.2233 49.2496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8264 3.29531) scale(49.2287 49.2549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8677 3.29924) scale(49.2344 49.2607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5173CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9074 3.30318) scale(49.2399 49.2661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9486 3.30743) scale(49.2454 49.2716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9902 3.311) scale(49.2508 49.2771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0315 3.31494) scale(49.2563 49.2826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0731 3.31919) scale(49.2619 49.2881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1144 3.32277) scale(49.2678 49.294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1541 3.3267) scale(49.2733 49.2996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1953 3.33064) scale(49.2789 49.3052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2366 3.33489) scale(49.2846 49.3108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2782 3.33846) scale(49.2902 49.3165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.3195 3.3424) scale(49.2959 49.3221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.3611 3.34629) scale(49.3019 49.3282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4023 3.3506) scale(49.3076 49.3339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5174CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.442 3.35417) scale(49.3133 49.3396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4832 3.35811) scale(49.3191 49.3454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5248 3.362) scale(49.3249 49.3512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5661 3.36631) scale(49.3307 49.357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6077 3.36988) scale(49.3368 49.3631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6489 3.37377) scale(49.3427 49.369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6901 3.37771) scale(49.3486 49.3748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7298 3.38165) scale(49.3544 49.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.771 3.38559) scale(49.3603 49.3866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8126 3.38949) scale(49.3663 49.3926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8539 3.39379) scale(49.3726 49.3989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8954 3.39737) scale(49.3785 49.4049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9366 3.40126) scale(49.3846 49.4109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9763 3.40521) scale(49.3906 49.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0175 3.40951) scale(49.3966 49.4229)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0591 3.41309) scale(49.4027 49.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1003 3.41699) scale(49.4092 49.4355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1415 3.42093) scale(49.4153 49.4416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1831 3.42524) scale(49.4214 49.4477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2243 3.42877) scale(49.4276 49.4539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2639 3.43271) scale(49.4338 49.4601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3051 3.43666) scale(49.4399 49.4663)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5275CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3467 3.44061) scale(49.4465 49.4728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3879 3.4445) scale(49.4528 49.4791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4295 3.44844) scale(49.459 49.4854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4707 3.45239) scale(49.4653 49.4917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5122 3.45629) scale(49.4717 49.4981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5515 3.46024) scale(49.478 49.5044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5927 3.46418) scale(49.4847 49.5111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6891ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6342 3.46849) scale(49.4911 49.5174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6754 3.47203) scale(49.4975 49.5239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.717 3.47597) scale(49.5039 49.5303)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7582 3.47992) scale(49.5104 49.5368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7997 3.48419) scale(49.5169 49.5433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8389 3.48777) scale(49.5237 49.5501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8805 3.49172) scale(49.5302 49.5566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9217 3.49562) scale(49.5368 49.5632)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9632 3.49957) scale(49.5434 49.5698)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0044 3.50352) scale(49.5499 49.5763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0455 3.50746) scale(49.5565 49.5829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0851 3.51137) scale(49.5635 49.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.1263 3.51532) scale(49.5702 49.5966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.1678 3.51927) scale(49.5769 49.6033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5375D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.209 3.52317) scale(49.5836 49.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2505 3.52712) scale(49.5903 49.6167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2917 3.53107) scale(49.5971 49.6235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3332 3.53502) scale(49.6041 49.6306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3724 3.53892) scale(49.611 49.6374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4139 3.54324) scale(49.6178 49.6442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4551 3.54683) scale(49.6246 49.651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4962 3.55073) scale(49.6315 49.6579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5377 3.55469) scale(49.6384 49.6648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5789 3.55864) scale(49.6456 49.6721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6204 3.56259) scale(49.6525 49.679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#648DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5475D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6596 3.5665) scale(49.6595 49.686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7011 3.57045) scale(49.6665 49.6929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7422 3.5744) scale(49.6735 49.6999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7837 3.57831) scale(49.6805 49.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8249 3.58226) scale(49.6879 49.7144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8664 3.58622) scale(49.6949 49.7214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9075 3.59018) scale(49.702 49.7285)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9467 3.59408) scale(49.7092 49.7357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9882 3.59804) scale(49.7163 49.7428)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0293 3.60199) scale(49.7234 49.7499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0708 3.6059) scale(49.731 49.7575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5476D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1119 3.60986) scale(49.7382 49.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1534 3.61381) scale(49.7454 49.7719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1926 3.6174) scale(49.7526 49.7791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2341 3.62168) scale(49.7599 49.7864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2752 3.62564) scale(49.7672 49.7937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3167 3.6296) scale(49.7748 49.8014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3578 3.6335) scale(49.7822 49.8087)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3989 3.63746) scale(49.7896 49.8161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4404 3.64142) scale(49.7969 49.8235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4795 3.64538) scale(49.8043 49.8309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.521 3.64929) scale(49.8118 49.8383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5621 3.65325) scale(49.8196 49.8461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6036 3.65721) scale(49.827 49.8536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6447 3.66112) scale(49.8346 49.8611)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6992ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6862 3.66508) scale(49.8421 49.8686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7273 3.66905) scale(49.8496 49.8762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7668 3.67295) scale(49.8572 49.8838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8078 3.67655) scale(49.8651 49.8917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8489 3.68088) scale(49.8727 49.8993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8904 3.68484) scale(49.8803 49.9069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9315 3.68875) scale(49.888 49.9146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5576D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9729 3.69235) scale(49.8957 49.9223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.014 3.69668) scale(49.9034 49.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0535 3.70059) scale(49.9115 49.9381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0946 3.70455) scale(49.9192 49.9458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.136 3.70852) scale(49.927 49.9536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1771 3.71248) scale(49.9348 49.9614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2182 3.71639) scale(49.9426 49.9692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2596 3.72036) scale(49.9504 49.9771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2987 3.72433) scale(49.9586 49.9852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3402 3.72824) scale(49.9665 49.9932)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3812 3.73221) scale(49.9744 50.0011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4227 3.73581) scale(49.9824 50.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4637 3.74014) scale(49.9903 50.0169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5051 3.74405) scale(49.9983 50.0249)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5462 3.74802) scale(50.0066 50.0333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5857 3.75162) scale(50.0146 50.0413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6267 3.7559) scale(50.0227 50.0494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6678 3.75987) scale(50.0308 50.0574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7092 3.76384) scale(50.0388 50.0655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7502 3.76744) scale(50.0469 50.0736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7917 3.77172) scale(50.0554 50.0821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8327 3.77569) scale(50.0636 50.0903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8722 3.77966) scale(50.0717 50.0984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9132 3.78358) scale(50.08 50.1067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9546 3.78755) scale(50.0882 50.1149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9957 3.79152) scale(50.0964 50.1231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0371 3.79512) scale(50.105 50.1317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0781 3.79941) scale(50.1134 50.1401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.1191 3.80338) scale(50.1217 50.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.1586 3.80735) scale(50.13 50.1567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.1996 3.8109) scale(50.1384 50.1651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.241 3.81524) scale(50.1468 50.1735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.282 3.81921) scale(50.1555 50.1822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3234 3.82318) scale(50.1639 50.1906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3644 3.82674) scale(50.1724 50.1991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5777D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4038 3.83107) scale(50.1809 50.2076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4449 3.83505) scale(50.1893 50.2161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4862 3.83897) scale(50.1979 50.2246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5273 3.84258) scale(50.2068 50.2335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5683 3.84692) scale(50.2153 50.2421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6096 3.85089) scale(50.2239 50.2507)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6507 3.85445) scale(50.2325 50.2593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6901 3.85879) scale(50.2412 50.2679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6A93ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7311 3.86276) scale(50.2498 50.2766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7724 3.86669) scale(50.2588 50.2856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8135 3.87029) scale(50.2675 50.2943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8548 3.87464) scale(50.2763 50.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8958 3.87856) scale(50.285 50.3118)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9352 3.88254) scale(50.2938 50.3206)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9762 3.88615) scale(50.3026 50.3294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0172 3.89049) scale(50.3117 50.3385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0586 3.89441) scale(50.3206 50.3474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0996 3.89839) scale(50.3294 50.3563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1409 3.902) scale(50.3383 50.3651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1819 3.9063) scale(50.3473 50.3741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2213 3.91027) scale(50.3562 50.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2623 3.91389) scale(50.3655 50.3923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3036 3.91786) scale(50.3744 50.4013)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3446 3.92216) scale(50.3834 50.4103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3859 3.92613) scale(50.3924 50.4193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.4269 3.92975) scale(50.4015 50.4283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.4679 3.93405) scale(50.4106 50.4374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5073 3.93802) scale(50.42 50.4469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5482 3.942) scale(50.4291 50.456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5896 3.94561) scale(50.4382 50.4651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5878D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6305 3.94991) scale(50.4474 50.4743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5978D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6718 3.95389) scale(50.4566 50.4834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5978DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7128 3.95787) scale(50.4658 50.4926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5978DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7522 3.96144) scale(50.4754 50.5022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7931 3.96579) scale(50.4846 50.5115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8344 3.96977) scale(50.4938 50.5207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8754 3.97338) scale(50.5031 50.53)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9164 3.97732) scale(50.5125 50.5394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9577 3.98166) scale(50.5218 50.5487)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9986 3.98565) scale(50.5315 50.5584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.038 3.98921) scale(50.5409 50.5678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0789 3.9932) scale(50.5503 50.5772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.1202 3.99754) scale(50.5597 50.5867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.1612 4.00153) scale(50.5692 50.5961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2025 4.0051) scale(50.5787 50.6056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2434 4.00945) scale(50.5885 50.6154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2828 4.01343) scale(50.598 50.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3237 4.01737) scale(50.6076 50.6345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3646 4.02135) scale(50.6171 50.6441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4059 4.02533) scale(50.6267 50.6537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4468 4.02932) scale(50.6363 50.6633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5979DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4881 4.03289) scale(50.6463 50.6733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.529 4.03688) scale(50.6559 50.6829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5684 4.04123) scale(50.6656 50.6926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6093 4.04517) scale(50.6754 50.7023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6506 4.04879) scale(50.6851 50.7121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6915 4.05278) scale(50.6948 50.7218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7328 4.05713) scale(50.7049 50.7319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6B94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7737 4.06107) scale(50.7147 50.7417)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8146 4.06469) scale(50.7245 50.7515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8539 4.06868) scale(50.7343 50.7614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8948 4.07298) scale(50.7442 50.7713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9361 4.07697) scale(50.7541 50.7812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.977 4.08059) scale(50.7643 50.7914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0183 4.08527) scale(50.7743 50.8014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0592 4.08925) scale(50.7842 50.8113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0984 4.09288) scale(50.7942 50.8213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1393 4.09687) scale(50.8042 50.8312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1806 4.10117) scale(50.8142 50.8413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2215 4.10516) scale(50.8246 50.8517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2624 4.10879) scale(50.8346 50.8617)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3036 4.11273) scale(50.8448 50.8719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3445 4.11709) scale(50.8549 50.882)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3838 4.12108) scale(50.865 50.8921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4247 4.12471) scale(50.8751 50.9022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.466 4.12865) scale(50.8857 50.9128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint298_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.5068 4.13301) scale(50.8958 50.923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint299_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.5481 4.137) scale(50.9061 50.9332)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.589 4.14058) scale(50.9163 50.9435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6282 4.14457) scale(50.9266 50.9537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint302_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6691 4.14893) scale(50.9369 50.964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.71 4.15256) scale(50.9475 50.9747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7512 4.1565) scale(50.9579 50.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#6C95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7924 4.16013) scale(50.9682 50.9954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3356 6.28123) rotate(180) scale(36.5017 37.7847)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0458095,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6996,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2274 10.7169) scale(37.2438 37.2636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#5C7CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5B7BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.231 10.7163) scale(37.2407 37.2606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#5D7DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5B7BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2349 10.7156) scale(37.2376 37.2575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#5D7EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5B7CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2381 10.715) scale(37.2346 37.2544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#5E7FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint311_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.242 10.7143) scale(37.2315 37.2513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#5F80E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2475 10.7137) scale(37.2284 37.2482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6081E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2494 10.713) scale(37.2253 37.2451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6181E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2549 10.7124) scale(37.2222 37.2421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6282E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint315_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2585 10.7117) scale(37.2191 37.239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6283E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint316_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.262 10.7111) scale(37.2161 37.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6384E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint317_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2656 10.7104) scale(37.213 37.2328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6485E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5C7EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint318_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2695 10.7098) scale(37.2099 37.2297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6586E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint319_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.273 10.7091) scale(37.2068 37.2267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6687E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint320_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2769 10.7085) scale(37.2038 37.2236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6788E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint321_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2801 10.7078) scale(37.2007 37.2205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6789E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint322_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2837 10.7072) scale(37.1976 37.2174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#688AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2876 10.7065) scale(37.1945 37.2143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#698BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint324_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2911 10.7059) scale(37.1915 37.2113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6A8CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5D7FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint325_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.295 10.7052) scale(37.1884 37.2082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6B8DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E80E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint326_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3002 10.7046) scale(37.1853 37.2051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6C8EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E80E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3041 10.7039) scale(37.1822 37.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6C8EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E80E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3076 10.7033) scale(37.1791 37.1989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6D8FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E80E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3112 10.7026) scale(37.1761 37.1959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6E90E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E81E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint330_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3151 10.702) scale(37.173 37.1928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#6F91E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E81E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint331_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3186 10.7013) scale(37.1699 37.1897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7092E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5E81E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3222 10.7007) scale(37.1668 37.1866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7193E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F81E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3257 10.7) scale(37.1638 37.1836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7194EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F82E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint334_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3296 10.6994) scale(37.1607 37.1805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7295EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F82E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint335_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3332 10.6987) scale(37.1576 37.1774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7396EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F82E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3367 10.6981) scale(37.1545 37.1743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7497EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F82E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint337_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3403 10.6974) scale(37.1515 37.1713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7598EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F83E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint338_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3457 10.6968) scale(37.1484 37.1682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7599EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F83E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint339_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3497 10.6961) scale(37.1453 37.1651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#769AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#5F83E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint340_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3532 10.6955) scale(37.1422 37.162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#779AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6083E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint341_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3571 10.6948) scale(37.1392 37.159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#789BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6084E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint342_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3603 10.6942) scale(37.1361 37.1559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#799CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6084E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint343_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3638 10.6935) scale(37.133 37.1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7A9DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6084E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint344_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3678 10.6929) scale(37.1299 37.1497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7A9EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6084E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint345_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3713 10.6922) scale(37.1269 37.1467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7B9FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6085E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint346_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3752 10.6916) scale(37.1238 37.1436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7CA0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6085E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7BDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint347_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3788 10.6909) scale(37.1207 37.1405)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7DA1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6185E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint348_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3823 10.6903) scale(37.1177 37.1374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7EA2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6185E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint349_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3858 10.6896) scale(37.1146 37.1344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7FA3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6186E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint350_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3894 10.689) scale(37.1115 37.1313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#7FA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6186E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint351_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3933 10.6883) scale(37.1084 37.1282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#80A5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6186E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint352_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3988 10.6877) scale(37.1054 37.1251)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#81A6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6186E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint353_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4024 10.687) scale(37.1023 37.1221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#82A7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6187E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint354_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4059 10.6864) scale(37.0992 37.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#83A7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6287E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint355_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4098 10.6857) scale(37.0962 37.1159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#84A8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6287E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint356_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4133 10.6851) scale(37.0931 37.1129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#84A9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6287E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint357_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4173 10.6844) scale(37.09 37.1098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#85AAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6288E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint358_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4204 10.6838) scale(37.0869 37.1067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#86ABF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6288E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint359_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.424 10.6831) scale(37.0839 37.1036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#87ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6288E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint360_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4279 10.6825) scale(37.0808 37.1006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#88ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6288E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint361_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4314 10.6818) scale(37.0777 37.0975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#88AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6289E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint362_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4354 10.6812) scale(37.0747 37.0944)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#89AFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6389E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint363_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4385 10.6805) scale(37.0716 37.0914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8AB0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6389E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint364_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4425 10.6799) scale(37.0685 37.0883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8BB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#6389E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint365_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4479 10.6792) scale(37.0655 37.0852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8CB2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#638AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint366_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4515 10.6786) scale(37.0624 37.0821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8DB3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#638AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint367_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4554 10.6779) scale(37.0593 37.0791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8DB3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#638AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint368_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4589 10.6773) scale(37.0563 37.076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8EB4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#638AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint369_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4625 10.6766) scale(37.0532 37.0729)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#8FB5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648BE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint370_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.466 10.676) scale(37.0501 37.0699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#90B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648BE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint371_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.47 10.6753) scale(37.0471 37.0668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#91B7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648BE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint372_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4735 10.6747) scale(37.044 37.0637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#92B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint373_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.477 10.674) scale(37.0409 37.0607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#92B9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint374_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4806 10.6734) scale(37.0379 37.0576)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#93BAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint375_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4841 10.6727) scale(37.0348 37.0545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#94BBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#648CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint376_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.488 10.6721) scale(37.0317 37.0515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#95BCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint377_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4916 10.6714) scale(37.0287 37.0484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#96BDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint378_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4955 10.6708) scale(37.0256 37.0453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#97BEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint379_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5006 10.6701) scale(37.0225 37.0423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#97BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint380_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5042 10.6695) scale(37.0195 37.0392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#98C0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint381_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5081 10.6688) scale(37.0164 37.0361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#99C0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint382_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5116 10.6682) scale(37.0134 37.0331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#9AC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint383_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5156 10.6675) scale(37.0103 37.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#9BC2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#658EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint384_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5191 10.6669) scale(37.0072 37.0269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#9CC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#668EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint385_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5226 10.6662) scale(37.0042 37.0239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#9CC4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint386_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5262 10.6656) scale(37.0011 37.0208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#9DC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint387_radial_19952_150379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5297 10.6649) scale(36.998 37.0177)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    stopColor: "#9EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#668FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7ADE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no-orders.55482c424216fd5b51790ef86ddac9a5.svg";
export { ForwardRef as ReactComponent };